import React from "react";
import Quotation from "../components/rect/Quotation";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      version="1.1"
      viewBox="0 0 1920 3981"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            d="M0 0H2558.479V1643.146H0z"
            data-name="Rectángulo 25"
            transform="translate(0 .004)"
          ></path>
        </clipPath>
        <filter
          width="140"
          height="86"
          x="1511"
          y="3598"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="6"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodOpacity="0.161"></feFlood>
          <feComposite in2="blur" operator="in" result="result1"></feComposite>
          <feComposite in="SourceGraphic" in2="result1"></feComposite>
        </filter>
        <clipPath id="clip-path-2">
          <path
            fill="#cee4ea"
            d="M0 0H814.77V813.319H0z"
            data-name="Rectángulo 9"
            transform="translate(556.92 1272.514)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-3">
          <path
            fill="#cee4ea"
            d="M0 0H1018.03V1282.973H0z"
            data-name="Rectángulo 8"
            transform="translate(1545.39 155.78)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-4">
          <path
            fill="#cee4ea"
            d="M0 0H1492.44V1248.009H0z"
            data-name="Rectángulo 12"
          ></path>
        </clipPath>
        <clipPath id="clip-path-5">
          <path
            fill="none"
            d="M0 0H2563.42V2237.51H0z"
            data-name="Rectángulo 15"
          ></path>
        </clipPath>
        <clipPath id="clip-path-6">
          <path
            fill="none"
            d="M0 0H2563.415V2237.509H0z"
            data-name="Rectángulo 14"
            transform="translate(0 .001)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-7">
          <path
            fill="none"
            d="M0 0H1018.03V1282.973H0z"
            data-name="Rectángulo 8"
            transform="translate(1545.39 155.78)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-8">
          <path
            fill="none"
            d="M0 0H814.77V813.319H0z"
            data-name="Rectángulo 9"
            transform="translate(556.92 1272.514)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-9">
          <path
            fill="none"
            d="M0 0H350.632V206.07H0z"
            data-name="Rectángulo 10"
            transform="translate(673.818 633.4)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-10">
          <path
            fill="none"
            d="M0 0H1765.334V1510.67H0z"
            data-name="Rectángulo 11"
            transform="translate(192.236 726.84)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-11">
          <path
            fill="none"
            d="M0 0H1492.44V1248.009H0z"
            data-name="Rectángulo 12"
          ></path>
        </clipPath>
        <clipPath id="clip-path-12">
          <path
            fill="none"
            d="M0 0H241.09V244.315H0z"
            data-name="Rectángulo 13"
            transform="translate(1503.82 1092.03)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-13">
          <path
            fill="none"
            d="M0 0H253.668V87.813H0z"
            data-name="Rectángulo 2"
          ></path>
        </clipPath>
        <filter
          width="1106"
          height="633.51"
          x="407"
          y="625"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="6"></feOffset>
          <feGaussianBlur result="blur-2" stdDeviation="3"></feGaussianBlur>
          <feFlood floodOpacity="0.161"></feFlood>
          <feComposite
            in2="blur-2"
            operator="in"
            result="result1"
          ></feComposite>
          <feComposite in="SourceGraphic" in2="result1"></feComposite>
        </filter>
        <pattern
          id="pattern"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          viewBox="0 0 498 101"
        >
          <image
            width="498"
            height="101"
            xlinkHref="Web%201920%20%E2%80%93%202-image.png"
          ></image>
        </pattern>
        <filter
          width="278"
          height="86"
          x="1235"
          y="84"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="6"></feOffset>
          <feGaussianBlur result="blur-3" stdDeviation="3"></feGaussianBlur>
          <feFlood floodOpacity="0.161"></feFlood>
          <feComposite
            in2="blur-3"
            operator="in"
            result="result1"
          ></feComposite>
          <feComposite in="SourceGraphic" in2="result1"></feComposite>
        </filter>
        <filter
          width="278"
          height="86"
          x="1511"
          y="84"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="6"></feOffset>
          <feGaussianBlur result="blur-4" stdDeviation="3"></feGaussianBlur>
          <feFlood floodOpacity="0.161"></feFlood>
          <feComposite
            in2="blur-4"
            operator="in"
            result="result1"
          ></feComposite>
          <feComposite in="SourceGraphic" in2="result1"></feComposite>
        </filter>
        <clipPath id="clip-path-14">
          <path
            fill="#cee4ea"
            d="M0 0H1332.871V1330.498H0z"
            data-name="Rectángulo 9"
          ></path>
        </clipPath>
        <clipPath id="clip-path-15">
          <path
            fill="#cee4ea"
            d="M0 0H241.09V244.315H0z"
            data-name="Rectángulo 13"
            transform="translate(1503.82 1092.03)"
          ></path>
        </clipPath>
        <clipPath id="clip-path-17">
          <path
            fill="#fff"
            d="M0 0H30.754V30.751H0z"
            data-name="Rectángulo 28"
          ></path>
        </clipPath>
        <clipPath id="clip-Web_1920_2">
          <path d="M0 0H1920V3981H0z"></path>
        </clipPath>
      </defs>
      <g
        clip-path="url(#clip-Web_1920_2)"
        data-name="Web 1920 – 2"
        transform="translate(7.568 -15.137)"
      >
        <path fill="#fff" d="M0 0H1920V3981H0z"></path>
        <g data-name="Grupo 792" transform="translate(-444 3126.423)">
          <g clip-path="url(#clip-path)" data-name="Grupo 791">
            <path
              fill="#3fd86d"
              d="M270.366 1635.888c297.841 81.918 811.307-553.957 1440.543-664.344 525-92.1 577.263 223.323 766.029 56.156 150.118-132.942 209.455-474.075-104.155-673.717C1768.077 59.505-23.231 106.924 27.742 867.082c-87.568 309.4 42.759 713.835 242.624 768.806"
              data-name="Trazado 459"
            ></path>
          </g>
        </g>
        {/* <rect
          width="398"
          height="68"
          x="0"
          y="0"
          fill="#fff"
          data-name="Rectángulo 26"
          opacity="0.55"
          rx="34"
          transform="translate(1106 3601)"
        ></rect> */}
        {/* <g>
          <rect
            width="122"
            height="68"
            x="0"
            y="0"
            fill="#fff"
            data-name="Rectángulo 27"
            rx="34"
            transform="translate(1520 3601)"
          ></rect>
        </g> */}
        <g
          data-name="Grupo 296"
          opacity="0.1"
          transform="rotate(42 1540.14 2322.759)"
        >
          <g data-name="Grupo 12">
            <g clip-path="url(#clip-path-2)" data-name="Grupo 11">
              <path
                fill="#cee4ea"
                d="M751.733 2085.833q-30.579 0-56.07-5.944c-54.975-12.846-94.108-41.424-116.313-84.938-15.129-29.648-22.674-66.9-22.425-110.722.216-38.036 6.328-82.29 18.165-131.532 21.607-89.9 59-184.121 92.723-264.437 44.532-106.049 101.141-171.3 173.062-199.477 72.853-28.546 162.632-19.591 274.475 27.373 62.765 26.356 115.031 57.48 155.346 92.507 41.459 36.02 70.545 76.4 86.452 120.031 26.152 71.727 17 151.787-27.206 237.96-19.086 37.206-56.1 78.891-107.051 120.545-48.579 39.719-107.663 77.818-170.867 110.18-64.856 33.208-130.686 58.573-190.374 73.351-40.631 10.062-77.4 15.1-109.917 15.1m-79.933-595.9l3.987 1.674c-76.7 182.646-147.214 384.812-88.734 499.412 20.994 41.142 58.2 68.208 110.577 80.447 82 19.166 213.01-11.411 350.453-81.784 131.949-67.562 237-154.533 274.165-226.977 43.06-83.941 52.069-161.678 26.776-231.048-30.853-84.619-110.6-154.441-237.022-207.528-109.665-46.05-197.321-54.977-267.972-27.3-69.631 27.283-124.664 90.993-168.243 194.774z"
                data-name="Trazado 9"
              ></path>
            </g>
          </g>
        </g>
        <g
          data-name="Grupo 300"
          opacity="0.1"
          transform="translate(-881.39 606)"
        >
          <g data-name="Grupo 9">
            <g clip-path="url(#clip-path-3)" data-name="Grupo 8">
              <path
                fill="#cee4ea"
                d="M2538.456 536.128c-12.036-73.8-29.006-137.52-50.44-189.388-24.636-59.614-56.074-105.846-93.442-137.41-54.732-46.232-123.924-62.648-205.651-48.786-65.65 11.134-139.772 47.2-220.306 107.2-72.836 54.262-147.993 126.463-217.347 208.8-67.593 80.245-126.288 165.943-169.74 247.83-13.83 26.064-25.9 51.385-36.143 75.74q3.786 1.862 7.507 3.965c41.562-99.324 113.2-213 204.99-321.964 147.5-175.1 309.172-292.13 432.485-313.044a314.993 314.993 0 0152.662-4.63c56.457 0 105.4 17.234 145.962 51.5 69.053 58.328 115.152 163.519 140.927 321.585 21.9 134.261 24.847 283.684 24.847 412.144 0 167.135-38.786 286.065-118.574 363.584-80.933 78.632-206.1 116.857-382.658 116.857q-50.76 0-97-4.134-.166 4.306-.649 8.527 46.755 4.242 97.648 4.254c178.918 0 306.059-39.024 388.685-119.3 81.551-79.234 121.2-200.192 121.2-369.787 0-128.806-2.966-278.665-24.959-413.537"
                data-name="Trazado 8"
              ></path>
            </g>
          </g>
        </g>
        <g data-name="Grupo 298" opacity="0.1" transform="translate(814 1878)">
          <g clip-path="url(#clip-path-4)" data-name="Grupo 20">
            <path
              fill="#cee4ea"
              d="M1389.93 286.106C1156.067 33.657 458.936-75.778 224.98 56.517c-304.153 171.99-284.873 486.356-32.524 851.047 252.349 364.691 492.874 428.316 780.206 229.5 287.332-198.816 718.655-525.615 417.268-850.954M839.888 790.531c-129.967 89.931-238.763 61.152-352.906-103.807S364.117 379.57 501.693 301.775c105.824-59.841 421.153-10.341 526.936 103.849 136.325 147.158-58.773 294.976-188.741 384.907"
              data-name="Trazado 12"
            ></path>
          </g>
        </g>
        <g data-name="Grupo 29" transform="translate(-500 -944)">
          <g clip-path="url(#clip-path-5)" data-name="Grupo 28">
            <g data-name="Grupo 27">
              <g clip-path="url(#clip-path-6)" data-name="Grupo 26">
                <path
                  fill="#3fd86d"
                  d="M2421.415 1861.6s-371.889 140.925-960.268 140.925c-619.459 0-959.2-140.925-959.2-140.925l-.536-1489.371h1919.468z"
                  data-name="Trazado 7"
                ></path>
                <g data-name="Grupo 10" opacity="0.2">
                  <g data-name="Grupo 9">
                    <g clip-path="url(#clip-path-7)" data-name="Grupo 8">
                      <path
                        fill="#fff"
                        d="M2538.456 536.128c-12.036-73.8-29.006-137.52-50.44-189.388-24.636-59.614-56.074-105.846-93.442-137.41-54.732-46.232-123.924-62.648-205.651-48.786-65.65 11.134-139.772 47.2-220.306 107.2-72.836 54.262-147.993 126.463-217.347 208.8-67.593 80.245-126.288 165.943-169.74 247.83-13.83 26.064-25.9 51.385-36.143 75.74q3.786 1.862 7.507 3.965c41.562-99.324 113.2-213 204.99-321.964 147.5-175.1 309.172-292.13 432.485-313.044a314.993 314.993 0 0152.662-4.63c56.457 0 105.4 17.234 145.962 51.5 69.053 58.328 115.152 163.519 140.927 321.585 21.9 134.261 24.847 283.684 24.847 412.144 0 167.135-38.786 286.065-118.574 363.584-80.933 78.632-206.1 116.857-382.658 116.857q-50.76 0-97-4.134-.166 4.306-.649 8.527 46.755 4.242 97.648 4.254c178.918 0 306.059-39.024 388.685-119.3 81.551-79.234 121.2-200.192 121.2-369.787 0-128.806-2.966-278.665-24.959-413.537"
                        data-name="Trazado 8"
                      ></path>
                    </g>
                  </g>
                </g>
                <g data-name="Grupo 13" opacity="0.2">
                  <g data-name="Grupo 12">
                    <g clip-path="url(#clip-path-8)" data-name="Grupo 11">
                      <path
                        fill="#fff"
                        d="M751.733 2085.833q-30.579 0-56.07-5.944c-54.975-12.846-94.108-41.424-116.313-84.938-15.129-29.648-22.674-66.9-22.425-110.722.216-38.036 6.328-82.29 18.165-131.532 21.607-89.9 59-184.121 92.723-264.437 44.532-106.049 101.141-171.3 173.062-199.477 72.853-28.546 162.632-19.591 274.475 27.373 62.765 26.356 115.031 57.48 155.346 92.507 41.459 36.02 70.545 76.4 86.452 120.031 26.152 71.727 17 151.787-27.206 237.96-19.086 37.206-56.1 78.891-107.051 120.545-48.579 39.719-107.663 77.818-170.867 110.18-64.856 33.208-130.686 58.573-190.374 73.351-40.631 10.062-77.4 15.1-109.917 15.1m-79.933-595.9l3.987 1.674c-76.7 182.646-147.214 384.812-88.734 499.412 20.994 41.142 58.2 68.208 110.577 80.447 82 19.166 213.01-11.411 350.453-81.784 131.949-67.562 237-154.533 274.165-226.977 43.06-83.941 52.069-161.678 26.776-231.048-30.853-84.619-110.6-154.441-237.022-207.528-109.665-46.05-197.321-54.977-267.972-27.3-69.631 27.283-124.664 90.993-168.243 194.774z"
                        data-name="Trazado 9"
                      ></path>
                    </g>
                  </g>
                </g>
                <g data-name="Grupo 16" opacity="0.2">
                  <g data-name="Grupo 15">
                    <g clip-path="url(#clip-path-9)" data-name="Grupo 14">
                      <path
                        fill="#fff"
                        d="M683.962 839.466C777.628 734 877.359 671.076 985.933 648.434q14.922-3.111 30.118-5.216a111.114 111.114 0 018.4-9.818c-128.736 15.2-244.095 83.075-350.636 204.493q5.121.61 10.144 1.573"
                        data-name="Trazado 10"
                      ></path>
                    </g>
                  </g>
                </g>
                <g data-name="Grupo 19" opacity="0.2">
                  <g data-name="Grupo 18">
                    <g clip-path="url(#clip-path-10)" data-name="Grupo 17">
                      <path
                        fill="#fff"
                        d="M1949.466 1304.5c-17.237-93.768-62.312-185.548-133.972-272.791-69.864-85.055-165.411-166.33-283.99-241.564q-56.1-35.6-109.386-63.3-2.071 3.813-4.451 7.447 53.123 27.567 109.2 63.154c240.817 152.793 380.137 323.917 414.09 508.617 27.879 151.659-17.676 308.425-135.4 465.942-101.454 135.748-346.843 277.565-640.405 370.108-182.009 57.378-354.537 86.648-498.514 86.645-97.989 0-182.764-13.564-248.256-41.052-103.994-43.648-171.452-112.729-200.5-205.325-37.986-121.077-13.578-280.293 74.621-486.747 45.292-106.019 102.948-213.369 162.768-315.274l-6.9-5.332c-60.171 102.453-118.22 210.472-163.818 317.206-41.05 96.088-68.726 183.957-82.26 261.17-15.532 88.62-13.063 166.529 7.34 231.563 14.474 46.133 38.307 86.915 70.837 121.215 34.515 36.393 79.791 66.5 134.57 89.5 43.587 18.294 95.591 30.75 154.563 37.022a910 910 0 0095.964 4.812c28.633 0 58.456-1.158 89.3-3.472 126.591-9.5 269.367-38.436 412.893-83.681 139.889-44.1 273.352-101.3 385.962-165.407 117.842-67.089 207.324-138.936 258.77-207.772 119.224-159.525 165.309-318.558 136.977-472.682"
                        data-name="Trazado 11"
                      ></path>
                    </g>
                  </g>
                </g>
                <g data-name="Grupo 22" opacity="0.15">
                  <g data-name="Grupo 21">
                    <g clip-path="url(#clip-path-11)" data-name="Grupo 20">
                      <path
                        fill="#fff"
                        d="M1389.93 286.106C1156.067 33.657 458.936-75.778 224.98 56.517c-304.153 171.99-284.873 486.356-32.524 851.047 252.349 364.691 492.874 428.316 780.206 229.5 287.332-198.816 718.655-525.615 417.268-850.954M839.888 790.531c-129.967 89.931-238.763 61.152-352.906-103.807S364.117 379.57 501.693 301.775c105.824-59.841 421.153-10.341 526.936 103.849 136.325 147.158-58.773 294.976-188.741 384.907"
                        data-name="Trazado 12"
                      ></path>
                    </g>
                  </g>
                </g>
                <g data-name="Grupo 25" opacity="0.2">
                  <g data-name="Grupo 24">
                    <g clip-path="url(#clip-path-12)" data-name="Grupo 23">
                      <path
                        fill="#fff"
                        d="M1623.6 1336.345c-66.027 0-119.772-56.017-119.772-122.931 0-66.914 53.745-121.386 119.772-121.386 66.027 0 121.312 54.472 121.312 121.386 0 66.914-55.28 122.931-121.312 122.931"
                        data-name="Trazado 13"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <text
          fill="#fff"
          data-name="Estás a un click de ahorrar."
          fontFamily="Nunito-Bold, Nunito"
          fontSize="100"
          fontWeight="700"
          transform="translate(960 408)"
        >
          <tspan x="-614.3" y="0">
            Estás a un click de ahorrar.
          </tspan>
        </text>
        <text
          fill="#1f4049"
          data-name="Todas nuestras operaciones se encuentran reguladas."
          fontFamily="Nunito-Bold, Nunito"
          fontSize="50"
          fontWeight="700"
          transform="translate(278 2903)"
        >
          <tspan x="68.8" y="51">
            Todas nuestras operaciones se encuentran reguladas.
          </tspan>
        </text>
        <g data-name="Grupo 2" transform="translate(146.332 80)">
          <g
            clip-path="url(#clip-path-13)"
            data-name="Grupo 1"
            transform="translate(0 -3)"
          >
            <path
              fill="#ef2d56"
              d="M150.947 15.418a7.7 7.7 0 01-7.547-7.75 7.613 7.613 0 017.547-7.654 7.7 7.7 0 017.653 7.654 7.78 7.78 0 01-7.649 7.751"
              data-name="Trazado 1"
              transform="translate(-82.01 -.008)"
            ></path>
            <path
              fill="#fff"
              d="M24.592 71.82C11.231 71.82 0 60.734 0 44.839V0h4.454c5.035 0 8.52 2.943 8.52 9.124v15.4c2.614-3.827 7.068-8.045 14.135-8.045 13.265 0 23.431 10.989 23.431 26.589 0 15.9-10.069 28.747-25.948 28.747m0-43.661c-6.583 0-11.521 6.574-11.521 14.815 0 12.166 5.131 17.171 12.877 17.171 6.487 0 11.134-6.28 11.134-14.816 0-12.853-4.551-17.17-12.49-17.17"
              data-name="Trazado 2"
              transform="translate(0 -.001)"
            ></path>
            <path
              fill="#fff"
              d="M161.7 96.3c-10.069 0-15.588-5.788-15.588-16.484V44.007h3.679c5.809 0 9.294 3.139 9.294 9.811v24.725c0 5.3 2.227 6.966 7.939 6.966h2.421v2.846c0 5.69-2.227 7.947-7.746 7.947"
              data-name="Trazado 3"
              transform="translate(-83.563 -25.168)"
            ></path>
            <path
              fill="#fff"
              d="M236.226 71.82c-13.748 0-24.3-12.166-24.3-26.687 0-17.367 8.327-28.649 23.527-28.649 5.228 0 10.941 3.728 12.974 8.339V0h3.97c6.2 0 8.907 3.63 8.907 8.928v37.285c0 15.4-7.165 25.607-25.076 25.607m-.678-44.249c-6.583 0-10.844 6.475-10.844 15.011 0 10.989 5.616 18.152 13.071 18.152 7.261 0 10.456-5.5 10.456-15.11 0-13.246-5.712-18.053-12.683-18.053"
              data-name="Trazado 4"
              transform="translate(-121.203 -.001)"
            ></path>
            <path
              fill="#fff"
              d="M375.322 71.82c-13.748 0-24.3-12.166-24.3-26.687 0-17.367 8.327-28.649 23.527-28.649 5.229 0 10.941 3.728 12.974 8.339V0h3.97c6.2 0 8.907 3.63 8.907 8.928v37.285c0 15.4-7.164 25.607-25.076 25.607m-.678-44.249c-6.583 0-10.844 6.475-10.844 15.011 0 10.989 5.616 18.152 13.071 18.152 7.261 0 10.456-5.5 10.456-15.11 0-13.246-5.712-18.053-12.683-18.053"
              data-name="Trazado 5"
              transform="translate(-200.755 -.001)"
            ></path>
            <path
              fill="#fff"
              d="M494.369 111.408c-4.841 0-9.1-3.238-9.1-8.143v-2.551l7.358-.491c4.744-.294 6.39-2.256 9.2-9.713-6.874-10.5-16.75-36.794-18.492-49.255h6.874a7.605 7.605 0 017.552 6.181 114.894 114.894 0 0010.456 30.514c4.26-9.91 9-25.9 10.166-36.7H524c4.164 0 6.1 1.865 6.1 6.181 0 5.593-9.1 29.729-11.521 35.42-9.681 23.155-14.813 28.552-24.2 28.552"
              data-name="Trazado 6"
              transform="translate(-276.427 -23.595)"
            ></path>
          </g>
        </g>
        <text
          fill="#fff"
          data-name="La mejor cotización del mercado, al alcance de tu mano."
          fontFamily="OpenSans-Regular, 'Open Sans'"
          fontSize="42"
          transform="translate(278 491)"
        >
          <tspan x="134.77" y="45">
            La mejor cotización del mercado, al alcance de tu mano.
          </tspan>
        </text>
        <g data-name="Grupo 3" transform="translate(138 -12)">
          <g transform="translate(-138 12)">
            <rect
              width="1088"
              height="615.51"
              x="0"
              y="0"
              fill="#fff"
              data-name="Rectángulo 4"
              rx="60"
              transform="translate(416 628)"
            ></rect>
          </g>
          <g
            fill="#fff"
            stroke="#3fd86d"
            strokeWidth="1"
            data-name="Rectángulo 24"
            transform="translate(692 878)"
          >
            <rect
              width="260"
              height="154"
              x="0"
              y="0"
              stroke="none"
              rx="29"
            ></rect>
            <rect
              width="259"
              height="153"
              x="0.5"
              y="0.5"
              fill="none"
              rx="28.5"
            ></rect>
          </g>
          {/* <g fill="#efefef" data-name="Grupo 37">
            <rect
              width="260"
              height="154"
              x="0"
              y="0"
              data-name="Rectángulo 21"
              rx="29"
              transform="translate(416 878)"
            ></rect>
            <rect
              width="812"
              height="233.574"
              x="0"
              y="0"
              data-name="Rectángulo 22"
              rx="31"
              transform="translate(416 941)"
            ></rect>
          </g>
          <text
            fill="#1f4049"
            data-name="Voy a comprar"
            fontFamily="OpenSans-Regular, 'Open Sans'"
            fontSize="30"
            transform="translate(456 1017.359)"
            className="hover"

          >
            <tspan x="0" y="0">
              Voy a comprar
            </tspan>
          </text>
          <text
            fill="#1f4049"
            data-name="Tengo que pagar"
            fontFamily="OpenSans-Regular, 'Open Sans'"
            fontSize="30"
            transform="translate(456 1097.431)"
          >
            <tspan x="0" y="0">
              Tengo que pagar
            </tspan>
          </text>
          <text
            fill="#1f4049"
            data-name="COMPRA USD: $68,00"
            fontFamily="Nunito-Medium, Nunito"
            fontSize="28"
            fontWeight="500"
            transform="translate(603.5 800.278)"
          >
            <tspan x="-151.84" y="0" xmlSpace="preserve">
              COMPRA USD: $68,00
            </tspan>
          </text>
          <text
            fill="#1f4049"
            data-name="VENTA USD: $64,00"
            fontFamily="Nunito-Medium, Nunito"
            fontSize="28"
            fontWeight="500"
            transform="translate(1055.5 800.278)"
          >
            <tspan x="-136.671" y="0" xmlSpace="preserve">
              VENTA USD: $64,00
            </tspan>
          </text>
          <text
            fill="#ff6339"
            data-name="Quiero comprar"
            fontFamily="Nunito-Bold, Nunito"
            fontSize="28"
            fontWeight="700"
            transform="translate(546 920.833)"
          >
            <tspan x="-100.842" y="0">
              Quiero comprar
            </tspan>
          </text>
          <text
            fill="#ff6339"
            data-name="Quiero vender"
            fontFamily="Nunito-Bold, Nunito"
            fontSize="28"
            fontWeight="700"
            transform="translate(822 920.833)"
            className="hover"

          >
            <tspan x="-91.154" y="0">
              Quiero vender
            </tspan>
          </text>
          <text
            fill="#1f4049"
            fontFamily="Nunito-Bold, Nunito"
            fontSize="30"
            fontWeight="700"
            transform="translate(1112 1033.843)"
          >
            <tspan x="-72.15" y="0">
              Cotización
            </tspan>
          </text>
          <input style={{width: '100%', zIndex: 1000 }} /> */}
          <g
            fill="#fff"
            stroke="#3fd86d"
            strokeWidth="1"
            data-name="Rectángulo 6"
            transform="translate(731 985.66)"
          >
          
            {/* <rect
              width="259.475"
              height="46"
              x="0"
              y="0"
              stroke="none"
              rx="23"
            ></rect>
            <rect
              width="258.475"
              height="45"
              x="0.5"
              y="0.5"
              fill="none"
              rx="22.5"
            ></rect> */}
          </g>
          <g
            fill="#fff"
            stroke="#3fd86d"
            strokeWidth="1"
            data-name="Rectángulo 7"
            transform="translate(731 1065.287)"
          >
            <rect
              width="259.475"
              height="46"
              x="0"
              y="0"
              stroke="none"
              rx="23"
            ></rect>
            <rect
              width="258.475"
              height="45"
              x="0.5"
              y="0.5"
              fill="none"
              rx="22.5"
            ></rect>
          </g>
          {/* <text
            fill="#1f4049"
            data-name="SIMULADOR DE OPERACIONES"
            fontFamily="Nunito-Bold, Nunito"
            fontSize="30"
            fontWeight="700"
            transform="translate(596.5 722)"
          >
            <tspan x="0" y="0">
              SIMULADOR DE OPERACIONES
            </tspan>
          </text>
          <text
            fill="#1f4049"
            data-name="$68,00"
            fontFamily="Nunito-Medium, Nunito"
            fontSize="50"
            fontWeight="500"
            transform="translate(1112 1094.111)"
          >
            <tspan x="-80.981" y="0">
              $68,00
            </tspan>
          </text>
          <path
            fill="none"
            stroke="#1f4049"
            strokeWidth="1"
            d="M0 0L812 0"
            data-name="Línea 1"
            transform="translate(416 758)"
          ></path>
          
          <text
            fill="#1f4049"
            data-name="Ej: USD$20"
            fontFamily="OpenSans-Regular, 'Open Sans'"
            fontSize="20"
            opacity="0.42"
            transform="translate(861 1016)"
          >
            <tspan x="-50.562" y="0">
              Ej: USD$20
            </tspan>
          </text> */}
        </g>
        <g data-name="Grupo 294" transform="translate(0 36)">
          <g data-name="Grupo 4" transform="translate(0 33)">
            <g transform="translate(284 1372.5)">
              <g data-name="user-check" transform="translate(1 2.5)">
                <path
                  fill="#b052e2"
                  d="M73.743 39.149l6.479 6.479 12.957-12.957a4.581 4.581 0 016.479 6.479l-16.2 16.2a4.58 4.58 0 01-6.479 0l-9.718-9.718a4.581 4.581 0 116.479-6.479zm-36.094 9.163a22.906 22.906 0 1122.906-22.906 22.906 22.906 0 01-22.906 22.906zm0-9.162a13.744 13.744 0 10-13.743-13.744 13.743 13.743 0 0013.743 13.743zM1 80.38v-9.162a18.325 18.325 0 0118.325-18.325h36.649A18.325 18.325 0 0174.3 71.218v9.162a9.162 9.162 0 01-9.162 9.162H10.162A9.162 9.162 0 011 80.38zm9.162 0h54.974v-9.162a9.162 9.162 0 00-9.162-9.162H19.325a9.162 9.162 0 00-9.162 9.162z"
                  transform="translate(-1 -2.5)"
                ></path>
              </g>
            </g>
            <text
              fill="#1f4049"
              fontFamily="Nunito-Medium, Nunito"
              fontSize="40"
              fontWeight="500"
              transform="translate(140 1511)"
            >
              <tspan x="105.387" y="39">
                Registrate
              </tspan>
            </text>
            <text
              fill="#1f4049"
              data-name="Crea tu perfil, cargá tus datos y prepárate para empezar a operar."
              fontFamily="OpenSans-Regular, 'Open Sans'"
              fontSize="30"
              transform="translate(140 1569)"
            >
              <tspan x="36.666" y="32">
                Crea tu perfil, cargá tus
              </tspan>
              <tspan x="39.266" y="64">
                datos y prepárate para
              </tspan>
              <tspan x="70.16" y="96">
                empezar a operar.
              </tspan>
            </text>
          </g>
          <g data-name="Grupo 5" transform="translate(0 33)">
            <g transform="translate(689.497 1366.509)">
              <g data-name="rotate" transform="translate(1.503 1.491)">
                <path
                  fill="#06afbe"
                  d="M18.73 75.309a40.5 40.5 0 0073.246-23.791 4.764 4.764 0 019.527.006 50.042 50.042 0 01-88.134 32.363v5.7a4.763 4.763 0 01-9.527 0V75.309a9.521 9.521 0 019.527-9.516H27.66a4.758 4.758 0 110 9.516zm65.584-47.578a40.506 40.506 0 00-73.285 23.027 4.765 4.765 0 01-9.529-.172 50.045 50.045 0 0188.08-31.547v-5.581a4.763 4.763 0 019.527 0v14.273a9.521 9.521 0 01-9.527 9.516H75.294a4.761 4.761 0 01-4.763-4.758c-.001-2.627 2.132-4.758 13.783-4.758z"
                  data-name="shape"
                  transform="translate(-1.503 -1.491)"
                ></path>
              </g>
            </g>
            <text
              fill="#1f4049"
              fontFamily="Nunito-Medium, Nunito"
              fontSize="40"
              fontWeight="500"
              transform="translate(554 1513)"
            >
              <tspan x="143.238" y="39">
                Operá
              </tspan>
            </text>
            <text
              fill="#1f4049"
              data-name="Elegí la operación que querés realizar y revizá la cotización"
              fontFamily="OpenSans-Regular, 'Open Sans'"
              fontSize="30"
              transform="translate(554 1571)"
            >
              <tspan x="45.462" y="32">
                Elegí la operación que
              </tspan>
              <tspan x="22.054" y="64">
                querés realizar y revizá la
              </tspan>
              <tspan x="129.149" y="96">
                cotización
              </tspan>
            </text>
          </g>
          <g data-name="Grupo 6" transform="translate(51 33)">
            <g transform="translate(1064 1368)">
              <g data-name="calender-check" transform="translate(2 2)">
                <path
                  fill="#ff6339"
                  d="M11.524 37h76.19v-5a9.771 9.771 0 00-9.524-10h-4.761v5a4.768 4.768 0 11-9.529 0v-5H35.333v5a4.768 4.768 0 11-9.524 0v-5h-4.761a9.771 9.771 0 00-9.524 10zm76.19 10h-76.19v35a9.771 9.771 0 009.524 10h28.571a5.006 5.006 0 010 10H21.048C10.528 102 2 93.046 2 82V32c0-11.046 8.528-20 19.048-20h4.762V7a4.768 4.768 0 119.524 0v5H63.9V7a4.768 4.768 0 119.524 0v5h4.762c10.52 0 19.048 8.954 19.048 20v20a4.768 4.768 0 11-9.524 0zM66.933 74.5l10.1 10.606 16.838-17.677a4.6 4.6 0 016.734 0 5.179 5.179 0 010 7.071L80.4 95.713a4.6 4.6 0 01-6.734 0L60.2 81.571a5.179 5.179 0 010-7.071 4.6 4.6 0 016.733 0z"
                  data-name="shape"
                  transform="translate(-2 -2)"
                ></path>
              </g>
            </g>
            <text
              fill="#1f4049"
              fontFamily="Nunito-Medium, Nunito"
              fontSize="40"
              fontWeight="500"
              transform="translate(917 1513)"
            >
              <tspan x="126.217" y="39">
                Reservá
              </tspan>
            </text>
            <text
              fill="#1f4049"
              data-name="Congelá el precio haciendo una reserva."
              fontFamily="OpenSans-Regular, 'Open Sans'"
              fontSize="30"
              transform="translate(917 1571)"
            >
              <tspan x="10.519" y="32">
                Congelá el precio haciendo
              </tspan>
              <tspan x="112.267" y="64">
                una reserva.
              </tspan>
            </text>
          </g>
          <g data-name="Grupo 7" transform="translate(47 33)">
            <g transform="translate(1473 1366)">
              <g data-name="donate" transform="translate(0 2)">
                <path
                  fill="#a1e44d"
                  d="M10.317 45.848v36.11h10.317v-36.11zm74.618 10.317h5.7A25.793 25.793 0 1046.55 35.576a20.635 20.635 0 0113.216 6l4.273 4.273h3.022a20.626 20.626 0 0117.874 10.316zM87.7 66.482v5.158a5.158 5.158 0 01-5.163 5.16H51.585a5.159 5.159 0 010-10.317h25.793a10.317 10.317 0 00-10.317-10.318H61.9a5.159 5.159 0 01-3.648-1.511l-5.781-5.784a10.317 10.317 0 00-7.3-3.022h-14.22v37.377l28.214 8.061a10.314 10.314 0 005.549.033l48.775-13.3V76.8a10.317 10.317 0 00-10.317-10.317zM25.07 92.275H5.159A5.158 5.158 0 010 87.116V40.689a5.159 5.159 0 015.159-5.159H36.2a36.111 36.111 0 1167.3 20.637A20.634 20.634 0 01123.805 76.8v5.159a5.159 5.159 0 01-3.8 4.977l-52.577 14.337a20.637 20.637 0 01-11.1-.067z"
                  transform="translate(0 -2)"
                ></path>
              </g>
              <text
                fill="#a1e44d"
                data-name="$"
                fontFamily="Nunito-Medium, Nunito"
                fontSize="42"
                fontWeight="500"
                transform="translate(72.186 51.617)"
              >
                <tspan x="-12.479" y="0">
                  $
                </tspan>
              </text>
            </g>
            <text
              fill="#1f4049"
              fontFamily="Nunito-Medium, Nunito"
              fontSize="40"
              fontWeight="500"
              transform="translate(1335 1513)"
            >
              <tspan x="143.941" y="39">
                Recibí
              </tspan>
            </text>
            <text
              fill="#1f4049"
              data-name="Transferimos tu dinero a tu cuenta bancaria, o podes retirarlo por una sucursal."
              fontFamily="OpenSans-Regular, 'Open Sans'"
              fontSize="30"
              transform="translate(1335 1571)"
            >
              <tspan x="7.567" y="32">
                Transferimos tu dinero a tu
              </tspan>
              <tspan x="23.468" y="64">
                cuenta bancaria, o podes
              </tspan>
              <tspan x="16.993" y="96">
                retirarlo por una sucursal.
              </tspan>
            </text>
          </g>
        </g>
        {/* <path
          fill="url(#pattern)"
          d="M0 0H812V165H0z"
          data-name="Imagen 1"
          transform="translate(554 3032)"
        ></path> */}
        <g>
          <rect
            width="260"
            height="68"
            x="0"
            y="0"
            fill="#fff"
            data-name="Rectángulo 16"
            rx="34"
            transform="translate(1244 87)"
  
          ></rect>
        </g>
        <g>
          <rect
            width="260"
            height="68"
            x="0"
            y="0"
            fill="#fff"
            data-name="Rectángulo 17"
            rx="34"
            transform="translate(1520 87)"
          ></rect>
        </g>
        <text
          fill="#ff6339"
          fontFamily="Nunito-Bold, Nunito"
          fontSize="35"
          fontWeight="700"
          transform="translate(1374 133)"
          className="hover"
          onClick={() => {
            window.location.href = "http://24.232.220.141:5000/Account/Login"
          }}
        >
          <tspan x="-66.202" y="0">
            Ingresar
          </tspan>
        </text>
        <text
          fill="#ff6339"
          fontFamily="Nunito-Bold, Nunito"
          fontSize="35"
          fontWeight="700"
          transform="translate(1650 133)"
          className="hover"
          onClick={() => {
            window.location.href = 'http://24.232.220.141:5000/Account/Register'
          }}
        >
          <tspan x="-91.858" y="0">
            Registrarse
          </tspan>
        </text>
        <g transform="translate(912.559 612.163)">
          <g transform="translate(440.441 581.955)">
            <g data-name="Grupo 39" transform="translate(23.812 93.392)">
              <g data-name="Grupo 38">
                <path
                  fill="#161616"
                  d="M570.215 1111.769H601.7a.886.886 0 000-1.769h-31.485a.886.886 0 000 1.769z"
                  data-name="Trazado 25"
                  transform="translate(-569.375 -1110)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 41" transform="translate(162.153 92.331)">
              <g data-name="Grupo 40">
                <path
                  fill="#161616"
                  d="M804.884 1109.969h23.349a.886.886 0 000-1.769h-23.349a.884.884 0 000 1.769z"
                  data-name="Trazado 26"
                  transform="translate(-804 -1108.2)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 43" transform="translate(196.867 91.27)">
              <g data-name="Grupo 42">
                <path
                  fill="#161616"
                  d="M863.715 1108.169h13.561a.886.886 0 000-1.769h-13.561a.886.886 0 000 1.769z"
                  data-name="Trazado 27"
                  transform="translate(-862.875 -1106.4)"
                ></path>
              </g>
            </g>
            <path
              fill="#a1e44d"
              stroke="#161616"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M142.164 22.343H30.195a7.1 7.1 0 01-7.076-7.076v-3.656a7.1 7.1 0 017.076-7.076h111.97a7.1 7.1 0 017.076 7.076v3.656a7.1 7.1 0 01-7.077 7.076z"
              data-name="Trazado 28"
            ></path>
            <path
              fill="#a1e44d"
              stroke="#161616"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M153.132 41.093H41.161a7.1 7.1 0 01-7.076-7.076v-3.656a7.1 7.1 0 017.076-7.076h111.97a7.1 7.1 0 017.076 7.076v3.656a7.1 7.1 0 01-7.075 7.076z"
              data-name="Trazado 29"
            ></path>
            <path
              fill="#a1e44d"
              stroke="#161616"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M127.306 59.371H15.336a7.1 7.1 0 01-7.076-7.075V48.64a7.1 7.1 0 017.076-7.075h111.97a7.1 7.1 0 017.076 7.075v3.656a7.1 7.1 0 01-7.076 7.075z"
              data-name="Trazado 30"
            ></path>
            <path
              fill="#a1e44d"
              stroke="#161616"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M140.986 76.588H29.074a7.1 7.1 0 01-7.076-7.075v-3.656a7.1 7.1 0 017.076-7.076h111.97a7.1 7.1 0 017.076 7.076v3.656a7.186 7.186 0 01-7.134 7.075z"
              data-name="Trazado 31"
            ></path>
            <path
              fill="#a1e44d"
              stroke="#161616"
              strokeMiterlimit="10"
              strokeWidth="2"
              d="M153.132 94.395H41.161a7.1 7.1 0 01-7.076-7.075v-3.656a7.1 7.1 0 017.076-7.075h111.97a7.1 7.1 0 017.076 7.075v3.656a7.1 7.1 0 01-7.075 7.075z"
              data-name="Trazado 32"
            ></path>
            <g data-name="Grupo 45" transform="translate(109.44 11.538)">
              <g data-name="Grupo 44">
                <path
                  fill="#161616"
                  d="M714.6 971.838v7.311a.679.679 0 001.356 0v-7.311a.678.678 0 00-1.356 0z"
                  data-name="Trazado 33"
                  transform="translate(-714.6 -971.175)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 47" transform="translate(113.391 12.879)">
              <g data-name="Grupo 46">
                <path
                  fill="#161616"
                  d="M721.3 974.069v6.663a.679.679 0 001.356 0v-6.663a.681.681 0 00-1.356 0z"
                  data-name="Trazado 34"
                  transform="translate(-721.3 -973.45)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 49" transform="translate(126.716 9.223)">
              <g data-name="Grupo 48">
                <path
                  fill="#161616"
                  d="M743.9 967.869v9.316a.679.679 0 001.356 0v-9.316a.681.681 0 00-1.356 0z"
                  data-name="Trazado 35"
                  transform="translate(-743.9 -967.25)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 51" transform="translate(129.37 14.53)">
              <g data-name="Grupo 50">
                <path
                  fill="#161616"
                  d="M748.4 976.869v3.656a.679.679 0 001.356 0v-3.656a.681.681 0 00-1.356 0z"
                  data-name="Trazado 36"
                  transform="translate(-748.4 -976.25)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 53" transform="translate(37.86 8.943)">
              <g data-name="Grupo 52">
                <path
                  fill="#161616"
                  d="M593.2 967.438v10.318a.679.679 0 001.356 0v-10.318a.678.678 0 00-1.356 0z"
                  data-name="Trazado 37"
                  transform="translate(-593.2 -966.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 55" transform="translate(32.376 11.582)">
              <g data-name="Grupo 54">
                <path
                  fill="#161616"
                  d="M583.9 971.869v6.073a.679.679 0 001.356 0v-6.073a.681.681 0 00-1.356 0z"
                  data-name="Trazado 38"
                  transform="translate(-583.9 -971.25)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 57" transform="translate(54.428 9.356)">
              <g data-name="Grupo 56">
                <path
                  fill="#161616"
                  d="M621.3 968.138v8.255a.679.679 0 001.356 0v-8.255a.678.678 0 00-1.356 0z"
                  data-name="Trazado 39"
                  transform="translate(-621.3 -967.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 59" transform="translate(48.355 14.191)">
              <g data-name="Grupo 58">
                <path
                  fill="#161616"
                  d="M611 976.338v5.484a.679.679 0 001.356 0v-5.484a.678.678 0 00-1.356 0z"
                  data-name="Trazado 40"
                  transform="translate(-611 -975.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 61" transform="translate(79.251 9.577)">
              <g data-name="Grupo 60">
                <path
                  fill="#161616"
                  d="M663.4 968.469V979.2a.679.679 0 001.356 0v-10.731a.681.681 0 00-1.356 0z"
                  data-name="Trazado 41"
                  transform="translate(-663.4 -967.85)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 63" transform="translate(83.32 13.601)">
              <g data-name="Grupo 62">
                <path
                  fill="#161616"
                  d="M670.3 975.338v5.484a.679.679 0 001.356 0v-5.484a.678.678 0 00-1.356 0z"
                  data-name="Trazado 42"
                  transform="translate(-670.3 -974.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 65" transform="translate(89.334 8.752)">
              <g data-name="Grupo 64">
                <path
                  fill="#161616"
                  d="M680.5 967.069V977.8a.679.679 0 001.356 0v-10.731a.681.681 0 00-1.356 0z"
                  data-name="Trazado 43"
                  transform="translate(-680.5 -966.45)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 67" transform="translate(49.947 26.735)">
              <g data-name="Grupo 66">
                <path
                  fill="#161616"
                  d="M613.7 997.569v12.731a.679.679 0 001.356 0v-12.731a.681.681 0 00-1.356 0z"
                  data-name="Trazado 44"
                  transform="translate(-613.7 -996.95)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 69" transform="translate(57.258 30.981)">
              <g data-name="Grupo 68">
                <path
                  fill="#161616"
                  d="M626.1 1004.769v9.08a.679.679 0 001.356 0v-9.08c-.059-.826-1.356-.826-1.356 0z"
                  data-name="Trazado 45"
                  transform="translate(-626.1 -1004.15)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 71" transform="translate(80.902 28.563)">
              <g data-name="Grupo 70">
                <path
                  fill="#161616"
                  d="M666.2 1000.669v9.08a.679.679 0 001.356 0v-9.08c-.059-.825-1.356-.825-1.356 0z"
                  data-name="Trazado 46"
                  transform="translate(-666.2 -1000.05)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 73" transform="translate(96.233 25.32)">
              <g data-name="Grupo 72">
                <path
                  fill="#161616"
                  d="M692.2 995.169v14.741a.679.679 0 001.356 0v-14.741c-.059-.825-1.356-.825-1.356 0z"
                  data-name="Trazado 47"
                  transform="translate(-692.2 -994.55)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 75" transform="translate(110.148 31.172)">
              <g data-name="Grupo 74">
                <path
                  fill="#161616"
                  d="M715.8 1005.138v4.835a.679.679 0 001.356 0v-4.835a.678.678 0 00-1.356 0z"
                  data-name="Trazado 48"
                  transform="translate(-715.8 -1004.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 77" transform="translate(22.058 45.913)">
              <g data-name="Grupo 76">
                <path
                  fill="#161616"
                  d="M566.4 1030.138v11.734a.679.679 0 001.356 0v-11.734a.678.678 0 00-1.356 0z"
                  data-name="Trazado 49"
                  transform="translate(-566.4 -1029.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 79" transform="translate(53.19 46.326)">
              <g data-name="Grupo 78">
                <path
                  fill="#161616"
                  d="M619.2 1030.838v12.146a.679.679 0 001.356 0v-12.146a.678.678 0 00-1.356 0z"
                  data-name="Trazado 50"
                  transform="translate(-619.2 -1030.175)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 81" transform="translate(40.277 47.328)">
              <g data-name="Grupo 80">
                <path
                  fill="#161616"
                  d="M597.3 1032.538v8.078a.679.679 0 001.356 0v-8.078a.678.678 0 00-1.356 0z"
                  data-name="Trazado 51"
                  transform="translate(-597.3 -1031.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 83" transform="translate(44.699 44.719)">
              <g data-name="Grupo 82">
                <path
                  fill="#161616"
                  d="M604.8 1028.069v6.663a.679.679 0 001.356 0v-6.663a.681.681 0 00-1.356 0z"
                  data-name="Trazado 52"
                  transform="translate(-604.8 -1027.45)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 85" transform="translate(87.565 44.91)">
              <g data-name="Grupo 84">
                <path
                  fill="#161616"
                  d="M677.5 1028.438v12.323a.679.679 0 001.356 0v-12.323a.678.678 0 00-1.356 0z"
                  data-name="Trazado 53"
                  transform="translate(-677.5 -1027.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 87" transform="translate(76.421 44.719)">
              <g data-name="Grupo 86">
                <path
                  fill="#161616"
                  d="M658.6 1028.069v3.007a.679.679 0 001.356 0v-3.007a.681.681 0 00-1.356 0z"
                  data-name="Trazado 54"
                  transform="translate(-658.6 -1027.45)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 89" transform="translate(113.98 41.078)">
              <g data-name="Grupo 88">
                <path
                  fill="#161616"
                  d="M722.3 1021.938v11.734a.679.679 0 001.356 0v-11.734a.678.678 0 00-1.356 0z"
                  data-name="Trazado 55"
                  transform="translate(-722.3 -1021.275)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 91" transform="translate(119.877 49.554)">
              <g data-name="Grupo 90">
                <path
                  fill="#161616"
                  d="M732.3 1036.269v7.076a.679.679 0 001.356 0v-7.076c-.059-.825-1.356-.825-1.356 0z"
                  data-name="Trazado 56"
                  transform="translate(-732.3 -1035.65)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 93" transform="translate(98.65 44.719)">
              <g data-name="Grupo 92">
                <path
                  fill="#161616"
                  d="M696.3 1028.069v10.318a.679.679 0 001.356 0v-10.318a.681.681 0 00-1.356 0z"
                  data-name="Trazado 57"
                  transform="translate(-696.3 -1027.45)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 95" transform="translate(33.379 60.064)">
              <g data-name="Grupo 94">
                <path
                  fill="#161616"
                  d="M585.6 1054.138v13.149a.679.679 0 001.356 0v-13.149a.678.678 0 00-1.356 0z"
                  data-name="Trazado 58"
                  transform="translate(-585.6 -1053.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 97" transform="translate(42.282 62.444)">
              <g data-name="Grupo 96">
                <path
                  fill="#161616"
                  d="M602.056 1071.3v-13.149a.679.679 0 00-1.356 0v13.149a.678.678 0 001.356 0z"
                  data-name="Trazado 59"
                  transform="translate(-600.7 -1057.512)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 99" transform="translate(46.527 70.168)">
              <g data-name="Grupo 98">
                <path
                  fill="#161616"
                  d="M609.256 1076.324v-5.071a.679.679 0 00-1.356 0v5.071a.681.681 0 001.356 0z"
                  data-name="Trazado 60"
                  transform="translate(-607.9 -1070.612)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 101" transform="translate(57.258 59.061)">
              <g data-name="Grupo 100">
                <path
                  fill="#161616"
                  d="M626.1 1052.438v13.738a.679.679 0 001.356 0v-13.738a.678.678 0 00-1.356 0z"
                  data-name="Trazado 61"
                  transform="translate(-626.1 -1051.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 103" transform="translate(60.678 65.533)">
              <g data-name="Grupo 102">
                <path
                  fill="#161616"
                  d="M631.9 1063.369v6.486a.679.679 0 001.356 0v-6.486c-.059-.825-1.356-.825-1.356 0z"
                  data-name="Trazado 62"
                  transform="translate(-631.9 -1062.75)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 105" transform="translate(65.336 63.115)">
              <g data-name="Grupo 104">
                <path
                  fill="#161616"
                  d="M639.8 1059.269v7.076a.679.679 0 001.356 0v-7.076c-.059-.825-1.356-.825-1.356 0z"
                  data-name="Trazado 63"
                  transform="translate(-639.8 -1058.65)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 107" transform="translate(80.49 59.061)">
              <g data-name="Grupo 106">
                <path
                  fill="#161616"
                  d="M665.5 1052.438v14.328a.679.679 0 001.356 0v-14.328a.678.678 0 00-1.356 0z"
                  data-name="Trazado 64"
                  transform="translate(-665.5 -1051.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 109" transform="translate(95.82 64.309)">
              <g data-name="Grupo 108">
                <path
                  fill="#161616"
                  d="M691.5 1061.338v7.9a.679.679 0 001.356 0v-7.9a.678.678 0 00-1.356 0z"
                  data-name="Trazado 65"
                  transform="translate(-691.5 -1060.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 111" transform="translate(116.811 58.649)">
              <g data-name="Grupo 110">
                <path
                  fill="#161616"
                  d="M727.1 1051.738v15.153a.679.679 0 001.356 0v-15.153a.678.678 0 00-1.356 0z"
                  data-name="Trazado 66"
                  transform="translate(-727.1 -1051.075)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 113" transform="translate(123.297 66.122)">
              <g data-name="Grupo 112">
                <path
                  fill="#161616"
                  d="M738.1 1064.369v7.252a.679.679 0 001.356 0v-7.252a.681.681 0 00-1.356 0z"
                  data-name="Trazado 67"
                  transform="translate(-738.1 -1063.75)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 115" transform="translate(134.44 59.459)">
              <g data-name="Grupo 114">
                <path
                  fill="#161616"
                  d="M757 1053.069v11.321a.679.679 0 001.356 0v-11.321c-.059-.825-1.356-.825-1.356 0z"
                  data-name="Trazado 68"
                  transform="translate(-757 -1052.45)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 117" transform="translate(48.532 80.074)">
              <g data-name="Grupo 116">
                <path
                  fill="#161616"
                  d="M612.656 1101.2v-13.149a.679.679 0 00-1.356 0v13.149a.681.681 0 001.356 0z"
                  data-name="Trazado 69"
                  transform="translate(-611.3 -1087.412)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 119" transform="translate(53.367 86.324)">
              <g data-name="Grupo 118">
                <path
                  fill="#161616"
                  d="M620.856 1105.316v-6.663a.679.679 0 00-1.356 0v6.663a.678.678 0 001.356 0z"
                  data-name="Trazado 70"
                  transform="translate(-619.5 -1098.012)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 121" transform="translate(68.343 77.635)">
              <g data-name="Grupo 120">
                <path
                  fill="#161616"
                  d="M644.9 1083.938v15.153a.679.679 0 001.356 0v-15.153a.678.678 0 00-1.356 0z"
                  data-name="Trazado 71"
                  transform="translate(-644.9 -1083.275)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 123" transform="translate(80.49 80.052)">
              <g data-name="Grupo 122">
                <path
                  fill="#161616"
                  d="M665.5 1088.038v9.316a.679.679 0 001.356 0v-9.316a.678.678 0 00-1.356 0z"
                  data-name="Trazado 72"
                  transform="translate(-665.5 -1087.375)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 125" transform="translate(76.244 81.88)">
              <g data-name="Grupo 124">
                <path
                  fill="#161616"
                  d="M658.3 1091.138v3.656a.679.679 0 001.356 0v-3.656a.678.678 0 00-1.356 0z"
                  data-name="Trazado 73"
                  transform="translate(-658.3 -1090.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 127" transform="translate(102.483 76.22)">
              <g data-name="Grupo 126">
                <path
                  fill="#161616"
                  d="M702.8 1081.538v15.743a.679.679 0 001.356 0v-15.743a.678.678 0 00-1.356 0z"
                  data-name="Trazado 74"
                  transform="translate(-702.8 -1080.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 129" transform="translate(107.554 83.103)">
              <g data-name="Grupo 128">
                <path
                  fill="#161616"
                  d="M711.4 1093.169v7.075a.679.679 0 001.356 0v-7.075c-.059-.826-1.356-.826-1.356 0z"
                  data-name="Trazado 75"
                  transform="translate(-711.4 -1092.55)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 131" transform="translate(120.466 77.03)">
              <g data-name="Grupo 130">
                <path
                  fill="#161616"
                  d="M733.3 1082.869v14.741a.679.679 0 001.356 0v-14.741a.681.681 0 00-1.356 0z"
                  data-name="Trazado 76"
                  transform="translate(-733.3 -1082.25)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 133" transform="translate(143.933 78.269)">
              <g data-name="Grupo 132">
                <path
                  fill="#161616"
                  d="M773.1 1084.969v12.736a.679.679 0 001.356 0v-12.736c-.059-.826-1.356-.826-1.356 0z"
                  data-name="Trazado 77"
                  transform="translate(-773.1 -1084.35)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 135" transform="translate(147.53 83.708)">
              <g data-name="Grupo 134">
                <path
                  fill="#161616"
                  d="M779.2 1094.238v6.073a.679.679 0 001.356 0v-6.073a.678.678 0 00-1.356 0z"
                  data-name="Trazado 78"
                  transform="translate(-779.2 -1093.575)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 137" transform="translate(131.08 29.661)">
              <g data-name="Grupo 136">
                <path
                  fill="#161616"
                  d="M752.656 1011.988v-9.434a.679.679 0 00-1.356 0v9.434c.059.826 1.356.884 1.356 0z"
                  data-name="Trazado 79"
                  transform="translate(-751.3 -1001.912)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 139" transform="translate(140.573 25.828)">
              <g data-name="Grupo 138">
                <path
                  fill="#161616"
                  d="M767.4 996.054v12.677a.679.679 0 001.356 0v-12.677c-.059-.826-1.356-.885-1.356 0z"
                  data-name="Trazado 80"
                  transform="translate(-767.4 -995.412)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 141" transform="translate(146.375)">
              <g data-name="Grupo 140">
                <path
                  fill="#161616"
                  d="M777.57 952.841a9.6 9.6 0 014.717 9.139c-.059.825 1.238.825 1.356 0a10.754 10.754 0 00-5.366-10.26.663.663 0 10-.708 1.12z"
                  data-name="Trazado 81"
                  transform="translate(-777.24 -951.607)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 143" transform="translate(10.228 44.711)">
              <g data-name="Grupo 142">
                <path
                  fill="#161616"
                  d="M547.789 1027.769a9.606 9.606 0 00-.826 8.491c.295.767 1.592.472 1.3-.354a8.418 8.418 0 01.708-7.488.674.674 0 00-1.179-.649z"
                  data-name="Trazado 82"
                  transform="translate(-546.337 -1027.437)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 145" transform="translate(0 38.162)">
              <g data-name="Grupo 144">
                <path
                  fill="#161616"
                  d="M534.008 1016.548a22.836 22.836 0 00-5.008 14.917.679.679 0 001.356 0 21.663 21.663 0 014.658-14.033c.472-.59-.472-1.533-1-.884z"
                  data-name="Trazado 83"
                  transform="translate(-528.99 -1016.329)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 147" transform="translate(145.785 55.979)">
              <g data-name="Grupo 146">
                <path
                  fill="#161616"
                  d="M776.57 1047.758a7.053 7.053 0 013.833 6.309.679.679 0 001.356 0 8.316 8.316 0 00-4.481-7.429c-.767-.413-1.474.708-.708 1.12z"
                  data-name="Trazado 84"
                  transform="translate(-776.24 -1046.548)"
                ></path>
              </g>
            </g>
            <path
              fill="#3d3d3d"
              d="M667.191 960.46c3.6-.472 12.028-1.061 20.047 3.774a27.5 27.5 0 015.542 4.363c-.177 2.712-.413 5.425-.59 8.137-8.668.354-17.276.708-25.944 1 1.179.059 10.613.59 15.743 8.255a17.59 17.59 0 012.889 8.726 23.2 23.2 0 01-4.658 11.026 23.732 23.732 0 01-11.321 7.842 14.137 14.137 0 016.958 8.432 13.871 13.871 0 010 7.252q-8.579 9.287-17.158 18.632l78.774.884a9.712 9.712 0 004.068-4.068 10.5 10.5 0 00-1.179-11.026c-4.127-5.248-13.5-3.42-14.564-3.184.295-.177 5.071-3.774 4.658-9.611a10.931 10.931 0 00-3.774-7.252c-4.186-.295-8.314-.59-12.5-.884a11.017 11.017 0 002.889-8.727 10.765 10.765 0 00-6.663-8.432c5.6-.059 10.436-.177 14.269-.295 11.144-.295 13.679-.472 15.684-2.594 2.712-2.948 3.6-8.667.884-12.205a8.412 8.412 0 00-4.658-2.889c-4.363-.177-8.727-.413-13.09-.59a8.553 8.553 0 006.132-2.3c2.3-2.359 2.123-5.484 2.064-6.958-.059-.943-.413-4.835-3.184-7.252-2.889-2.535-6.6-1.828-13.385-1.474-5.307.295-10.672-.236-15.979 0-11.082.474-22.285 1.005-31.954 1.418z"
              data-name="Trazado 85"
              opacity="0.15"
              transform="translate(-582.22 -954.509)"
            ></path>
          </g>
          <g transform="translate(488.105 330.982)">
            <path
              fill="#1f4049"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              d="M38.899 201.616c1.828 9.611 3.6 19.281 5.425 28.892C13.899 241.534-.9 249.14.043 253.385q1.681 7.695 71.7.59-3.007-30.071-6.014-60.2c-8.964 2.652-17.927 5.247-26.83 7.841z"
              data-name="Trazado 146"
            ></path>
            <path
              fill="#fff"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              d="M181.293 81.156c-12.736 5.248-18.1 3.951-34.2 8.373-29.658 8.137-51.121 23.349-64.505 34.847l1.946 65.8c-1.356 1.592-16.215 18.455-38.738 16.156-15.507-1.592-25.177-11.38-27.771-14.21-.413-20.224-.059-41.8 1.3-64.505.826-13.149 1.887-25.885 3.243-38.09 2-2.83 5.071-6.9 9.021-11.616C62.603 41 99.75 24.611 119.974 16 140.139 7.391 152.757 2.026 171.566.493c5.012-.413 55.13-3.951 63.208 16.156 7.487 18.339-22.053 51.59-53.481 64.507z"
              data-name="Trazado 147"
            ></path>
            <path
              fill="#3d3d3d"
              d="M872.945 542.906c-11.2-7.724-35.908 25.177-85.083 56.191-47.288 29.776-72.052 29.3-86.321 58.255-4.363 8.785-8.9 22.7-11.675 36.852a169.113 169.113 0 00-2.653 43.809 63.109 63.109 0 0013.267-2 64.687 64.687 0 0025.236-13.267c-.649-22.347-1.356-44.694-2-66.982a184.573 184.573 0 0139.151-24.528c33.2-15.389 45.637-8.785 73-24.528 6.309-3.6 41.981-24.175 41.156-51.062-.246-4.308-.305-10.146-4.078-12.74z"
              data-name="Trazado 148"
              opacity="0.16"
              transform="translate(-641.415 -532.446)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M902.29 561.562c-2.476-2-12.087 11.439-35.142 27.889-28.656 20.4-42.453 20.165-74 39.151A286.186 286.186 0 00747.1 663.1a156.152 156.152 0 0015.92-7.96c13.561-7.9 16.863-12.736 27.182-17.925 3.715-1.828 10.672-3.715 24.528-7.311 24.234-6.309 27.712-6.014 36.5-9.965a89.094 89.094 0 0023.231-15.271c19.22-16.868 30.954-40.63 27.829-43.106z"
              data-name="Trazado 149"
              opacity="0.25"
              transform="translate(-666.161 -540.489)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M732.483 735q-11.321 40.773-22.583 81.6a56.541 56.541 0 0011.969-4.658 53.934 53.934 0 0013.915-10.613c-1.12-22.107-2.184-44.218-3.301-66.329z"
              data-name="Trazado 150"
              opacity="0.2"
              transform="translate(-650.895 -611.745)"
            ></path>
          </g>
          <g transform="translate(636.626 319.626)">
            <path
              fill="#1f4049"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              d="M82.184 305.073c1.828 9.611 3.6 19.281 5.425 28.892-27.536 13.856-40.625 22.465-39.446 25.826q2.211 6.1 66.628-10.554c-1.946-17.335-3.833-34.67-5.778-52.005a4725.56 4725.56 0 01-26.829 7.841z"
              data-name="Trazado 151"
            ></path>
            <path
              fill="#fff"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              d="M105.768 5.42a820.262 820.262 0 016.014 69.222c1.946 45.224-.884 70.4-1.356 103.833a707.425 707.425 0 009.314 123.178 60.551 60.551 0 01-58.609 4.658c-1.3-25.118-3.6-51.828-7.311-79.894a1001.57 1001.57 0 00-28.6-139.093c-7.076-9.788-14.21-19.517-21.286-29.3q38.65-27.329 77.241-54.6c8.143.704 16.339 1.352 24.593 1.996z"
              data-name="Trazado 152"
            ></path>
            <g data-name="Grupo 269">
              <g data-name="Grupo 268">
                <path
                  fill="#fff"
                  d="M875.387 569.79c-1.828-2.535-3.6-5.13-5.425-7.665-.531 2-1.061 4.009-1.592 6.073 8.727-5.425 17.276-11.144 25.472-17.394 6.84-5.189 13.208-10.908 20.106-15.979 4.363-3.243 8.844-6.309 13.326-9.375 4.3-2.889 8.668-6.545 13.385-8.844 2.535-1.238 5.543-1.061 8.255-1.061 5.189 0 10.318.177 15.448.472 5.66.295 5.66-8.55 0-8.844-5.13-.236-10.318-.472-15.448-.472-3.3 0-6.722 0-9.847 1-4.894 1.592-9.316 5.425-13.5 8.314-4.835 3.243-9.611 6.486-14.328 9.906-7.311 5.307-14.033 11.262-21.168 16.745a314.271 314.271 0 01-26.12 17.866c-1.887 1.179-3.007 4.068-1.592 6.073 1.828 2.535 3.6 5.13 5.425 7.665 3.243 4.6 10.908.177 7.606-4.481z"
                  data-name="Trazado 153"
                  transform="translate(-861.718 -506.7)"
                ></path>
              </g>
            </g>
            <path
              fill="#3d3d3d"
              d="M941.7 526.053a727.62 727.62 0 0135.849 297.172 34.682 34.682 0 0010.613 2c13.267.354 22.819-7.311 25.885-9.965a506.571 506.571 0 01-7.96-56.368c-4.363-51.592 1.12-80.838 2-124.706a613.678 613.678 0 00-7.96-110.791l-58.427 2.658z"
              data-name="Trazado 154"
              opacity="0.14"
              transform="translate(-894.541 -513.553)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M1033.02 569.6q-2.477 87.117-8.609 179.128-3.184 47.494-7.311 93.515a29.667 29.667 0 0027.182-9.257 588.1 588.1 0 01-8.609-90.213c-.648-39.387 3.066-59.493 2-105.484-.703-29.245-2.943-52.948-4.653-67.689z"
              data-name="Trazado 155"
              opacity="0.2"
              transform="translate(-925.483 -532.513)"
            ></path>
          </g>
          <g transform="translate(464.158 108.089)">
            <path
              fill="#fff"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              d="M38.848 9.059c.766-1.769-6.781-5.425-6.014-7.488.767-2.123 10.142-2.653 16.451 2 6.6 4.835 6.191 11.91 9.965 20.991 4.3 10.2 11.085 15.743 21.4 24.234 6.191 5.13 30.366 24.352 65.213 23.29a94.862 94.862 0 0038.8-9.788c-1.356 16.922-2.771 33.9-4.127 50.826a103.344 103.344 0 01-31.958 2.3c-46.934-4.068-77.064-40.271-86.38-51.415a160.834 160.834 0 01-20.46-31.427 62.853 62.853 0 01-24.47 2.482c-7.311-.708-16.038-2.948-15.979-5.012.059-2.712 15.094-4.54 14.977-5.484-.118-.825-11.969 2.417-14.977-2-2.359-3.479.943-11.321 6.486-14.5 1.71-.943 3.656-1.533 8.491-1.474 13.089-.012 21.875 4.057 22.582 2.465z"
              data-name="Trazado 156"
            ></path>
            <g data-name="Grupo 271" transform="translate(0 17.285)">
              <g data-name="Grupo 270">
                <path
                  fill="#1f4049"
                  d="M570.326 179.166c3.007-.708 6.486.767 9.552.884a33.737 33.737 0 008.078-.649c1.12-.236.649-1.946-.472-1.71a30.812 30.812 0 01-10.142.354c-2.594-.354-4.894-1.179-7.488-.59-1.12.236-.649 1.946.472 1.71z"
                  data-name="Trazado 157"
                  transform="translate(-569.214 -177.25)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 273" transform="translate(2.463 11.362)">
              <g data-name="Grupo 272">
                <path
                  fill="#1f4049"
                  d="M574.517 169.207c3.538-.708 6.663.767 10.083.943a29.06 29.06 0 008.962-1.179.887.887 0 00-.472-1.71 24.479 24.479 0 01-11.5.649c-2.653-.531-4.894-1-7.606-.472-1.061.295-.59 2 .531 1.769z"
                  data-name="Trazado 158"
                  transform="translate(-573.391 -167.205)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 275" transform="translate(35.954 13.622)">
              <g data-name="Grupo 274">
                <path
                  fill="#1f4049"
                  d="M630.433 172.549a14.966 14.966 0 0011.439 4.717c1.12-.059 1.12-1.828 0-1.769a12.677 12.677 0 01-10.142-4.186.9.9 0 00-1.3 1.238z"
                  data-name="Trazado 159"
                  transform="translate(-630.192 -171.038)"
                ></path>
              </g>
            </g>
            <path
              fill="#3d3d3d"
              d="M571.4 184.426c.177-1.592 13.031-2 24.823-.295 6.368.884 12.559 1.769 18.4 4.54 12.736 5.955 16.922 17.335 23.526 27.771 0 0 14.8 23.172 41.274 36.144 26.3 12.854 56.309 4.245 73.232-2.594l-1.955 25.472a106.226 106.226 0 01-36.144 1.3c-44.635-6.309-72.642-40.625-83.786-54.246a170.909 170.909 0 01-18.691-28.066 55.8 55.8 0 01-24.823 3.243c-7.134-.767-15.566-3.125-15.507-5.189.118-2.653 14.328-4.245 14.21-4.835-.059-.295-4.068.59-9.021-.649-1.938-.474-5.597-1.712-5.538-2.596z"
              data-name="Trazado 160"
              opacity="0.18"
              transform="translate(-570.11 -162.336)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M743.51 289.4c21.05.295 37.323-7.96 45.814-13.208-.295 7.547-.649 15.035-.943 22.583a118.387 118.387 0 01-55.484-3.892c-42.276-13.5-63.031-47.111-68.4-56.486 1.713 3.069 29.484 50.357 79.013 51.003z"
              data-name="Trazado 161"
              opacity="0.24"
              transform="translate(-608.317 -185.06)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M591.446 200.608c12.618.059 21.109-1.828 21.285-.943.118.708-5.13 2.83-10.672 3.892-16.1 3.066-30.837-3.6-30.661-4.54.178-.649 6.782 1.532 20.048 1.591z"
              data-name="Trazado 162"
              opacity="0.19"
              transform="translate(-570.11 -168.848)"
            ></path>
          </g>
          <g transform="translate(477.063 54.707)">
            <circle
              cx="16.627"
              cy="16.627"
              r="16.627"
              fill="#06afbe"
              data-name="Elipse 2"
              transform="translate(5.601 3.538)"
            ></circle>
            <ellipse
              cx="18.868"
              cy="18.927"
              fill="none"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="2"
              data-name="Elipse 3"
              rx="18.868"
              ry="18.927"
            ></ellipse>
            <g data-name="Grupo 277" transform="translate(10.961 8.539)">
              <g data-name="Grupo 276">
                <path
                  fill="#1f4049"
                  d="M620.191 71.892c-3.715-.236-13.267 3.361-9.729 8.726 2.064 3.125 6.073 1.061 8.962 1.828 3.715 1 3.3 5.484 1 7.665a5.935 5.935 0 01-8.137-.177c-.826-.767-2.123.472-1.238 1.238 4.661 4.246 12.975 1.828 12.975-5.072a5.354 5.354 0 00-5.071-5.484c-2.182-.295-8.314 1.356-6.9-3.125.943-3.066 5.484-4.009 8.2-3.833 1.12.059 1.12-1.71-.059-1.769z"
                  data-name="Trazado 163"
                  transform="translate(-609.69 -71.881)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 279" transform="translate(17.683 2.757)">
              <g data-name="Grupo 278">
                <path
                  fill="#1f4049"
                  d="M622.865 68.694c.177-1.946.354-3.833.531-5.778.118-1.12-1.651-1.12-1.769 0-.177 1.946-.354 3.833-.531 5.778-.118 1.12 1.651 1.12 1.769 0z"
                  data-name="Trazado 164"
                  transform="translate(-621.09 -62.075)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 281" transform="translate(18.273 29.643)">
              <g data-name="Grupo 280">
                <path
                  fill="#1f4049"
                  d="M622.1 108.515c.177 1.356.354 2.771.472 4.127.118 1.12 1.887 1.12 1.769 0a98.132 98.132 0 01-.472-4.127c-.118-1.12-1.887-1.12-1.769 0z"
                  data-name="Trazado 165"
                  transform="translate(-622.09 -107.675)"
                ></path>
              </g>
            </g>
          </g>
          <g transform="translate(627.393 157.281)">
            <path
              fill="#06afbe"
              d="M885.293 240.289a89.562 89.562 0 00-16.863 2.476 81.1 81.1 0 00-10.731 3.42 111.747 111.747 0 00-10.909 36.085c-2.712 22.347 2.712 36.734 6.427 58.963a245.442 245.442 0 011.769 65.331 85.622 85.622 0 0045.519 21.58c33.727 4.717 58.491-13.09 63.621-16.922 3.125-19.34 6.073-39.21 8.727-59.552 4.54-34.434 7.96-67.748 10.5-99.765-16.333-15.389-30.484-19.517-40.448-20.342-19.169-1.652-36.505 7.547-57.612 8.726z"
              data-name="Trazado 166"
              transform="translate(-846.058 -231.365)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M949.128 255.716a87.6 87.6 0 0113.149 17.276c21.521 37.382 8.2 81.015 2.241 100.354A187.344 187.344 0 01937.1 428.24a82.564 82.564 0 0021.816.766 85.328 85.328 0 0042.1-16.568c5.543-31.486 10.26-64.977 13.915-100.354a1459.278 1459.278 0 004.894-60.5 66.553 66.553 0 00-10.554-8.255c-7.606-4.894-19.576-12.5-33.078-10.142-17.218 2.953-25.944 20.17-27.065 22.529z"
              data-name="Trazado 167"
              opacity="0.17"
              transform="translate(-883.419 -231.933)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M1023.45 287.6c-3.007 8.432-7.665 21.875-12.382 38.738-14.033 49.47-13.031 70.7-30.071 96.227a119.109 119.109 0 01-28.6 29.717 96.96 96.96 0 0054.54-17.276c4.6-24.646 8.667-51.239 11.675-79.717 2.421-23.703 4.013-46.345 4.838-67.689z"
              data-name="Trazado 168"
              opacity="0.11"
              transform="translate(-889.698 -254.442)"
            ></path>
          </g>
          <g transform="translate(724.145 167.089)">
            <path
              fill="#fff"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              d="M9.641 136.852c-1.238-2.3.059-5.719 2-7.547 3.6-3.42 10.142-2.123 13.09 1.592.413.531 2.417 3.007 1.592 5.13-1.764 4.304-14.144 5.424-16.682.825z"
              data-name="Trazado 169"
            ></path>
            <path
              fill="#fff"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              d="M26.268.708a154 154 0 0153.833 65.684 156.806 156.806 0 018.314 24.941 126.176 126.176 0 01-33.255 45.519 121.127 121.127 0 01-18.986 13.443 104.869 104.869 0 01-13.267 12.441c-3.774 3.007-8.9 7.017-10.083 6.014-.943-.825.708-4.894 3.243-7.724 3.007-3.3 6.722-4.3 6.663-4.481-.059-.181-3.361.413-6.427 2.771-3.538 2.771-3.361 5.366-5.13 5.778-3.715.884-12.264-8.078-10.967-17.158 1.061-7.606 8.55-11.675 11.085-13.09a26 26 0 0116.215-2.771c8.844-13.738 17.689-27.418 26.533-41.156a99.592 99.592 0 01-9.08-8.314c-4.068-4.186-15.507-16.1-20.991-32.429-7.369-21.932-.589-42.157 2.3-49.468z"
              data-name="Trazado 170"
            ></path>
            <g data-name="Grupo 283" transform="translate(0 143.072)">
              <g data-name="Grupo 282">
                <path
                  fill="#1f4049"
                  d="M1011.771 503a20.946 20.946 0 0110.731-10.731c1.061-.472.118-2-.884-1.533a22.32 22.32 0 00-11.38 11.38c-.472 1 1.061 1.887 1.533.884z"
                  data-name="Trazado 171"
                  transform="translate(-1010.149 -490.649)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 285" transform="translate(5.947 148.158)">
              <g data-name="Grupo 284">
                <path
                  fill="#1f4049"
                  d="M1022.4 514.738c-1.828-5.542 3.538-11.262 7.96-13.8a.885.885 0 00-.885-1.533c-5.13 2.948-10.908 9.434-8.785 15.8.354 1.061 2.064.59 1.71-.472z"
                  data-name="Trazado 172"
                  transform="translate(-1020.235 -499.275)"
                ></path>
              </g>
            </g>
            <path
              fill="#3d3d3d"
              d="M1039.549 258.436a330.725 330.725 0 0127.713 32.547c14.976 19.988 22.406 30.012 22.936 40.566.943 19.576-13.738 44.045-33.078 53.361-5.6 2.712-20.165 8.2-28.538 18.927-2.417 3.066-4.894 7.311-4.009 8.255.766.767 3.6-1.238 4.54-.295 1.12 1.12-1.592 4.54-.825 5.307.943.943 6.191-2.417 11.5-6.663a103.462 103.462 0 0012.028-11.5 120.077 120.077 0 0017.63-12.264 127.846 127.846 0 0035.2-47.76 168.386 168.386 0 00-6.663-20.283 161.067 161.067 0 00-27.183-45.044 151.082 151.082 0 00-28.539-25.59c-.943 3.479-1.828 6.958-2.712 10.436z"
              data-name="Trazado 173"
              opacity="0.18"
              transform="translate(-1015.993 -248)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M1099.419 410.1c-5.66 7.311-8.55 11.969-10.908 15.448-4.481 6.486-11.144 12.677-24.528 25.059a616.76 616.76 0 01-19.222 17.1c-8.373 7.252-12.441 10.967-12.264 11.2q.354.442 24.293-18.4a116.42 116.42 0 0012.028-8.019c27.477-21.05 39.8-51.3 38.679-52.005-.472-.227-3.007 3.017-8.078 9.617z"
              data-name="Trazado 174"
              opacity="0.21"
              transform="translate(-1019.317 -310.574)"
            ></path>
          </g>
          <g transform="translate(623.791 50.837)">
            <path
              fill="#fff"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              d="M30.514 18.67c-17.335 14.21-16.627 43.043-9.847 61.675a66.447 66.447 0 0015.743 24.352l-2.83 20.519a56.852 56.852 0 0020.991 5.13c23 1.12 39.446-12.323 43.927-16.215q-6.1-20.431-12.205-40.92c-.531-3.833-1.415-9.729-2.358-16.922-2.535-18.75-2.417-19.752-3.538-22.819-.472-1.238-7.547-19.222-24-22.406-13.265-2.477-24.229 6.25-25.883 7.606z"
              data-name="Trazado 175"
            ></path>
            <path
              fill="#1f4049"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              d="M16.248 66.665a51.808 51.808 0 00-1.356 17.571c.472 4.953 1.3 13.561 7.488 21.875a39.117 39.117 0 0019.458 13.62 22.077 22.077 0 01-.825-3.715 18.092 18.092 0 010-4.009c4.068 2.241 8.2 4.422 12.264 6.663 10.318-9.493 13.738-18.219 14.918-24.528.943-4.953 1.533-14.033 3.715-30.661.413-2.948 1.179-8.255 4.54-9.611a5.122 5.122 0 015.071.825c4.068 3.42-.059 13.326.825 13.62.884.294 8.019-9.67 5.6-21.05a24.248 24.248 0 00-6.663-11.969q-6.722 10.613-14.918 21.875c-3.479 4.776-6.958 9.257-10.377 13.62a9.936 9.936 0 01-5.484 1.3c-1.769-.177-2.358-.767-3.656-1.12-4.835-1.356-7.429 4.363-12.205 3.6-3.892-.649-4.245-4.835-8.55-4.953-2.064-.059-2.889.884-5.012.472a9.928 9.928 0 01-4.833-3.425z"
              data-name="Trazado 176"
            ></path>
            <g data-name="Grupo 287" transform="translate(33.458 49.279)">
              <g data-name="Grupo 286">
                <path
                  fill="#1f4049"
                  d="M899.528 135.054a136.443 136.443 0 00-2.83 20.7.9.9 0 001.356.767c2.417-1.238 4.894-2.535 7.311-3.774 1-.531.118-2.064-.884-1.533-2.417 1.238-4.894 2.535-7.311 3.774.472.236.884.531 1.356.767a129.347 129.347 0 012.771-20.224c.177-1.12-1.533-1.592-1.769-.472z"
                  data-name="Trazado 177"
                  transform="translate(-896.695 -134.414)"
                ></path>
              </g>
            </g>
            <ellipse
              cx="1.356"
              cy="3.42"
              fill="#1f4049"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              data-name="Elipse 4"
              rx="1.356"
              ry="3.42"
              transform="translate(25.501 50.156)"
            ></ellipse>
            <ellipse
              cx="1.828"
              cy="3.42"
              fill="#1f4049"
              stroke="#1f4049"
              strokeMiterlimit="10"
              strokeWidth="3"
              data-name="Elipse 5"
              rx="1.828"
              ry="3.42"
              transform="translate(47.907 50.156)"
            ></ellipse>
            <g data-name="Grupo 289" transform="translate(21.913 43.674)">
              <g data-name="Grupo 288">
                <path
                  fill="#1f4049"
                  d="M878.756 128.146c1.12-2.064 3.6-1.592 5.425-.943 1.061.354 1.533-1.356.472-1.71-2.594-.943-5.9-1-7.429 1.769-.531.943 1 1.887 1.533.884z"
                  data-name="Trazado 178"
                  transform="translate(-877.113 -124.907)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 291" transform="translate(44.333 40.953)">
              <g data-name="Grupo 290">
                <path
                  fill="#1f4049"
                  d="M916.649 123.835a6.137 6.137 0 019.375.767c.649.884 2.182 0 1.533-.884a7.964 7.964 0 00-12.146-1.12c-.826.767.413 2 1.238 1.238z"
                  data-name="Trazado 179"
                  transform="translate(-915.138 -120.293)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 293" transform="translate(0 30.753)">
              <g data-name="Grupo 292">
                <path
                  fill="#1f4049"
                  d="M842.515 108.3q37.235 2.211 74.234 6.25c3.361.354 3.361-4.953 0-5.307q-37.058-4.068-74.234-6.25c-3.42-.177-3.42 5.13 0 5.307z"
                  data-name="Trazado 180"
                  transform="translate(-839.95 -102.993)"
                ></path>
              </g>
            </g>
            <path
              fill="#ef2d56"
              d="M871.5 83.244c.413-3.833 1.946-13.679 9.493-21.7 9.847-10.436 28.066-14.8 42.217-5.955 11.085 6.958 17.04 20.4 15.035 34.08Q904.9 86.487 871.5 83.244z"
              data-name="Trazado 181"
              transform="translate(-852.897 -50.837)"
            ></path>
            <path
              fill="#ef2d56"
              d="M922.965 53.219c-2.889 2.417-2.889 7.547-1.887 12.972 1.12 5.955 4.009 13.208 8.314 20.7 9.67 1.12 19.34 2.3 29.01 3.42a30.541 30.541 0 00.472-8.844 35.352 35.352 0 00-4.186-12.795c-7.076-12.151-25.588-20.641-31.723-15.453z"
              data-name="Trazado 182"
              opacity="0.69"
              transform="translate(-872.995 -51.177)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M965.759 166.776a7.6 7.6 0 01-5.13.708 48.572 48.572 0 01-9.729 58.255 74.01 74.01 0 0012.913-3.892 72.72 72.72 0 0020.224-12.441L969.886 159.7c0 .295-.236 5.012-4.127 7.076z"
              data-name="Trazado 183"
              opacity="0.24"
              transform="translate(-885.481 -95.511)"
            ></path>
            <path
              fill="#3d3d3d"
              d="M934.093 119.3a36.011 36.011 0 01.59 12.854A37.858 37.858 0 01926.9 150.2c1.356-.413 2.712-.884 4.068-1.3 2.712-3.3 5.484-6.84 8.2-10.436a375.356 375.356 0 0012.382-17.512c-5.841-.532-11.619-1.121-17.457-1.652z"
              data-name="Trazado 184"
              opacity="0.19"
              transform="translate(-875.632 -78.932)"
            ></path>
          </g>
        </g>
        <g
          data-name="Grupo 297"
          opacity="0.1"
          transform="rotate(42 770.854 1062.31)"
        >
          <g data-name="Grupo 12" transform="translate(556.92 1272.514)">
            <g clip-path="url(#clip-path-14)" data-name="Grupo 11">
              <path
                fill="#cee4ea"
                d="M875.613 2603.012q-50.024 0-91.724-9.724c-89.933-21.015-153.95-67.765-190.275-138.949-24.749-48.5-37.092-109.441-36.685-181.129.353-62.223 10.352-134.617 29.716-215.171 35.347-147.058 96.514-301.2 151.684-432.589 72.849-173.484 165.455-280.224 283.11-326.322 119.179-46.7 266.048-32.049 449.01 44.779 102.677 43.115 188.178 94.031 254.129 151.331 67.822 58.925 115.4 124.988 141.426 196.357 42.782 117.337 27.808 248.306-44.506 389.276-31.223 60.865-91.78 129.057-175.124 197.2-79.47 64.976-176.124 127.3-279.519 180.242-106.1 54.325-213.787 95.819-311.43 119.994-66.468 16.46-126.61 24.707-179.812 24.707m-130.762-974.825l6.522 2.739c-125.464 298.788-240.825 629.509-145.159 816.982 34.344 67.3 95.205 111.581 180.891 131.6 134.138 31.354 348.46-18.667 573.3-133.79 215.854-110.523 387.71-252.8 448.5-371.309 70.441-137.318 85.179-264.487 43.8-377.968-50.472-138.427-180.926-252.648-387.741-339.492-179.4-75.333-322.795-89.936-438.372-44.653-113.908 44.632-203.936 148.854-275.227 318.628z"
                data-name="Trazado 9"
                transform="translate(-556.921 -1272.514)"
              ></path>
            </g>
          </g>
        </g>
        <g
          data-name="Grupo 299"
          opacity="0.22"
          transform="translate(-1466.91 2.655)"
        >
          <g data-name="Grupo 24">
            <g clip-path="url(#clip-path-15)" data-name="Grupo 23">
              <path
                fill="#cee4ea"
                d="M1623.6 1336.345c-66.027 0-119.772-56.017-119.772-122.931 0-66.914 53.745-121.386 119.772-121.386 66.027 0 121.312 54.472 121.312 121.386 0 66.914-55.28 122.931-121.312 122.931"
                data-name="Trazado 13"
              ></path>
            </g>
          </g>
        </g>
        <g transform="translate(-304.204 1859.648)">
          <g transform="translate(272.707 426.298)">
            <g data-name="Grupo 302" transform="translate(485.162 354.797)">
              <g data-name="Grupo 301">
                <path
                  fill="#e8e8e8"
                  d="M667.978 1004.671H372.61a1.136 1.136 0 010-2.271h295.368a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 185"
                  transform="translate(-371.475 -1002.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 304" transform="translate(167.882 354.797)">
              <g data-name="Grupo 303">
                <path
                  fill="#e8e8e8"
                  d="M1064.532 1004.671H762.71a1.136 1.136 0 010-2.271h301.822a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 186"
                  transform="translate(-761.575 -1002.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 306" transform="translate(228.438 375.616)">
              <g data-name="Grupo 305">
                <path
                  fill="#e8e8e8"
                  d="M1018.391 1032.171H833.935a1.136 1.136 0 010-2.271h184.455a1.137 1.137 0 110 2.271z"
                  data-name="Trazado 187"
                  transform="translate(-832.8 -1029.9)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 308" transform="translate(495.44 380.537)">
              <g data-name="Grupo 307">
                <path
                  fill="#e8e8e8"
                  d="M703.1 1038.671H596.01a1.136 1.136 0 010-2.271H703.1a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 188"
                  transform="translate(-594.875 -1036.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 310" transform="translate(41.512 353.586)">
              <g data-name="Grupo 309">
                <path
                  fill="#e8e8e8"
                  d="M1278.407 1003.071h-85.1a1.136 1.136 0 010-2.271h85.1a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 189"
                  transform="translate(-1192.175 -1000.8)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 312" transform="translate(703.005 210.97)">
              <g data-name="Grupo 311">
                <path
                  fill="#e8e8e8"
                  d="M459.888 814.146a66 66 0 00-5.976 55.72 1.078 1.078 0 01-.8 1.363 15.375 15.375 0 00-6.534 3.482c-2.151 2.271-2.629 6.814 1.036 8.176.717.3 1.355 1.287.558 1.893-6.215 4.618-6.932 12.34-7.41 19.305a109.3 109.3 0 01-2.948 20.365c-3.426 12.87-10.119 24.832-21.354 32.932-1.2.908-2.39-1.06-1.2-1.968 12.43-8.933 18.8-22.939 21.513-37.172 2.151-11.053-.717-27.254 9.8-35.052a16.99 16.99 0 00.558 1.893 6.8 6.8 0 01-4.3-7.949c.956-4.467 5.657-6.814 9.88-8.1-.239.454-.558.908-.8 1.363a67.894 67.894 0 016.215-57.461c.478-1.211 2.55-.076 1.753 1.211z"
                  data-name="Trazado 190"
                  transform="translate(-414.773 -812.419)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 314" transform="translate(667.078 208.741)">
              <g data-name="Grupo 313">
                <path
                  fill="#e8e8e8"
                  d="M495.541 811.614c-16.254 9.463-29.242 22.787-39.919 37.626a253.3 253.3 0 00-14.262 22.182c-3.665 6.359-12.031 17.715-5.1 24.453a1.124 1.124 0 01-.558 1.893c-5.418 1.363-7.649 7.192-9.641 11.659a94.555 94.555 0 00-5.02 14.46 103.557 103.557 0 00-3.346 31.267c.08 1.438-2.311 1.438-2.39 0a105.491 105.491 0 014.621-35.885 96.979 96.979 0 016.215-15.444c1.912-3.71 4.542-7.116 8.924-8.252a17.008 17.008 0 01-.558 1.893c-5.9-5.678-2.629-14.006.717-20.138a262.856 262.856 0 0116.1-26.194c11.394-16.352 25.258-31.191 43.026-41.487a1.152 1.152 0 011.2 1.968z"
                  data-name="Trazado 191"
                  transform="translate(-415.216 -809.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 316" transform="translate(678.235 209.59)">
              <g data-name="Grupo 315">
                <path
                  fill="#e8e8e8"
                  d="M484.943 812.568c-36.333 40.049-59.44 90.242-65.655 142.782-.159 1.438-2.55 1.438-2.39 0a259.58 259.58 0 0144.222-116.436 272.067 272.067 0 0122.23-27.936c.956-1.136 2.629.53 1.594 1.59z"
                  data-name="Trazado 192"
                  transform="translate(-416.89 -810.597)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 318" transform="translate(688.979 263.252)">
              <g data-name="Grupo 317">
                <path
                  fill="#e8e8e8"
                  d="M475.608 883.539a104.691 104.691 0 00-48.208 39.745c-.8 1.211-2.868.076-2.072-1.136a106.521 106.521 0 0149.082-40.578c1.355-.53 2.55 1.363 1.2 1.968z"
                  data-name="Trazado 193"
                  transform="translate(-425.152 -881.478)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 320" transform="translate(702.527 245.686)">
              <g data-name="Grupo 319">
                <path
                  fill="#e8e8e8"
                  d="M470.826 859.354a219.525 219.525 0 01-3.107 23.847c-.239 1.438-2.55.833-2.311-.606a229.1 229.1 0 003.028-23.242c.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 194"
                  transform="translate(-465.39 -858.275)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 322" transform="translate(679.784 304.89)">
              <g data-name="Grupo 321">
                <path
                  fill="#e8e8e8"
                  d="M487.547 938.539a118.713 118.713 0 00-46.612 35.43c-.876 1.135-2.948 0-2.072-1.136a121.083 121.083 0 0147.488-36.263c1.354-.53 2.55 1.363 1.2 1.969z"
                  data-name="Trazado 195"
                  transform="translate(-438.652 -936.478)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 324" transform="translate(639.905 172.661)">
              <g data-name="Grupo 323">
                <path
                  fill="#e8e8e8"
                  d="M533.366 848.791a158.417 158.417 0 00-9.083-54.736c.558.227 1.2.454 1.753.681-1.434.681-2.789 1.363-4.223 1.968a1.255 1.255 0 01-1.833-.984 60.05 60.05 0 00-10.358-32.175 21.009 21.009 0 002.151-.3c-5.418 14.687-10.836 29.3-16.254 43.985-2.629 7.116-5.259 14.157-7.888 21.273-1.992 5.375-10.2 20.744.239 22.409a1.124 1.124 0 01.558 1.893c-5.5 5.6-7.569 13.1-8.605 20.516a130.887 130.887 0 00-.876 23.015 141.582 141.582 0 0010.279 46.786c.558 1.363-1.753 1.968-2.311.606a142.97 142.97 0 01-10.438-50.118c-.319-13.854-.4-31.569 10.279-42.32a17 17 0 00.558 1.893c-6.135-.984-7.649-7.192-6.534-12.264 1.992-8.706 6.215-17.337 9.322-25.74 6.454-17.488 12.988-34.976 19.442-52.54a1.225 1.225 0 012.151-.3 61.259 61.259 0 0110.677 33.311c-.637-.3-1.2-.681-1.833-.984 1.434-.681 2.789-1.363 4.223-1.968a1.188 1.188 0 011.753.681 160 160 0 019.163 55.341 1.157 1.157 0 01-2.311.076z"
                  data-name="Trazado 196"
                  transform="translate(-476.384 -761.818)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 326" transform="translate(661.015 175.005)">
              <g data-name="Grupo 325">
                <path
                  fill="#e8e8e8"
                  d="M520.053 766.342c-12.51 58.975-3.984 119.616-14.262 178.818-.239 1.438-2.55.833-2.311-.606 10.2-59.2 1.673-119.918 14.262-178.818.319-1.438 2.629-.833 2.311.606z"
                  data-name="Trazado 197"
                  transform="translate(-503.462 -764.914)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 328" transform="translate(667.895 223.246)">
              <g data-name="Grupo 327">
                <path
                  fill="#e8e8e8"
                  d="M508.58 830.047c-4.7 21.652-15.139 41.487-25.5 61.171-.717 1.287-2.789.151-2.072-1.136 10.279-19.456 20.557-39.14 25.258-60.565.319-1.514 2.629-.909 2.311.53z"
                  data-name="Trazado 198"
                  transform="translate(-480.862 -828.635)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 330" transform="translate(653.393 224.395)">
              <g data-name="Grupo 329">
                <path
                  fill="#e8e8e8"
                  d="M515.439 830.718a184.178 184.178 0 0114.183 32.705c.478 1.363-1.833 1.968-2.311.606a184.056 184.056 0 00-13.944-32.175c-.717-1.287 1.354-2.423 2.072-1.136z"
                  data-name="Trazado 199"
                  transform="translate(-513.219 -830.152)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 332" transform="translate(234.731 227.317)">
              <g data-name="Grupo 331">
                <path
                  fill="#e8e8e8"
                  d="M1038.823 960.659l-6.932-57.007 1.2 1.136a8.782 8.782 0 00-6.215 1.741 1.256 1.256 0 01-2.072-.833c-.239-4.164-.4-8.252-.637-12.416a18.384 18.384 0 001.514 1.06c-5.816.984-8.924-4.164-11.075-8.4a85.742 85.742 0 00-12.191-17.715c-8.685-9.993-18.565-19.759-21.832-32.781h2.311c-4.462 13.4-9.083 27.027-9.8 41.184-.558 10.9.717 26.724 13.306 31.418a1.153 1.153 0 01.717 1.666c-6.932 12.264 11.155 20.592 19.043 26.649a83.725 83.725 0 0121.513 24.756c.717 1.287-1.354 2.423-2.072 1.136-6.932-12.037-16.573-21.5-28.365-29.3-8.127-5.375-17.928-14.157-12.191-24.377.239.53.478 1.135.717 1.666-11.633-4.391-14.82-17.185-15.139-27.936-.4-16.277 4.86-32.1 9.96-47.468a1.222 1.222 0 012.311 0c2.948 11.886 11.713 20.971 19.76 30.055a112.47 112.47 0 0110.438 13.249c2.47 3.937 5.737 15.066 12.031 14.006a1.2 1.2 0 011.514 1.06c.239 4.164.4 8.252.637 12.416-.717-.3-1.355-.53-2.072-.833a11.443 11.443 0 017.968-2.423 1.2 1.2 0 011.2 1.136l6.932 57.007c.08 1.59-2.311 1.59-2.47.151z"
                  data-name="Trazado 200"
                  transform="translate(-970.597 -834.012)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 334" transform="translate(244.784 230.696)">
              <g data-name="Grupo 333">
                <path
                  fill="#e8e8e8"
                  d="M981.437 839.554c1.355 21.5 5.578 43.38 17.689 61.928 5.9 9.085 13.7 17.034 20 25.891a101.329 101.329 0 0113.784 27.557c.478 1.363-1.833 1.968-2.311.606a102.128 102.128 0 00-15.537-29.753c-6.693-8.858-14.422-16.958-20.079-26.5-10.677-18.169-14.581-39.14-15.856-59.732-.159-1.438 2.231-1.438 2.311 0z"
                  data-name="Trazado 201"
                  transform="translate(-979.119 -838.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 336" transform="translate(266.001 266.93)">
              <g data-name="Grupo 335">
                <path
                  fill="#e8e8e8"
                  d="M1018.172 887.445a106.623 106.623 0 01-5.1 31.191c-.478 1.363-2.789.833-2.311-.606a104.761 104.761 0 005.02-30.585c.08-1.438 2.47-1.514 2.39 0z"
                  data-name="Trazado 202"
                  transform="translate(-1010.697 -886.337)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 338" transform="translate(236.18 262.086)">
              <g data-name="Grupo 337">
                <path
                  fill="#e8e8e8"
                  d="M1050.887 893.309a55.314 55.314 0 01-16.653-11.432c-1.036-1.06.637-2.65 1.673-1.59a54.379 54.379 0 0016.175 11.053c1.434.606.159 2.574-1.2 1.968z"
                  data-name="Trazado 203"
                  transform="translate(-1033.908 -879.938)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 340" transform="translate(261.841 328.584)">
              <g data-name="Grupo 339">
                <path
                  fill="#e8e8e8"
                  d="M1018.782 993.761c.717-8.328 1.673-16.655 2.789-24.907.159-1.438 2.629-1.438 2.39 0-1.115 8.252-2.072 16.58-2.789 24.907-.08 1.438-2.47 1.438-2.39 0z"
                  data-name="Trazado 204"
                  transform="translate(-1018.78 -967.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 342" transform="translate(198.379 211.295)">
              <g data-name="Grupo 341">
                <path
                  fill="#e8e8e8"
                  d="M1093.129 862.854a332.652 332.652 0 01-22.151-48.6h2.311c-4.542 17.639-9 35.279-13.545 52.919-.239-.454-.558-.909-.8-1.363l9.561 2.725a1.126 1.126 0 01.876 1.06c.159 1.817-.876 2.877-2.311 3.937-3.346 2.65-4.223 4.769-3.984 8.933.239 3.785.637 7.495.956 11.2.239 2.877.08 10.3 4.781 10.069.717 0 1.434.757 1.116 1.438-3.586 9.463.4 19.229 5.1 27.633a119.8 119.8 0 0016.812 22.939c1.036 1.06-.638 2.725-1.673 1.59a121.8 121.8 0 01-18.485-25.74c-4.382-8.328-7.569-17.867-4.143-27.027a17.534 17.534 0 011.116 1.438c-7.49.379-7.012-10.6-7.41-15.141-.319-4.164-1.275-8.706-.558-12.87a7.838 7.838 0 011.594-3.71c1.2-1.438 4.621-2.725 4.462-4.694a13.08 13.08 0 00.876 1.06l-9.561-2.725a1.078 1.078 0 01-.8-1.363c4.542-17.639 9-35.279 13.545-52.919a1.237 1.237 0 012.311 0 320.836 320.836 0 0021.912 48.073c.876 1.287-1.2 2.422-1.912 1.136z"
                  data-name="Trazado 205"
                  transform="translate(-1057.233 -812.849)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 344" transform="translate(211.815 216.189)">
              <g data-name="Grupo 343">
                <path
                  fill="#e8e8e8"
                  d="M1043.779 820.742c-7.49 45.348 25.975 84.337 34.581 127.186.319 1.438-1.992 2.044-2.311.606-8.685-43.38-42.15-82.444-34.58-128.4.239-1.438 2.55-.833 2.311.606z"
                  data-name="Trazado 206"
                  transform="translate(-1040.362 -819.314)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 346" transform="translate(223.727 248.819)">
              <g data-name="Grupo 345">
                <path
                  fill="#e8e8e8"
                  d="M1071.136 863.842c-1.833 9.009-3.585 18.018-5.418 27.1-.319 1.438-2.63.833-2.311-.606 1.833-9.009 3.586-18.018 5.418-27.1.319-1.438 2.55-.833 2.311.606z"
                  data-name="Trazado 207"
                  transform="translate(-1063.377 -862.414)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 348" transform="translate(204.276 245.733)">
              <g data-name="Grupo 347">
                <path
                  fill="#e8e8e8"
                  d="M1091.443 874.435a106.359 106.359 0 00-12.35-14.157c-1.116-1.06.637-2.65 1.673-1.59a108.442 108.442 0 0112.749 14.611c.877 1.211-1.2 2.347-2.072 1.136z"
                  data-name="Trazado 208"
                  transform="translate(-1078.734 -858.338)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 350" transform="translate(408.989 132.007)">
              <g data-name="Grupo 349">
                <path
                  fill="#e8e8e8"
                  d="M723.786 718.627a390.958 390.958 0 00-178.081 4.315c-29.561 7.722-57.448 19.759-85.973 30.358a735.84 735.84 0 01-86.212 26.119 761.861 761.861 0 01-99.678 16.807c-1.514.151-1.514-2.12 0-2.271A753.932 753.932 0 00452.083 753.6c28.923-10.372 56.97-22.863 86.61-31.191a388.743 388.743 0 0186.61-13.854 394.926 394.926 0 0199.04 7.873c1.514.3.876 2.5-.558 2.2z"
                  data-name="Trazado 209"
                  transform="translate(-272.707 -708.117)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 352" transform="translate(44.54 123.659)">
              <g data-name="Grupo 351">
                <path
                  fill="#e8e8e8"
                  d="M1170.228 749.638c-62.787 14.687-128.043 8.555-190.75-3.407-64.619-12.34-127.8-31.191-192.981-40.881-36.971-5.527-74.579-7.873-111.948-4.315-1.514.151-1.514-2.12 0-2.271 65.336-6.208 130.354 5.829 193.618 20.214 63.743 14.536 127.167 31.645 192.822 36.112 36.413 2.423 73.065.757 108.6-7.571a1.109 1.109 0 11.637 2.12z"
                  data-name="Trazado 210"
                  transform="translate(-673.414 -697.09)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 354" transform="translate(150.911 58.735)">
              <g data-name="Grupo 353">
                <path
                  fill="#e8e8e8"
                  d="M1014.65 631.143c-37.767-7.192-75.216 4.467-111.47 13.249-36.732 8.933-74.1 13.021-111.948 9.463-37.608-3.558-73.942-13.7-110.753-21.425a878.262 878.262 0 00-244.852-16.58c-1.514.076-1.514-2.2 0-2.271a885.578 885.578 0 01228.916 13.4c37.847 7.268 74.977 18.018 113.3 23.166a325.5 325.5 0 00116.729-5.905c39.441-9.16 79.758-23.015 120.792-15.217 1.434.151.8 2.347-.717 2.12z"
                  data-name="Trazado 211"
                  transform="translate(-434.491 -611.332)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 356" transform="translate(1.784)">
              <g data-name="Grupo 355">
                <path
                  fill="#e8e8e8"
                  d="M1265.576 565.66c-42.548 4.164-84.618-4.769-125.812-13.779-21.035-4.618-42.15-9.236-63.5-12.264a361.437 361.437 0 00-141.27 7.873 1.145 1.145 0 11-.637-2.2 364.426 364.426 0 01131.151-9.312c42.787 4.769 84.061 17.11 126.449 23.923 24.3 3.937 48.922 5.829 73.543 3.407a1.174 1.174 0 01.08 2.347z"
                  data-name="Trazado 212"
                  transform="translate(-933.487 -533.749)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 358" transform="translate(650.047 25.046)">
              <g data-name="Grupo 357">
                <path
                  fill="#e8e8e8"
                  d="M486.619 576.5c-32.11 5.3-63.743-5.375-95.694-7.041-33.7-1.817-67.249 3.407-100.315 8.63-1.514.227-2.151-1.968-.637-2.2 32.349-5.072 65.018-10.145 97.925-8.858 32.668 1.287 65.336 12.719 98.164 7.268 1.434-.227 2.072 1.968.558 2.2z"
                  data-name="Trazado 213"
                  transform="translate(-289.107 -566.832)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 360" transform="translate(583.246 461.24)">
              <g data-name="Grupo 359">
                <path
                  fill="#1f4049"
                  d="M591.049 1145.271H476.71a1.136 1.136 0 010-2.271h114.339a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 214"
                  transform="translate(-475.575 -1143)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 362" transform="translate(502.771 475.624)">
              <g data-name="Grupo 361">
                <path
                  fill="#1f4049"
                  d="M694.142 1164.271H588.01a1.136 1.136 0 010-2.271h106.132a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 215"
                  transform="translate(-586.875 -1162)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 364" transform="translate(789.693 460.18)">
              <g data-name="Grupo 363">
                <path
                  fill="#1f4049"
                  d="M286.41 1141.6h59.52a1.136 1.136 0 010 2.271h-59.52a1.136 1.136 0 010-2.271z"
                  data-name="Trazado 216"
                  transform="translate(-285.275 -1141.6)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 366" transform="translate(340.625 419.147)">
              <g data-name="Grupo 365">
                <path
                  fill="#1f4049"
                  d="M877.08 1089.671H690.473a1.136 1.136 0 010-2.271H877.08a1.136 1.136 0 110 2.271z"
                  data-name="Trazado 217"
                  transform="translate(-689.337 -1087.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 368" transform="translate(273.64 434.492)">
              <g data-name="Grupo 367">
                <path
                  fill="#1f4049"
                  d="M1135.193 1067.671h-69.958a1.136 1.136 0 010-2.271h69.958a1.137 1.137 0 110 2.271z"
                  data-name="Trazado 218"
                  transform="translate(-1064.1 -1065.4)"
                ></path>
              </g>
            </g>
          </g>
          <g transform="translate(315.733 716.041)">
            <path
              fill="#ff6339"
              stroke="#1f4049"
              strokeWidth="1"
              d="M766.211 102.755c.319 4.315.558 8.555.877 12.87 1.992.53 3.9 1.136 5.9 1.666.08 3.18.159 6.359.319 9.539h9.163c-.558 4.391-1.2 8.782-1.753 13.173-5.179.076-10.438.151-15.617.3-.558 3.558-1.2 7.116-1.753 10.674 3.665 0 7.49-.076 11.474-.3 4.7-.227 9.083-.606 13.227-1.136.159 4.694.4 9.312.558 14.005-13.067-.151-26.134-.378-39.2-.53l-1.2 9.766a429.466 429.466 0 01-82.547.833c-8.366-.757-16.414-1.665-24.143-2.8v-11.2a60.917 60.917 0 0026.533 3.634c-.478-2.953-.956-5.981-1.434-8.933a28.3 28.3 0 01-1.434-7.268 35.809 35.809 0 010-5.072c7.569.076 15.139.151 22.708.3.159-4.921.4-9.917.558-14.838-7.012-.53-13.944-1.136-20.955-1.666-.159-2.65-.4-5.224-.558-7.873 3.506-.454 7.091-.908 10.6-1.363.159-5.072.4-10.069.558-15.141z"
              data-name="Trazado 220"
            ></path>
            <path
              fill="#06afbe"
              d="M1244.752 923.8c.08 3.1.159 6.208.239 9.236-7.251.454-14.5.909-21.752 1.287v8.706c2.709.606 5.418 1.211 8.047 1.817.159 3.331.4 6.738.558 10.069l25.338.227c.239 3.331.558 6.738.8 10.069-9.96.151-19.92.379-29.8.53v12.189c10.119.227 20.238.53 30.357.757.159 3.861.4 7.8.558 11.659-3.267.227-6.533.53-9.721.757l-.239 10.3c4.382.379 8.765.681 13.067 1.06-.159 4.467-.4 9.009-.558 13.476l-15.856-.227v14.308a821.783 821.783 0 01-37.05 1.06 793.54 793.54 0 01-56.89-1.817 114.7 114.7 0 01-2.231-11.886 129.848 129.848 0 01-1.115-14.838c-2.231-.379-4.462-.682-6.693-1.06l-.239-9.766 16.732-.227c-.239-4.315-.558-8.63-.8-12.946-8.446-.227-16.892-.53-25.338-.757l-.239-11.356h21.195c-.239-3.1-.558-6.208-.8-9.236-7.729-.454-15.458-.908-23.107-1.287l-.239-11.356H1118.7c.159-3.407.4-6.889.558-10.3 8.446.151 16.892.378 25.338.53-.239-4.164-.558-8.328-.8-12.416a215.932 215.932 0 0135.7-4.769 218.676 218.676 0 0165.256 6.207z"
              data-name="Trazado 221"
              transform="translate(-989.333 -884.657)"
            ></path>
            <g data-name="Grupo 372" transform="translate(640.557 158.759)">
              <g data-name="Grupo 371">
                <path
                  fill="#1f4049"
                  d="M468.174 1130.509c-.08 3.18-.239 6.435-.319 9.615a1.2 1.2 0 01-1.2 1.136 731.2 731.2 0 01-105.414-.757c-.478-.076-1.036-.3-1.116-.833a34.326 34.326 0 01-.8-12.416c.159-1.438 2.55-1.438 2.39 0a32.763 32.763 0 00.717 11.81 13.588 13.588 0 01-1.116-.833 742.317 742.317 0 00105.415.757l-1.2 1.136c.08-3.18.239-6.435.319-9.615 0-1.438 2.39-1.438 2.311 0z"
                  data-name="Trazado 222"
                  transform="translate(-359.098 -1126.175)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 374" transform="translate(787.003 148.103)">
              <g data-name="Grupo 373">
                <path
                  fill="#1f4049"
                  d="M311.59 1113.236v13.4a1.2 1.2 0 01-2.39 0v-13.4a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 223"
                  transform="translate(-309.2 -1112.1)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 376" transform="translate(667.307 162.411)">
              <g data-name="Grupo 375">
                <path
                  fill="#1f4049"
                  d="M430.533 1133.271H312.21a1.136 1.136 0 010-2.271h118.323a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 224"
                  transform="translate(-311.075 -1131)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 378" transform="translate(738.698 163.831)">
              <g data-name="Grupo 377">
                <path
                  fill="#1f4049"
                  d="M372.119 1133.954a38.526 38.526 0 00-.239 7.419c.08 1.438-2.311 1.438-2.39 0a33.054 33.054 0 01.239-7.419c.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 225"
                  transform="translate(-369.39 -1132.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 380" transform="translate(730.931 163.839)">
              <g data-name="Grupo 379">
                <path
                  fill="#1f4049"
                  d="M381.789 1134.259a19.578 19.578 0 00-.478 5.678c.08 1.438-2.311 1.438-2.39 0a18.534 18.534 0 01.558-6.284c.319-1.363 2.629-.757 2.311.606z"
                  data-name="Trazado 226"
                  transform="translate(-378.862 -1132.885)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 382" transform="translate(665.723 153.232)">
              <g data-name="Grupo 381">
                <path
                  fill="#1f4049"
                  d="M461.168 1129.039a31.6 31.6 0 01-1.116-9.085 1.2 1.2 0 012.39 0 27.831 27.831 0 001.036 8.479c.4 1.363-1.912 1.968-2.311.606z"
                  data-name="Trazado 227"
                  transform="translate(-460.042 -1118.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 384" transform="translate(666.749 148.465)">
              <g data-name="Grupo 383">
                <path
                  fill="#1f4049"
                  d="M431.47 1114.79a555.807 555.807 0 01-118.721 2.953c-1.514-.151-1.514-2.422 0-2.271a549.86 549.86 0 00118.083-2.877c1.514-.227 2.151 1.968.637 2.2z"
                  data-name="Trazado 228"
                  transform="translate(-311.614 -1112.578)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 386" transform="translate(641.897 159.17)">
              <g data-name="Grupo 385">
                <path
                  fill="#1f4049"
                  d="M486.75 1131.474a62.01 62.01 0 01-23.266-2.5 1.145 1.145 0 01.637-2.2 58.685 58.685 0 0022.629 2.422c1.514-.075 1.514 2.2 0 2.271z"
                  data-name="Trazado 229"
                  transform="translate(-462.675 -1126.719)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 388" transform="translate(678.402 163.831)">
              <g data-name="Grupo 387">
                <path
                  fill="#1f4049"
                  d="M447.89 1133.954v7.873a1.2 1.2 0 01-2.39 0v-7.873a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 230"
                  transform="translate(-445.5 -1132.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 390" transform="translate(659.102 161.967)">
              <g data-name="Grupo 389">
                <path
                  fill="#1f4049"
                  d="M471.772 1131.842c-.478 2.8-.876 5.6-1.355 8.328-.239 1.438-2.55.833-2.311-.606.478-2.8.876-5.6 1.355-8.328.239-1.438 2.47-.833 2.311.606z"
                  data-name="Trazado 231"
                  transform="translate(-468.09 -1130.414)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 392" transform="translate(649.292 161.513)">
              <g data-name="Grupo 391">
                <path
                  fill="#1f4049"
                  d="M483.939 1131.242a10.546 10.546 0 00.319 4.467 1.2 1.2 0 01-2.311.606 12.482 12.482 0 01-.319-5.678c.239-1.438 2.55-.833 2.311.606z"
                  data-name="Trazado 232"
                  transform="translate(-481.442 -1129.814)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 394" transform="translate(774.97 149.977)">
              <g data-name="Grupo 393">
                <path
                  fill="#1f4049"
                  d="M326.568 1115.654l-.478 12.037c-.08 1.438-2.47 1.438-2.39 0l.478-12.037c.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 233"
                  transform="translate(-323.698 -1114.575)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 396" transform="translate(758.63 151.339)">
              <g data-name="Grupo 395">
                <path
                  fill="#1f4049"
                  d="M346.945 1117.454c-.319 3.1-.637 6.208-.956 9.236-.159 1.438-2.55 1.438-2.39 0 .319-3.1.637-6.208.956-9.236.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 234"
                  transform="translate(-343.59 -1116.375)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 398" transform="translate(749.987 153.232)">
              <g data-name="Grupo 397">
                <path
                  fill="#1f4049"
                  d="M357.8 1119.954a12.278 12.278 0 01-.478 5.375 1.2 1.2 0 01-2.311-.606 12.138 12.138 0 00.4-4.77c-.159-1.438 2.231-1.438 2.39 0z"
                  data-name="Trazado 235"
                  transform="translate(-354.965 -1118.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 400" transform="translate(762.206 139.775)">
              <g data-name="Grupo 399">
                <path
                  fill="#1f4049"
                  d="M342.464 1102.236a64.567 64.567 0 01-1.036 10.448c-.239 1.438-2.55.833-2.311-.606a51.492 51.492 0 00.956-9.842 1.2 1.2 0 012.39 0z"
                  data-name="Trazado 236"
                  transform="translate(-339.1 -1101.1)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 402" transform="translate(663.651 138.791)">
              <g data-name="Grupo 401">
                <path
                  fill="#1f4049"
                  d="M440.3 1102.071q-48.763.909-97.526 1.893a13.6 13.6 0 001.115-.833 31.871 31.871 0 00-.159 9.539c.159 1.438-2.231 1.438-2.39 0a36.087 36.087 0 01.239-10.145 1.1 1.1 0 011.116-.833q48.763-.908 97.526-1.893a1.137 1.137 0 11.08 2.271z"
                  data-name="Trazado 237"
                  transform="translate(-341.087 -1099.8)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 404" transform="translate(779.825 126.31)">
              <g data-name="Grupo 403">
                <path
                  fill="#1f4049"
                  d="M320.109 1084.742c-.8 4.012-1.355 8.1-1.833 12.189-.159 1.438-2.55 1.438-2.39 0a170.785 170.785 0 011.912-12.794c.239-1.438 2.55-.833 2.311.606z"
                  data-name="Trazado 238"
                  transform="translate(-315.878 -1083.314)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 406" transform="translate(686.527 125.315)">
              <g data-name="Grupo 405">
                <path
                  fill="#1f4049"
                  d="M412.674 1084.422c-15.458.908-30.995.3-46.452.151-15.617-.076-31.234-.227-46.851-.3l1.2-1.136c-.159 3.861-.319 7.722-.4 11.583-.08 1.438-2.47 1.438-2.39 0 .159-3.861.319-7.722.4-11.583a1.2 1.2 0 011.2-1.136c15.617.076 31.234.227 46.851.3 15.458.076 30.995.681 46.452-.151 1.514-.076 1.514 2.2 0 2.271z"
                  data-name="Trazado 239"
                  transform="translate(-317.775 -1082)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 408" transform="translate(762.204 138.714)">
              <g data-name="Grupo 407">
                <path
                  fill="#1f4049"
                  d="M337.224 1102.425l-17.051-.454c-1.514-.076-1.514-2.347 0-2.271l17.051.454a1.136 1.136 0 110 2.271z"
                  data-name="Trazado 240"
                  transform="translate(-319.037 -1099.698)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 410" transform="translate(772.485 116.165)">
              <g data-name="Grupo 409">
                <path
                  fill="#1f4049"
                  d="M329.42 1071.342c-.478 3.1-.956 6.132-1.514 9.236-.239 1.438-2.55.833-2.311-.606.478-3.1.956-6.132 1.514-9.236.239-1.438 2.55-.833 2.311.606z"
                  data-name="Trazado 241"
                  transform="translate(-325.578 -1069.914)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 412" transform="translate(665.266 112.292)">
              <g data-name="Grupo 411">
                <path
                  fill="#1f4049"
                  d="M435.323 1070.7a354.783 354.783 0 00-107.406.833c-1.514.227-2.151-1.968-.637-2.2a360.731 360.731 0 01108.681-.833c1.514.227.876 2.423-.637 2.2z"
                  data-name="Trazado 242"
                  transform="translate(-326.414 -1064.798)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 414" transform="translate(666.921 124.618)">
              <g data-name="Grupo 413">
                <path
                  fill="#1f4049"
                  d="M455.851 1084.88c-4.94-.227-9.8-.454-14.741-.606-2.39-.076-5.259.378-6.852-1.59-.956-1.135 1.116-2.271 2.072-1.135.956 1.211 8.047.606 9.4.681l10.04.454a1.105 1.105 0 11.08 2.2z"
                  data-name="Trazado 243"
                  transform="translate(-434.012 -1081.079)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 416" transform="translate(665.942 115.635)">
              <g data-name="Grupo 415">
                <path
                  fill="#1f4049"
                  d="M462.438 1070.036a39.876 39.876 0 01.877 6.813c.08 1.438-2.311 1.438-2.39 0a32.335 32.335 0 00-.8-6.208c-.319-1.438 1.992-2.044 2.311-.606z"
                  data-name="Trazado 244"
                  transform="translate(-460.098 -1069.214)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 418" transform="translate(765.729 101.449)">
              <g data-name="Grupo 417">
                <path
                  fill="#1f4049"
                  d="M335.9 1064.424v-12.87a1.2 1.2 0 012.39 0v12.87a1.2 1.2 0 01-2.39 0z"
                  data-name="Trazado 245"
                  transform="translate(-335.9 -1050.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 420" transform="translate(676.549 99.6)">
              <g data-name="Grupo 419">
                <path
                  fill="#1f4049"
                  d="M426.838 1052.021c-29.083-1.363-58.245-1.893-87.327-1.666a1.136 1.136 0 010-2.271c29.083-.227 58.245.3 87.327 1.666 1.514.076 1.514 2.347 0 2.271z"
                  data-name="Trazado 246"
                  transform="translate(-338.375 -1048.033)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 422" transform="translate(675.531 100.56)">
              <g data-name="Grupo 421">
                <path
                  fill="#1f4049"
                  d="M451.246 1050.436c-.319 4.315-.637 8.555-.956 12.87-.08 1.438-2.47 1.438-2.39 0 .319-4.315.637-8.555.956-12.87.08-1.514 2.47-1.514 2.39 0z"
                  data-name="Trazado 247"
                  transform="translate(-447.898 -1049.3)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 424" transform="translate(759.746 116.136)">
              <g data-name="Grupo 423">
                <path
                  fill="#1f4049"
                  d="M345.565 1070.954c-.319 2.8-.558 5.6-.876 8.479-.159 1.438-2.55 1.438-2.39 0 .319-2.8.558-5.6.876-8.479.08-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 248"
                  transform="translate(-342.291 -1069.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 426" transform="translate(750.175 114.773)">
              <g data-name="Grupo 425">
                <path
                  fill="#1f4049"
                  d="M357.646 1069.154a29.46 29.46 0 01-.637 6.965c-.239 1.439-2.55.833-2.311-.606a34.3 34.3 0 00.558-6.359 1.2 1.2 0 012.39 0z"
                  data-name="Trazado 249"
                  transform="translate(-354.681 -1068.075)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 428" transform="translate(733.213 128.098)">
              <g data-name="Grupo 427">
                <path
                  fill="#1f4049"
                  d="M378.872 1086.754c-.319 3.1-.558 6.208-.876 9.312-.159 1.438-2.55 1.438-2.39 0 .319-3.1.558-6.208.876-9.312.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 250"
                  transform="translate(-375.598 -1085.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 430" transform="translate(723.094 127.189)">
              <g data-name="Grupo 429">
                <path
                  fill="#1f4049"
                  d="M391.565 1085.554c-.319 3.1-.558 6.208-.876 9.312-.159 1.438-2.55 1.438-2.39 0 .319-3.1.558-6.208.876-9.312.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 251"
                  transform="translate(-388.29 -1084.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 432" transform="translate(706.361 126.754)">
              <g data-name="Grupo 431">
                <path
                  fill="#1f4049"
                  d="M412.552 1085.036l-.956 10.675c-.159 1.438-2.55 1.438-2.39 0l.956-10.675c.08-1.514 2.47-1.514 2.39 0z"
                  data-name="Trazado 252"
                  transform="translate(-409.198 -1083.9)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 434" transform="translate(701.581 140.968)">
              <g data-name="Grupo 433">
                <path
                  fill="#1f4049"
                  d="M418.5 1103.754c-.4 3.558-.717 7.116-1.115 10.674-.159 1.438-2.55 1.438-2.39 0 .4-3.558.717-7.116 1.115-10.674.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 253"
                  transform="translate(-414.99 -1102.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 436" transform="translate(691.762 140.921)">
              <g data-name="Grupo 435">
                <path
                  fill="#1f4049"
                  d="M430.952 1104.042a45.782 45.782 0 00-.478 9.917c.08 1.438-2.311 1.438-2.39 0a42.264 42.264 0 01.558-10.523c.239-1.438 2.55-.833 2.311.606z"
                  data-name="Trazado 254"
                  transform="translate(-427.978 -1102.614)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 438" transform="translate(679.56 140.513)">
              <g data-name="Grupo 437">
                <path
                  fill="#1f4049"
                  d="M446.177 1103.154a43.859 43.859 0 00.159 10.22c.159 1.438-2.231 1.438-2.39 0a48.706 48.706 0 01-.159-10.22c.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 255"
                  transform="translate(-443.59 -1102.075)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 440" transform="translate(716.56 153.838)">
              <g data-name="Grupo 439">
                <path
                  fill="#1f4049"
                  d="M399.188 1120.754c.239 2.2.4 4.467.637 6.662.159 1.438-2.231 1.438-2.39 0-.239-2.2-.4-4.467-.638-6.662-.159-1.438 2.231-1.438 2.39 0z"
                  data-name="Trazado 256"
                  transform="translate(-396.79 -1119.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 442" transform="translate(709.638 154.754)">
              <g data-name="Grupo 441">
                <path
                  fill="#1f4049"
                  d="M408.357 1122.259a9.959 9.959 0 00-.8 5.451c.159 1.438-2.231 1.438-2.39 0a12 12 0 01.876-6.057c.558-1.363 2.868-.757 2.311.606z"
                  data-name="Trazado 257"
                  transform="translate(-405.092 -1120.885)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 444" transform="translate(714.895 112.578)">
              <g data-name="Grupo 443">
                <path
                  fill="#1f4049"
                  d="M401.966 1066.254c-.319 3.558-.4 7.116-.478 10.674a1.2 1.2 0 01-2.39 0q0-5.337.478-10.674c.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 258"
                  transform="translate(-399.098 -1065.175)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 446" transform="translate(705.32 113.44)">
              <g data-name="Grupo 445">
                <path
                  fill="#1f4049"
                  d="M413.923 1067.742a27.708 27.708 0 00-.478 7.268c.08 1.438-2.311 1.438-2.39 0a26.277 26.277 0 01.558-7.874c.319-1.438 2.629-.833 2.311.606z"
                  data-name="Trazado 259"
                  transform="translate(-410.962 -1066.314)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 448" transform="translate(740.353 100.116)">
              <g data-name="Grupo 447">
                <path
                  fill="#1f4049"
                  d="M369.807 1050.142a32.656 32.656 0 00-.956 10.75c.159 1.438-2.231 1.438-2.39 0a32.065 32.065 0 011.036-11.356 1.2 1.2 0 012.311.606z"
                  data-name="Trazado 260"
                  transform="translate(-366.342 -1048.714)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 450" transform="translate(730.096 100.116)">
              <g data-name="Grupo 449">
                <path
                  fill="#1f4049"
                  d="M382.6 1050.142c-.558 2.953-1.036 5.905-1.594 8.858-.239 1.438-2.55.833-2.311-.606.558-2.953 1.036-5.905 1.594-8.858.239-1.438 2.55-.833 2.311.606z"
                  data-name="Trazado 261"
                  transform="translate(-378.678 -1048.714)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 452" transform="translate(696.476 100.57)">
              <g data-name="Grupo 451">
                <path
                  fill="#1f4049"
                  d="M425.039 1050.742a42.476 42.476 0 00-.478 9.009c.08 1.438-2.311 1.438-2.39 0a38.8 38.8 0 01.558-9.615c.239-1.438 2.55-.833 2.311.606z"
                  data-name="Trazado 262"
                  transform="translate(-422.078 -1049.314)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 454" transform="translate(159.404 132.153)">
              <g data-name="Grupo 453">
                <path
                  fill="#1f4049"
                  d="M1236 1049.851l-.239 13.1a1.2 1.2 0 01-1.2 1.135c-19.92.151-39.76 0-59.679-.53-9.641-.227-19.362-.606-29-.984-2.311-.076-6.135.454-7.49-1.968a7.556 7.556 0 01-.478-3.482c-.159-2.271-.239-4.618-.319-6.965-.08-1.438 2.311-1.438 2.39 0 .08 1.817.159 3.709.239 5.526.159 2.65.4 3.937 3.346 4.467 4.223.757 9 .378 13.306.53 8.605.3 17.29.53 25.9.757q25.935.568 51.791.3l-1.2 1.135c.08-4.391.159-8.782.239-13.1.08-1.363 2.47-1.363 2.391.075z"
                  data-name="Trazado 263"
                  transform="translate(-1137.598 -1048.762)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 456" transform="translate(271.511 117.702)">
              <g data-name="Grupo 455">
                <path
                  fill="#1f4049"
                  d="M1119.67 1030.754c-.159 4.088-.319 8.176-.478 12.34-.08 1.438-2.47 1.438-2.39 0 .159-4.088.319-8.176.478-12.34a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 264"
                  transform="translate(-1116.8 -1029.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 458" transform="translate(159.43 130.44)">
              <g data-name="Grupo 457">
                <path
                  fill="#1f4049"
                  d="M1231.9 1048.771h-112.59a1.136 1.136 0 010-2.271h112.59a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 265"
                  transform="translate(-1118.175 -1046.5)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 460" transform="translate(157.155 116.434)">
              <g data-name="Grupo 459">
                <path
                  fill="#1f4049"
                  d="M1233.395 1030.271h-112.984a1.136 1.136 0 010-2.271h112.984a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 266"
                  transform="translate(-1119.275 -1028)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 462" transform="translate(157.972 116.869)">
              <g data-name="Grupo 461">
                <path
                  fill="#1f4049"
                  d="M1262.29 1029.654v13.552a1.2 1.2 0 01-2.39 0v-13.552a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 267"
                  transform="translate(-1259.9 -1028.575)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 464" transform="translate(258.924 105.816)">
              <g data-name="Grupo 463">
                <path
                  fill="#1f4049"
                  d="M1133.2 1025.274v-10.22a1.2 1.2 0 012.39 0v10.22a1.2 1.2 0 01-2.39 0z"
                  data-name="Trazado 268"
                  transform="translate(-1133.2 -1013.975)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 466" transform="translate(149.585 105.76)">
              <g data-name="Grupo 465">
                <path
                  fill="#1f4049"
                  d="M1244.032 1016.171H1135.51a1.136 1.136 0 010-2.271h108.522a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 269"
                  transform="translate(-1134.375 -1013.9)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 468" transform="translate(151.279 105.816)">
              <g data-name="Grupo 467">
                <path
                  fill="#1f4049"
                  d="M1270.69 1015.054v9.766a1.2 1.2 0 01-2.39 0v-9.766a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 270"
                  transform="translate(-1268.3 -1013.975)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 470" transform="translate(151.737 115.98)">
              <g data-name="Grupo 469">
                <path
                  fill="#1f4049"
                  d="M1267.228 1029.671h-6.693a1.136 1.136 0 010-2.271h6.693a1.137 1.137 0 110 2.271z"
                  data-name="Trazado 271"
                  transform="translate(-1259.4 -1027.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 472" transform="translate(268.725 93.931)">
              <g data-name="Grupo 471">
                <path
                  fill="#1f4049"
                  d="M1123.29 999.354v9.312a1.2 1.2 0 01-2.39 0v-9.312a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 272"
                  transform="translate(-1120.9 -998.275)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 474" transform="translate(166.876 93.041)">
              <g data-name="Grupo 473">
                <path
                  fill="#1f4049"
                  d="M1224.066 999.371h-101.431a1.136 1.136 0 010-2.271h101.431a1.137 1.137 0 110 2.271z"
                  data-name="Trazado 273"
                  transform="translate(-1121.5 -997.1)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 476" transform="translate(167.374 93.523)">
              <g data-name="Grupo 475">
                <path
                  fill="#1f4049"
                  d="M1250.49 998.845v10.22a1.2 1.2 0 01-2.39 0v-10.22a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 274"
                  transform="translate(-1248.1 -997.737)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 478" transform="translate(168.708 104.548)">
              <g data-name="Grupo 477">
                <path
                  fill="#1f4049"
                  d="M1222.233 1014.571h-99.6a1.136 1.136 0 010-2.271h99.6a1.137 1.137 0 110 2.271z"
                  data-name="Trazado 275"
                  transform="translate(-1121.5 -1012.3)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 480" transform="translate(237.889 82.045)">
              <g data-name="Grupo 479">
                <path
                  fill="#1f4049"
                  d="M1159.6 993.42v-9.766a1.2 1.2 0 012.39 0v9.766a1.2 1.2 0 01-2.39 0z"
                  data-name="Trazado 276"
                  transform="translate(-1159.6 -982.575)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 482" transform="translate(141.538 81.155)">
              <g data-name="Grupo 481">
                <path
                  fill="#1f4049"
                  d="M1257.323 983.671h-96.012a1.136 1.136 0 010-2.271h96.012a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 277"
                  transform="translate(-1160.175 -981.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 484" transform="translate(144.167 92.208)">
              <g data-name="Grupo 483">
                <path
                  fill="#1f4049"
                  d="M1272.475 998.271h-23.665a1.136 1.136 0 010-2.271h23.664a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 278"
                  transform="translate(-1247.675 -996)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 486" transform="translate(141.399 81.666)">
              <g data-name="Grupo 485">
                <path
                  fill="#1f4049"
                  d="M1283.09 983.154v9.766a1.2 1.2 0 01-2.39 0v-9.766a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 279"
                  transform="translate(-1280.7 -982.075)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 488" transform="translate(162.414 79.868)">
              <g data-name="Grupo 487">
                <path
                  fill="#1f4049"
                  d="M1229.1 981.971h-103.665a1.136 1.136 0 010-2.271H1229.1a1.137 1.137 0 110 2.271z"
                  data-name="Trazado 280"
                  transform="translate(-1124.3 -979.7)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 490" transform="translate(266.972 70.613)">
              <g data-name="Grupo 489">
                <path
                  fill="#1f4049"
                  d="M1123.1 977.487v-8.933a1.2 1.2 0 012.39 0v8.933a1.2 1.2 0 01-2.39 0z"
                  data-name="Trazado 281"
                  transform="translate(-1123.1 -967.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 492" transform="translate(162.015 70.178)">
              <g data-name="Grupo 491">
                <path
                  fill="#1f4049"
                  d="M1229.449 969.171h-104.538a1.136 1.136 0 010-2.271h104.538a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 282"
                  transform="translate(-1123.775 -966.9)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 494" transform="translate(161.557 70.178)">
              <g data-name="Grupo 493">
                <path
                  fill="#1f4049"
                  d="M1257.79 968.036v8.1a1.2 1.2 0 01-2.39 0v-8.1a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 283"
                  transform="translate(-1255.4 -966.9)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 496" transform="translate(240.997 59.56)">
              <g data-name="Grupo 495">
                <path
                  fill="#1f4049"
                  d="M1155.7 963.72v-9.766a1.2 1.2 0 012.39 0v9.766a1.2 1.2 0 01-2.39 0z"
                  data-name="Trazado 284"
                  transform="translate(-1155.7 -952.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 498" transform="translate(138.749 58.67)">
              <g data-name="Grupo 497">
                <path
                  fill="#1f4049"
                  d="M1259.366 953.971h-101.43a1.136 1.136 0 010-2.271h101.431a1.137 1.137 0 110 2.271z"
                  data-name="Trazado 285"
                  transform="translate(-1156.8 -951.7)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 500" transform="translate(138.769 59.125)">
              <g data-name="Grupo 499">
                <path
                  fill="#161616"
                  d="M1286.39 953.436v4.694a1.2 1.2 0 01-2.39 0v-4.694a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 286"
                  transform="translate(-1284 -952.3)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 502" transform="translate(138.829 70.178)">
              <g data-name="Grupo 501">
                <path
                  fill="#1f4049"
                  d="M1279.175 969.171h-23.665a1.136 1.136 0 010-2.271h23.664a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 287"
                  transform="translate(-1254.375 -966.9)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 504" transform="translate(138.769 60.412)">
              <g data-name="Grupo 503">
                <path
                  fill="#1f4049"
                  d="M1286.39 955.136v8.479a1.2 1.2 0 01-2.39 0v-8.479a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 288"
                  transform="translate(-1284 -954)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 506" transform="translate(233.029 48.961)">
              <g data-name="Grupo 505">
                <path
                  fill="#1f4049"
                  d="M1165.7 948.054v-8.1a1.2 1.2 0 012.39 0v8.1a1.2 1.2 0 01-2.39 0z"
                  data-name="Trazado 289"
                  transform="translate(-1165.7 -938.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 508" transform="translate(129.427 48.526)">
              <g data-name="Grupo 507">
                <path
                  fill="#1f4049"
                  d="M1270.433 940.571h-104.06a1.136 1.136 0 010-2.271h104.06a1.136 1.136 0 110 2.271z"
                  data-name="Trazado 290"
                  transform="translate(-1165.237 -938.3)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 510" transform="translate(.956 16.526)">
              <g data-name="Grupo 509">
                <path
                  fill="#161616"
                  d="M1297.01 940.571a1.136 1.136 0 010-2.271 1.136 1.136 0 010 2.271z"
                  data-name="Trazado 291"
                  transform="translate(-1295.875 -938.3)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 512" transform="translate(128.491 48.526)">
              <g data-name="Grupo 511">
                <path
                  fill="#1f4049"
                  d="M1299.29 939.436v8.1a1.2 1.2 0 01-2.39 0v-8.1a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 292"
                  transform="translate(-1296.9 -938.3)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 514" transform="translate(128.471 58.292)">
              <g data-name="Grupo 513">
                <path
                  fill="#1f4049"
                  d="M1295.392 953.471h-10.756a1.136 1.136 0 010-2.271h10.756a1.137 1.137 0 110 2.271z"
                  data-name="Trazado 293"
                  transform="translate(-1283.5 -951.2)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 516" transform="translate(254.462 38.76)">
              <g data-name="Grupo 515">
                <path
                  fill="#1f4049"
                  d="M1141.19 926.536v8.933a1.2 1.2 0 01-2.39 0v-8.933a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 294"
                  transform="translate(-1138.8 -925.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 518" transform="translate(229.025 47.617)">
              <g data-name="Grupo 517">
                <path
                  fill="#1f4049"
                  d="M1165.508 939.371h-25.5a1.136 1.136 0 010-2.271h25.5a1.136 1.136 0 010 2.271z"
                  data-name="Trazado 295"
                  transform="translate(-1138.875 -937.1)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 520" transform="translate(153.361 32)">
              <g data-name="Grupo 519">
                <path
                  fill="#1f4049"
                  d="M1240.771 924.139a275.451 275.451 0 00-100.554-1.514c-1.514.227-2.151-1.968-.638-2.2a279.082 279.082 0 01101.829 1.514c1.514.3.876 2.5-.637 2.2z"
                  data-name="Trazado 296"
                  transform="translate(-1138.714 -916.471)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 522" transform="translate(153.032 36.64)">
              <g data-name="Grupo 521">
                <path
                  fill="#1f4049"
                  d="M1268.49 923.736v8.933a1.2 1.2 0 01-2.39 0v-8.933a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 297"
                  transform="translate(-1266.1 -922.6)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 524" transform="translate(170.541 38.003)">
              <g data-name="Grupo 523">
                <path
                  fill="#1f4049"
                  d="M1226.051 926.671c-5.657 1.666-11.872.984-17.689.909-6.533-.076-13.067-.227-19.6-.3-13.306-.227-26.613-.454-39.919-.606a1.136 1.136 0 010-2.271c12.828.227 25.577.379 38.4.606 6.295.076 12.51.227 18.8.3 6.29.073 13.306 1.06 19.442-.757a1.1 1.1 0 11.558 2.12z"
                  data-name="Trazado 298"
                  transform="translate(-1147.707 -924.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 526" transform="translate(235.26 40.028)">
              <g data-name="Grupo 525">
                <path
                  fill="#1f4049"
                  d="M1165.29 928.154v7.646a1.2 1.2 0 01-2.39 0v-7.646a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 299"
                  transform="translate(-1162.9 -927.075)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 528" transform="translate(226.408 40.482)">
              <g data-name="Grupo 527">
                <path
                  fill="#1f4049"
                  d="M1176.206 928.754c-.239 1.817-.478 3.71-.717 5.526-.159 1.438-2.55 1.438-2.39 0 .239-1.817.478-3.71.717-5.526.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 300"
                  transform="translate(-1173.09 -927.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 530" transform="translate(195.652 40.075)">
              <g data-name="Grupo 529">
                <path
                  fill="#1f4049"
                  d="M1214.785 928.245c-.239 2.271-.478 4.542-.8 6.814-.159 1.438-2.55 1.438-2.39 0 .239-2.271.478-4.542.8-6.814.159-1.438 2.55-1.514 2.391 0z"
                  data-name="Trazado 301"
                  transform="translate(-1211.591 -927.137)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 532" transform="translate(186.975 40.88)">
              <g data-name="Grupo 531">
                <path
                  fill="#1f4049"
                  d="M1225.89 929.336v5.072a1.2 1.2 0 01-2.39 0v-5.072a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 302"
                  transform="translate(-1223.5 -928.2)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 534" transform="translate(192.933 49.794)">
              <g data-name="Grupo 533">
                <path
                  fill="#1f4049"
                  d="M1218.206 941.054a30.324 30.324 0 01-.319 7.571c-.239 1.438-2.55.833-2.311-.606a29.02 29.02 0 00.239-6.965c-.08-1.438 2.311-1.438 2.391 0z"
                  data-name="Trazado 303"
                  transform="translate(-1215.559 -939.975)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 536" transform="translate(184.233 49.794)">
              <g data-name="Grupo 535">
                <path
                  fill="#1f4049"
                  d="M1228.98 941.054a19.256 19.256 0 00.239 6.057c.239 1.438-1.992 2.044-2.311.606a23.413 23.413 0 01-.319-6.662c.16-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 304"
                  transform="translate(-1226.478 -939.975)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 538" transform="translate(233.427 60.014)">
              <g data-name="Grupo 537">
                <path
                  fill="#1f4049"
                  d="M1167.59 954.554v9.312a1.2 1.2 0 01-2.39 0v-9.312a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 305"
                  transform="translate(-1165.2 -953.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 540" transform="translate(224.406 60.412)">
              <g data-name="Grupo 539">
                <path
                  fill="#1f4049"
                  d="M1178.766 955.136a43.7 43.7 0 01-.637 7.116c-.239 1.438-2.55.833-2.311-.606a43.985 43.985 0 00.478-6.511c.08-1.514 2.47-1.514 2.47 0z"
                  data-name="Trazado 306"
                  transform="translate(-1175.8 -954)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 542" transform="translate(213.346 49.813)">
              <g data-name="Grupo 541">
                <path
                  fill="#1f4049"
                  d="M1192.648 941.136c-.159 2.65-.4 5.375-.558 8.025-.08 1.438-2.47 1.438-2.39 0 .159-2.65.4-5.375.558-8.025.08-1.514 2.47-1.514 2.39 0z"
                  data-name="Trazado 307"
                  transform="translate(-1189.698 -940)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 544" transform="translate(167.605 48.961)">
              <g data-name="Grupo 543">
                <path
                  fill="#1f4049"
                  d="M1249.965 939.954c-.319 2.574-.558 5.072-.876 7.646-.159 1.438-2.55 1.438-2.39 0 .319-2.574.558-5.072.876-7.646.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 308"
                  transform="translate(-1246.69 -938.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 546" transform="translate(147.612 49.359)">
              <g data-name="Grupo 545">
                <path
                  fill="#1f4049"
                  d="M1275.229 940.536a3935.4 3935.4 0 00-.239 5.981c-.08 1.438-2.47 1.438-2.39 0 .08-1.968.159-3.937.239-5.981.08-1.514 2.47-1.514 2.39 0z"
                  data-name="Trazado 309"
                  transform="translate(-1272.598 -939.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 548" transform="translate(184.345 59.56)">
              <g data-name="Grupo 547">
                <path
                  fill="#1f4049"
                  d="M1229.19 953.954v8.933a1.2 1.2 0 01-2.39 0v-8.933a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 310"
                  transform="translate(-1226.8 -952.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 550" transform="translate(207.054 58.292)">
              <g data-name="Grupo 549">
                <path
                  fill="#1f4049"
                  d="M1200.69 952.336v7.192a1.2 1.2 0 01-2.39 0v-7.192a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 311"
                  transform="translate(-1198.3 -951.2)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 552" transform="translate(253.011 71.011)">
              <g data-name="Grupo 551">
                <path
                  fill="#1f4049"
                  d="M1142.812 969.136a36.2 36.2 0 01-.558 8.782c-.239 1.438-2.55.833-2.311-.606a35.256 35.256 0 00.478-8.176c-.08-1.514 2.311-1.514 2.39 0z"
                  data-name="Trazado 312"
                  transform="translate(-1139.927 -968)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 554" transform="translate(237.013 71.446)">
              <g data-name="Grupo 553">
                <path
                  fill="#1f4049"
                  d="M1163.09 969.654v7.646a1.2 1.2 0 01-2.39 0v-7.646a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 313"
                  transform="translate(-1160.7 -968.575)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 556" transform="translate(216.824 72.232)">
              <g data-name="Grupo 555">
                <path
                  fill="#1f4049"
                  d="M1188.281 971.042a22.117 22.117 0 00-.319 6.056c.159 1.438-2.231 1.438-2.39 0a20.745 20.745 0 01.4-6.662c.319-1.438 2.63-.833 2.311.606z"
                  data-name="Trazado 314"
                  transform="translate(-1185.462 -969.614)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 558" transform="translate(195.629 71.446)">
              <g data-name="Grupo 557">
                <path
                  fill="#1f4049"
                  d="M1214.818 969.654a20.838 20.838 0 01-.319 6.284c-.319 1.438-2.629.833-2.311-.606a17.032 17.032 0 00.239-5.678c-.159-1.438 2.231-1.438 2.39 0z"
                  data-name="Trazado 315"
                  transform="translate(-1212.159 -968.575)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 560" transform="translate(175.342 71.011)">
              <g data-name="Grupo 559">
                <path
                  fill="#1f4049"
                  d="M1240.49 969.136v5.527a1.2 1.2 0 01-2.39 0v-5.527a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 316"
                  transform="translate(-1238.1 -968)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 562" transform="translate(227.551 82.499)">
              <g data-name="Grupo 561">
                <path
                  fill="#1f4049"
                  d="M1174.72 984.254a61.746 61.746 0 00.159 9.388c.159 1.438-2.231 1.438-2.39 0a52.663 52.663 0 01-.159-9.388c.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 317"
                  transform="translate(-1172.191 -983.175)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 564" transform="translate(222.189 82.499)">
              <g data-name="Grupo 563">
                <path
                  fill="#1f4049"
                  d="M1181.623 984.254a79.875 79.875 0 00-.159 9.766c.08 1.438-2.311 1.438-2.39 0a79.9 79.9 0 01.159-9.766c.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 318"
                  transform="translate(-1178.99 -983.175)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 566" transform="translate(206.574 81.212)">
              <g data-name="Grupo 565">
                <path
                  fill="#1f4049"
                  d="M1200.59 982.554c.16 3.785.4 7.646.558 11.432.08 1.438-2.311 1.438-2.39 0-.159-3.785-.4-7.646-.558-11.432-.08-1.438 2.311-1.438 2.39 0z"
                  data-name="Trazado 319"
                  transform="translate(-1198.198 -981.475)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 568" transform="translate(202.081 82.045)">
              <g data-name="Grupo 567">
                <path
                  fill="#1f4049"
                  d="M1206.812 983.654a50.073 50.073 0 00-.319 9.766c.08 1.438-2.311 1.438-2.39 0a50.064 50.064 0 01.319-9.766c.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 320"
                  transform="translate(-1203.991 -982.575)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 570" transform="translate(183.85 81.657)">
              <g data-name="Grupo 569">
                <path
                  fill="#1f4049"
                  d="M1229.571 983.151a45.773 45.773 0 01-.478 10.448c-.239 1.438-2.55.833-2.311-.606a51.423 51.423 0 00.4-9.918c-.08-1.363 2.311-1.363 2.39.076z"
                  data-name="Trazado 321"
                  transform="translate(-1226.765 -982.062)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 572" transform="translate(162.904 81.666)">
              <g data-name="Grupo 571">
                <path
                  fill="#1f4049"
                  d="M1255.845 983.154a3370.96 3370.96 0 00-.956 8.933c-.159 1.438-2.55 1.438-2.391 0 .319-2.953.638-5.905.956-8.933.159-1.439 2.55-1.439 2.39 0z"
                  data-name="Trazado 322"
                  transform="translate(-1252.49 -982.075)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 574" transform="translate(156.084 82.925)">
              <g data-name="Grupo 573">
                <path
                  fill="#1f4049"
                  d="M1264.4 984.845a25.6 25.6 0 00.159 6.057c.239 1.438-2.071 2.044-2.311.606a23.378 23.378 0 01-.239-6.662c.16-1.438 2.55-1.514 2.391 0z"
                  data-name="Trazado 323"
                  transform="translate(-1261.878 -983.737)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 576" transform="translate(263.386 94.782)">
              <g data-name="Grupo 575">
                <path
                  fill="#1f4049"
                  d="M1129.99 1000.536v8.933a1.2 1.2 0 01-2.39 0v-8.933a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 324"
                  transform="translate(-1127.6 -999.4)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 578" transform="translate(257.164 94.385)">
              <g data-name="Grupo 577">
                <path
                  fill="#1f4049"
                  d="M1137.572 999.954c-.319 3.1-.558 6.208-.876 9.312-.159 1.438-2.55 1.438-2.39 0 .319-3.1.557-6.208.876-9.312.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 325"
                  transform="translate(-1134.298 -998.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 580" transform="translate(245.053 93.523)">
              <g data-name="Grupo 579">
                <path
                  fill="#1f4049"
                  d="M1152.805 998.845c-.239 2.725-.478 5.375-.717 8.1-.159 1.438-2.55 1.438-2.391 0 .239-2.725.478-5.375.717-8.1.159-1.438 2.55-1.514 2.39 0z"
                  data-name="Trazado 326"
                  transform="translate(-1149.69 -997.737)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 582" transform="translate(232.932 94.006)">
              <g data-name="Grupo 581">
                <path
                  fill="#1f4049"
                  d="M1167.873 999.454c-.4 3.1-.877 6.208-1.275 9.312-.239 1.438-2.629 1.438-2.39 0 .4-3.1.877-6.208 1.275-9.312.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 327"
                  transform="translate(-1164.191 -998.375)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 584" transform="translate(195.899 94.385)">
              <g data-name="Grupo 583">
                <path
                  fill="#1f4049"
                  d="M1214.69 999.954v11.053a1.2 1.2 0 01-2.39 0v-11.053a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 328"
                  transform="translate(-1212.3 -998.875)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 586" transform="translate(177.174 93.523)">
              <g data-name="Grupo 585">
                <path
                  fill="#1f4049"
                  d="M1238.19 998.845v9.312a1.2 1.2 0 01-2.39 0v-9.312a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 329"
                  transform="translate(-1235.8 -997.737)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 588" transform="translate(248.715 106.678)">
              <g data-name="Grupo 587">
                <path
                  fill="#1f4049"
                  d="M1148.2 1016.542a22.114 22.114 0 00.08 8.252c.239 1.438-1.992 2.044-2.311.606a25.2 25.2 0 01-.08-9.463c.319-1.438 2.55-.833 2.31.606z"
                  data-name="Trazado 330"
                  transform="translate(-1145.478 -1015.114)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 590" transform="translate(242.668 107.936)">
              <g data-name="Grupo 589">
                <path
                  fill="#1f4049"
                  d="M1155.84 1017.854c-.159 2.574-.4 5.072-.558 7.646-.08 1.438-2.47 1.438-2.39 0 .159-2.574.4-5.072.558-7.646.16-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 331"
                  transform="translate(-1152.89 -1016.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 592" transform="translate(219.944 107.103)">
              <g data-name="Grupo 591">
                <path
                  fill="#1f4049"
                  d="M1184.312 1016.754a40.007 40.007 0 01-.558 9.236c-.239 1.438-2.55.833-2.311-.606a39 39 0 00.478-8.63c-.08-1.438 2.311-1.438 2.39 0z"
                  data-name="Trazado 332"
                  transform="translate(-1181.427 -1015.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 594" transform="translate(213.346 107.558)">
              <g data-name="Grupo 593">
                <path
                  fill="#1f4049"
                  d="M1192.648 1017.354c-.159 2.574-.319 5.072-.558 7.646-.08 1.438-2.47 1.438-2.39 0 .159-2.574.319-5.072.558-7.646.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 333"
                  transform="translate(-1189.698 -1016.275)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 596" transform="translate(208.162 107.936)">
              <g data-name="Grupo 595">
                <path
                  fill="#1f4049"
                  d="M1199.153 1017.854c-.159 1.817-.319 3.71-.558 5.527-.159 1.438-2.55 1.438-2.39 0 .159-1.817.319-3.71.558-5.527.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 334"
                  transform="translate(-1196.197 -1016.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 598" transform="translate(186.654 106.271)">
              <g data-name="Grupo 597">
                <path
                  fill="#1f4049"
                  d="M1226.1 1015.654c-.239 3.1-.478 6.208-.717 9.388-.08 1.438-2.47 1.438-2.391 0 .239-3.1.478-6.208.717-9.388.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 335"
                  transform="translate(-1222.99 -1014.575)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 600" transform="translate(171.834 106.696)">
              <g data-name="Grupo 599">
                <path
                  fill="#1f4049"
                  d="M1244.748 1016.245c-.159 2.574-.319 5.072-.558 7.646-.08 1.438-2.47 1.438-2.39 0 .159-2.574.319-5.072.557-7.646.08-1.438 2.47-1.514 2.39 0z"
                  data-name="Trazado 336"
                  transform="translate(-1241.798 -1015.137)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 602" transform="translate(160.345 107.057)">
              <g data-name="Grupo 601">
                <path
                  fill="#1f4049"
                  d="M1258.787 1016.436a33.248 33.248 0 01.319 7.949c-.159 1.439-2.55 1.439-2.39 0a28.259 28.259 0 00-.239-7.343c-.239-1.438 2.072-2.044 2.311-.606z"
                  data-name="Trazado 337"
                  transform="translate(-1256.459 -1015.614)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 604" transform="translate(263.065 117.277)">
              <g data-name="Grupo 603">
                <path
                  fill="#1f4049"
                  d="M1130.078 1030.542a115.392 115.392 0 00-1.2 12.87c-.08 1.438-2.47 1.438-2.39 0a108.657 108.657 0 011.275-13.476c.159-1.438 2.47-.833 2.311.606z"
                  data-name="Trazado 338"
                  transform="translate(-1126.49 -1029.114)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 606" transform="translate(256.344 117.702)">
              <g data-name="Grupo 605">
                <path
                  fill="#1f4049"
                  d="M1138.423 1030.754a34.038 34.038 0 01-.717 11.356c-.319 1.438-2.63.833-2.311-.606a32.508 32.508 0 00.637-10.75c-.159-1.439 2.231-1.439 2.39 0z"
                  data-name="Trazado 339"
                  transform="translate(-1135.365 -1029.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 608" transform="translate(237.889 117.324)">
              <g data-name="Grupo 607">
                <path
                  fill="#1f4049"
                  d="M1161.839 1030.254a101.733 101.733 0 00-.558 11.053 1.2 1.2 0 01-2.39 0 102.708 102.708 0 01.558-11.053c.16-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 340"
                  transform="translate(-1158.891 -1029.175)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 610" transform="translate(204.803 116.462)">
              <g data-name="Grupo 609">
                <path
                  fill="#1f4049"
                  d="M1203.358 1029.145a97.061 97.061 0 00-.558 12.719 1.2 1.2 0 01-2.39 0 97.083 97.083 0 01.558-12.719c.159-1.438 2.55-1.514 2.39 0z"
                  data-name="Trazado 341"
                  transform="translate(-1200.391 -1028.037)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 612" transform="translate(198.179 118.554)">
              <g data-name="Grupo 611">
                <path
                  fill="#1f4049"
                  d="M1211.52 1031.936a32.984 32.984 0 01-.876 10.069c-.319 1.439-2.63.833-2.311-.606a31.522 31.522 0 00.8-9.463c-.08-1.514 2.311-1.514 2.39 0z"
                  data-name="Trazado 342"
                  transform="translate(-1208.302 -1030.8)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 614" transform="translate(191.429 117.702)">
              <g data-name="Grupo 613">
                <path
                  fill="#1f4049"
                  d="M1220.058 1030.754a60.75 60.75 0 01-.4 11.431c-.159 1.438-2.55 1.438-2.39 0a54.911 54.911 0 00.4-11.431c-.08-1.439 2.311-1.439 2.39 0z"
                  data-name="Trazado 343"
                  transform="translate(-1217.262 -1029.675)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 616" transform="translate(169.125 118.157)">
              <g data-name="Grupo 615">
                <path
                  fill="#1f4049"
                  d="M1248.148 1031.354c-.159 3.255-.4 6.511-.558 9.766-.08 1.439-2.47 1.439-2.39 0 .159-3.255.4-6.511.558-9.766.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 344"
                  transform="translate(-1245.198 -1030.275)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 618" transform="translate(246.415 132.162)">
              <g data-name="Grupo 617">
                <path
                  fill="#1f4049"
                  d="M1151.29 1049.854v11.432a1.2 1.2 0 01-2.39 0v-11.432a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 345"
                  transform="translate(-1148.9 -1048.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 620" transform="translate(228.034 131.708)">
              <g data-name="Grupo 619">
                <path
                  fill="#1f4049"
                  d="M1174.254 1049.254a74.04 74.04 0 00-.239 11.886c.08 1.438-2.311 1.438-2.39 0a74.068 74.068 0 01.239-11.886c.159-1.438 2.55-1.438 2.39 0z"
                  data-name="Trazado 346"
                  transform="translate(-1171.49 -1048.175)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 622" transform="translate(217.006 132.162)">
              <g data-name="Grupo 621">
                <path
                  fill="#1f4049"
                  d="M1187.976 1049.854a58.732 58.732 0 01-.319 10.6c-.159 1.438-2.55 1.438-2.391 0a58.92 58.92 0 00.319-10.6c-.08-1.438 2.311-1.438 2.391 0z"
                  data-name="Trazado 347"
                  transform="translate(-1185.259 -1048.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 624" transform="translate(183.865 132.162)">
              <g data-name="Grupo 623">
                <path
                  fill="#1f4049"
                  d="M1229.647 1049.854c-.159 3.71-.4 7.344-.558 11.053-.08 1.438-2.47 1.438-2.39 0 .159-3.71.4-7.344.557-11.053.08-1.438 2.47-1.438 2.39 0z"
                  data-name="Trazado 348"
                  transform="translate(-1226.698 -1048.775)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 626" transform="translate(176.148 133.403)">
              <g data-name="Grupo 625">
                <path
                  fill="#1f4049"
                  d="M1239.242 1051.842a25.288 25.288 0 00.08 9.161c.319 1.438-1.992 2.044-2.311.606a26.727 26.727 0 01-.08-10.372c.319-1.439 2.63-.833 2.311.605z"
                  data-name="Trazado 349"
                  transform="translate(-1236.462 -1050.414)"
                ></path>
              </g>
            </g>
          </g>
          <g transform="translate(887.903 91.45)">
            <g data-name="Grupo 628" transform="translate(81.065 52.29)">
              <g data-name="Grupo 627">
                <path
                  fill="#1f4049"
                  d="M471.5 161.338c1.514 8.858-2.629 17.185-8.127 24.075-5.577 6.965-13.147 12.643-22.469 13.93-1.514.227-2.151-1.968-.637-2.2 8.047-1.06 14.74-5.6 19.84-11.432 5.657-6.511 10.6-14.99 9.083-23.7-.239-1.514 2.072-2.12 2.311-.681z"
                  data-name="Trazado 350"
                  transform="translate(-439.405 -160.52)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 630" transform="translate(102.419 47.553)">
              <g data-name="Grupo 629">
                <path
                  fill="#1f4049"
                  d="M448.458 159.817a19.251 19.251 0 00-7.808-3.331c-1.514-.3-.876-2.5.637-2.2a21.909 21.909 0 018.844 3.861c1.2.984-.478 2.574-1.673 1.666z"
                  data-name="Trazado 351"
                  transform="translate(-439.784 -154.262)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 632" transform="translate(73.34 47.689)">
              <g data-name="Grupo 631">
                <path
                  fill="#1f4049"
                  d="M481.159 156.681c-7.091 1.817-13.545 9.69-17.609 15.141a64.716 64.716 0 00-9.561 18.548c-.478 1.363-2.789.833-2.311-.606a65.606 65.606 0 0111.314-21.046c4.3-5.375 10.438-12.416 17.529-14.233a1.145 1.145 0 11.637 2.2z"
                  data-name="Trazado 352"
                  transform="translate(-451.614 -154.442)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 634" transform="translate(73.916 83.227)">
              <g data-name="Grupo 633">
                <path
                  fill="#1f4049"
                  d="M484.713 209.421a23.252 23.252 0 01-7.888-6.056c-.956-1.136.717-2.725 1.673-1.59a21.1 21.1 0 007.33 5.678c1.514.681.239 2.574-1.115 1.968z"
                  data-name="Trazado 353"
                  transform="translate(-476.54 -201.384)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 636" transform="translate(74.899 49.001)">
              <g data-name="Grupo 635">
                <path
                  fill="#1f4049"
                  d="M479.539 157.254c.239 8.706-4.86 17.412-10.279 24.15-5.1 6.359-12.27 11.2-21.035 11.053a1.136 1.136 0 010-2.271c8.844.151 15.7-5.3 20.477-11.886 4.382-6.132 8.605-13.4 8.446-21.046a1.2 1.2 0 012.39 0z"
                  data-name="Trazado 354"
                  transform="translate(-447.09 -156.175)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 638" transform="translate(104.999 58.142)">
              <g data-name="Grupo 637">
                <path
                  fill="#1f4049"
                  d="M446.34 173.587a13.779 13.779 0 00-4.3-3.255c-1.355-.606-.159-2.574 1.2-1.968a13.624 13.624 0 014.781 3.558c.956 1.136-.717 2.8-1.673 1.666z"
                  data-name="Trazado 355"
                  transform="translate(-441.442 -168.249)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 640" transform="translate(105.447 53.821)">
              <g data-name="Grupo 639">
                <path
                  fill="#1f4049"
                  d="M445.886 167.053a14.162 14.162 0 00-4.86-2.271 1.145 1.145 0 11.637-2.2 18.374 18.374 0 015.418 2.5c1.2.833.08 2.8-1.2 1.968z"
                  data-name="Trazado 356"
                  transform="translate(-440.16 -162.542)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 642" transform="translate(97.216 71.763)">
              <g data-name="Grupo 641">
                <path
                  fill="#1f4049"
                  d="M455.753 191.964c-1.673-1.287-3.426-2.574-5.1-3.861-1.2-.908.478-2.5 1.673-1.59 1.673 1.287 3.426 2.574 5.1 3.861 1.275.908-.478 2.5-1.673 1.59z"
                  data-name="Trazado 357"
                  transform="translate(-450.242 -186.242)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 644" transform="translate(93.304 77.39)">
              <g data-name="Grupo 643">
                <path
                  fill="#1f4049"
                  d="M461.216 198.766l-4.064-2.953a1.159 1.159 0 01-.4-1.59 1.3 1.3 0 011.673-.379l4.064 2.953a1.159 1.159 0 01.4 1.59 1.3 1.3 0 01-1.673.379z"
                  data-name="Trazado 358"
                  transform="translate(-456.574 -193.674)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 646" transform="translate(84.989 82.445)">
              <g data-name="Grupo 645">
                <path
                  fill="#1f4049"
                  d="M471.449 206.066c-1.355-1.287-2.789-2.5-4.143-3.785-1.115-.984.558-2.65 1.673-1.59 1.355 1.287 2.789 2.5 4.143 3.785 1.115.984-.558 2.65-1.673 1.59z"
                  data-name="Trazado 359"
                  transform="translate(-466.938 -200.35)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 648" transform="translate(85.908 52.974)">
              <g data-name="Grupo 647">
                <path
                  fill="#1f4049"
                  d="M469.32 163.223c-1.514 1.287-2.948 2.65-4.462 3.937a7.94 7.94 0 00.159-1.363c1.594 2.423 2.47 5.527.319 7.949a5.467 5.467 0 01-3.028 1.741 11.192 11.192 0 01-1.594 0c-.4-.076-.717-.227-1.115-.3-4.382-.681-5.179.908-2.311 4.694 1.434.53.8 2.725-.637 2.2-2.948-1.06-5.02-4.164-3.267-7.041a5.213 5.213 0 014.064-2.423 12.379 12.379 0 011.673.076c1.912.984 3.586.227 5.02-2.12a5.816 5.816 0 00-1.275-3.407 1.22 1.22 0 01.159-1.363c1.514-1.287 2.948-2.65 4.462-3.937 1.275-1.211 2.948.379 1.833 1.363z"
                  data-name="Trazado 360"
                  transform="translate(-452.741 -161.423)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 650" transform="translate(82.57 71.048)">
              <g data-name="Grupo 649">
                <path
                  fill="#1f4049"
                  d="M476.316 187.268c-1.355 1.514-2.629 2.953-3.984 4.467-.956 1.136-2.709-.53-1.673-1.59 1.355-1.514 2.629-2.953 3.984-4.467.956-1.136 2.629.53 1.673 1.59z"
                  data-name="Trazado 361"
                  transform="translate(-470.342 -185.297)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 652" transform="translate(4.632)">
              <g data-name="Grupo 651">
                <path
                  fill="#1f4049"
                  d="M554.974 129.189c7.012-5.224 11.314-20.062 5.418-27.1-6.932-8.1-20.716-11.583-28.445-2.953-6.454 7.192-6.852 18.472-1.992 26.573 2.948 4.921 7.251 7.268 13.227 7.343a18.723 18.723 0 0013.7-5.451c1.036-1.06 2.709.53 1.673 1.59-5.817 5.905-16.254 8.1-23.983 4.315-8.048-4.012-11.075-14.914-10.119-22.863.956-8.025 6.135-16.655 14.9-18.775 8.446-2.044 20.955 3.71 24.7 11.2 2.311 4.618 1.434 10.145.239 14.99-1.195 4.845-3.267 9.463-7.49 12.567-1.275 1.06-3.028-.53-1.833-1.438z"
                  data-name="Trazado 362"
                  transform="translate(-524.287 -91.45)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 654" transform="translate(21.073 8.071)">
              <g data-name="Grupo 653">
                <path
                  fill="#1f4049"
                  d="M547.009 103.314c0-.076.08-.227.08-.3.159.454.4.833.558 1.287.717-.227.8-.151.319.454a12.794 12.794 0 00-1.115 2.347c-.239-.454-.558-.908-.8-1.363 3.107.908 7.012 2.953 5.9 6.662a3.552 3.552 0 01-2.311 2.5c-.956.379-1.514 0-2.47-.076a3.876 3.876 0 00-4.382.757c-1.2 3.331-.239 5 2.948 5.224a1.173 1.173 0 011.036 1.741 24.9 24.9 0 00-1.753 3.937c-.478 1.363-2.789.833-2.311-.606a18.817 18.817 0 011.992-4.467c.319.606.717 1.136 1.036 1.741-3.825-.076-7.49-3.482-5.9-7.268a5.978 5.978 0 014.3-3.482c1.115-.227 2.072.227 3.107.227 1.992 0 2.55-.379 1.514-2.2-.956-1.666-1.514-1.893-3.346-2.423a1.109 1.109 0 01-.8-1.363c.558-1.514 1.116-3.634 2.709-4.391a1.326 1.326 0 011.2 0c.08.076.239.151.319.227a1.2 1.2 0 01.558 1.287c0 .076-.08.227-.08.3-.319 1.211-2.629.606-2.311-.757z"
                  data-name="Trazado 363"
                  transform="translate(-539.456 -102.111)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 656" transform="translate(0 .153)">
              <g data-name="Grupo 655">
                <path
                  fill="#1f4049"
                  d="M574.643 94.338c-12.111-2.952-18.405 9.462-18.643 18.927-.08 4.315.319 9.16 3.028 12.794 2.948 3.937 8.207 5.148 12.589 6.965 1.434.606.159 2.574-1.2 1.968-5.259-2.2-11-3.634-14.1-8.706-2.948-4.845-3.187-11.28-2.47-16.731 1.275-9.993 9.641-20.289 21.354-17.412a1.135 1.135 0 11-.558 2.2z"
                  data-name="Trazado 364"
                  transform="translate(-553.507 -91.652)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 658" transform="translate(3.618 30.595)">
              <g data-name="Grupo 657">
                <path
                  fill="#1f4049"
                  d="M574.326 134.768l-3.346-.681c-1.514-.3-.876-2.5.637-2.2l3.346.681c1.514.3.877 2.5-.637 2.2z"
                  data-name="Trazado 365"
                  transform="translate(-570.114 -131.862)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 660" transform="translate(.408 21.326)">
              <g data-name="Grupo 659">
                <path
                  fill="#1f4049"
                  d="M578.339 123.087c-1.275-.379-2.55-.757-3.745-1.211a1.145 1.145 0 01.637-2.2c1.275.379 2.55.757 3.745 1.211a1.145 1.145 0 01-.637 2.2z"
                  data-name="Trazado 366"
                  transform="translate(-573.785 -119.619)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 662" transform="translate(2.451 15.444)">
              <g data-name="Grupo 661">
                <path
                  fill="#1f4049"
                  d="M576.057 114.462c-.8-.151-1.673-.3-2.47-.454a1.078 1.078 0 01-.8-1.363 1.149 1.149 0 011.434-.757c.8.151 1.673.3 2.47.454a1.078 1.078 0 01.8 1.363 1.215 1.215 0 01-1.434.757z"
                  data-name="Trazado 367"
                  transform="translate(-572.749 -111.849)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 664" transform="translate(5.348 5.957)">
              <g data-name="Grupo 663">
                <path
                  fill="#1f4049"
                  d="M572.7 101.879a9.515 9.515 0 01-4.382-.3 1.145 1.145 0 01.637-2.2 7.271 7.271 0 003.107.3 1.215 1.215 0 011.434.757 1.1 1.1 0 01-.8 1.438z"
                  data-name="Trazado 368"
                  transform="translate(-567.512 -99.319)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 666" transform="translate(1.582 108.941)">
              <g data-name="Grupo 665">
                <path
                  fill="#1f4049"
                  d="M549.473 278.162a24.019 24.019 0 0017.37-22.712c.239-11.583-10.358-21.5-22.469-16.353-10.2 4.315-14.1 15.671-14.422 25.589-.159 4.769.717 10.523 5.259 13.324 4.7 2.953 10.836 1.817 15.856.3a1.145 1.145 0 01.637 2.2c-8.127 2.5-18.406 2.65-22.469-5.981-3.9-8.252-1.434-20.062 3.028-27.633 4.462-7.646 14.023-13.551 23.505-10.9 9.88 2.8 14.342 13.021 13.227 22.106a26.348 26.348 0 01-18.964 22.333 1.17 1.17 0 01-.558-2.271z"
                  data-name="Trazado 369"
                  transform="translate(-527.29 -235.35)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 668" transform="translate(14.562 116.372)">
              <g data-name="Grupo 667">
                <path
                  fill="#1f4049"
                  d="M559.453 247.009a20.177 20.177 0 00-4.462 6.738l-1.434-1.363c3.825-.757 5.817 2.347 5.578 5.678-.08 1.136-.319 2.5-1.514 3.1-.876.454-2.151.151-3.028.151a17.171 17.171 0 00-2.789-.076c-4.223.3-4.781 2.044-1.753 5.224.8.076 1.594.908 1.036 1.741a55.677 55.677 0 00-3.9 6.586c-.637 1.287-2.709.151-2.072-1.136a69.152 69.152 0 013.9-6.586c.319.606.717 1.136 1.036 1.741-3.347-.379-6.135-3.331-4.382-6.586a6.38 6.38 0 013.825-2.8 11.58 11.58 0 013.586-.379c.956.076 1.833.151 2.789.227 1.514-1.741.956-3.255-1.753-4.542-.8.151-1.833-.53-1.434-1.363a22.1 22.1 0 015.1-7.722 1.083 1.083 0 111.673 1.363z"
                  data-name="Trazado 370"
                  transform="translate(-544.991 -245.165)"
                ></path>
              </g>
            </g>
            <g data-name="Grupo 670" transform="translate(8.56 112.872)">
              <g data-name="Grupo 669">
                <path
                  fill="#1f4049"
                  d="M551.164 240.813c10.279 8.4 13.466 22.863 5.737 33.841a25.5 25.5 0 01-33.943 6.814 1.152 1.152 0 011.2-1.968c10.677 6.511 24.78 3.407 31.314-6.965 6.374-10.145 3.108-22.636-6.056-30.131-1.115-.908.558-2.5 1.753-1.59z"
                  data-name="Trazado 371"
                  transform="translate(-522.413 -240.542)"
                ></path>
              </g>
            </g>
            <path
              fill="#1f4049"
              d="M540.94 239.6a31.71 31.71 0 013.028 14.687c-.08 1.968-.637 12.946-9 20.365-5.737 5.072-11.792 5.375-11.553 7.116.319 1.893 7.808 3.407 14.581 1.817a24.522 24.522 0 0016.888-14.685c.717-1.893 3.586-9.463-.4-17.715A23.593 23.593 0 00540.94 239.6z"
              data-name="Trazado 372"
              opacity="0.14"
              transform="translate(-510.003 -127.441)"
            ></path>
            <path
              fill="#1f4049"
              d="M471.883 157.3a46.7 46.7 0 01-3.187 12.416c-2.072 4.845-5.657 13.551-14.979 18.548a30.743 30.743 0 01-13.067 3.482 12.644 12.644 0 004.462 4.694 13.924 13.924 0 004.3 1.666 44.148 44.148 0 0013.306-6.284c3.267-2.347 10.836-7.873 14.1-17.942a31.062 31.062 0 001.036-14.687c-1.907-.682-3.899-1.287-5.971-1.893z"
              data-name="Trazado 373"
              opacity="0.15"
              transform="translate(-365.81 -106.447)"
            ></path>
            <path
              fill="#3f3f3f"
              d="M575.365 92.944a23.159 23.159 0 00-9.4 8.555c-4.064 6.586-3.187 13.1-2.789 16.277.4 2.877.956 7.116 4.3 11.2a18.794 18.794 0 005.179 4.467 16.3 16.3 0 01-9.88-3.861c-2.868-2.574-3.745-5.527-4.7-8.782a26.662 26.662 0 01-.876-10.75 24.238 24.238 0 012.789-8.328c1.514-2.725 3.506-6.208 7.729-7.949a14.588 14.588 0 017.648-.829z"
              data-name="Trazado 374"
              opacity="0.14"
              transform="translate(-556.584 -91.77)"
            ></path>
          </g>
          <g transform="translate(637.893 115.84)">
            <g transform="translate(104.94 294.976)">
              <path
                fill="#1f4049"
                d="M585.827 909.9q3.466 25.21 6.932 50.5 66.571 13.854 65.894 19.154-.956 6.473-99.837.53c-2.868-22.56-5.657-45.121-8.526-67.606 11.872-.837 23.665-1.745 35.537-2.578z"
                data-name="Trazado 375"
                transform="translate(-488.464 -609.65)"
              ></path>
              <path
                fill="#3fd86d"
                d="M617.605 521.855a170.917 170.917 0 00-.159 34.522 177.85 177.85 0 0010.279 44.515c16.971 47.241 25.178 109.244 29 138.618a610.83 610.83 0 015.02 90.7 63.477 63.477 0 0038.724 6.586 62.34 62.34 0 0033.067-15.9 691.888 691.888 0 00-8.605-137.482C719.2 648.435 710.989 613 701.586 577.272a19150.724 19150.724 0 00-16.812-63.972c-22.31 2.8-44.774 5.678-67.169 8.555z"
                data-name="Trazado 376"
                transform="translate(-616.653 -513.3)"
              ></path>
              <path
                fill="#3f3f3f"
                d="M649.745 554.7c2.629 9.917 6.852 24.756 12.589 42.471 18.963 57.991 36.015 88.122 48.843 120.373 11.474 28.768 24.222 71.012 27.887 127.338a57.6 57.6 0 01-17.37 2.5 58.708 58.708 0 01-27.888-7.495c-.558-37.247-3.107-68.514-5.816-92.361-2.151-19.229-4.3-38-9.482-62.912-6.215-29.98-9.322-44.969-15.776-62.458-4.382-11.659-9.641-23.545-12.111-41.941a167.226 167.226 0 01-.876-25.515z"
                data-name="Trazado 377"
                opacity="0.13"
                transform="translate(-647.996 -523.358)"
              ></path>
              <path
                fill="#3f3f3f"
                d="M660.8 740.1q8.725 20.327 16.812 42.471a899.607 899.607 0 0132.588 109.85 63.771 63.771 0 01-15.776-.53 67.726 67.726 0 01-21.035-6.965q.6-22.6-.558-47.468A626.643 626.643 0 00660.8 740.1z"
                data-name="Trazado 378"
                opacity="0.19"
                transform="translate(-628.056 -568.399)"
              ></path>
            </g>
            <g transform="translate(0 287.33)">
              <path
                fill="#1f4049"
                d="M840.315 899.3c-4.064 12.643-8.127 25.21-12.191 37.853 31.792 21.349 46.692 33.841 44.62 37.323q-3.944 6.7-88.682-29.3c8.127-21.5 16.254-43.077 24.461-64.577 10.518 6.209 21.195 12.417 31.792 18.701z"
                data-name="Trazado 379"
                transform="translate(-784.062 -594.885)"
              ></path>
              <path
                fill="#3fd86d"
                d="M788.681 503.6a179.977 179.977 0 00-12.589 32.4 175.094 175.094 0 00-6.295 45.121c-.956 49.966-15.537 110.909-22.39 139.678a609.672 609.672 0 01-27.807 86.912 62.294 62.294 0 0034.1 18.775 63.118 63.118 0 0036.732-4.24 712.434 712.434 0 0041.273-132.031c7.171-34.749 12.111-70.709 16.175-107.351q3.586-32.819 7.171-65.561-33.224-6.927-66.37-13.703z"
                data-name="Trazado 380"
                transform="translate(-714.819 -503.297)"
              ></path>
              <path
                fill="#3f3f3f"
                d="M861.081 512.209q-16.135 64.161-32.031 128.322-22.95 92.55-45.177 185.253a54.954 54.954 0 01-12.589-4.012 55.616 55.616 0 01-18.884-14.006c5.5-13.854 12.191-32.175 18.884-53.9a705.225 705.225 0 0021.516-89.412c4.382-25.589 7.012-40.957 7.888-62.912.558-14.838-.159-22.182 2.072-37.474a222.476 222.476 0 0111.075-42.925 256.995 256.995 0 017.33-17.942q19.835 4.541 39.916 9.008z"
                data-name="Trazado 381"
                opacity="0.17"
                transform="translate(-746.982 -503.2)"
              ></path>
              <path
                fill="#3f3f3f"
                d="M875.841 612.8a943.43 943.43 0 01-17.848 187.3q-5.02 25.324-11.075 48.906a42.157 42.157 0 01-7.888-3.028 45.564 45.564 0 01-14.741-11.507c8.207-21.879 16.1-45.348 23.107-70.407A866.311 866.311 0 00875.841 612.8z"
                data-name="Trazado 382"
                opacity="0.15"
                transform="translate(-819.031 -529.826)"
              ></path>
            </g>
            <g data-name="torso" transform="translate(69.875 115.098)">
              <path
                fill="#fff"
                stroke="#1f4049"
                strokeMiterlimit="10"
                strokeWidth="2"
                d="M93.865 14.384c11.075 8.479 15.936 19 18.8 25.286 9 19.608 7.091 37.55 5.976 47.089-2.868 24.453-11.713 28.466-16.1 51.48-2.311 12.34-3.187 28.617 1.833 48.906-3.426 2.877-29.8 24.3-64.779 17.867A75.152 75.152 0 01.553 184.496a763.458 763.458 0 014.63-118.707C9.247 31.343 13.47 16.58 26.776 8.025 45.423-3.941 75.539.378 93.865 14.384z"
                data-name="Trazado 383"
              ></path>
              <path
                fill="#3f3f3f"
                d="M792.89 275.7a229.949 229.949 0 00-16.255 39.443c-12.908 42.017-10.279 76.766-8.924 88.879a220.21 220.21 0 0023.665 77.9 73.642 73.642 0 01-21.035-2.5 72.6 72.6 0 01-32.589-19c-.717-26.119-.478-48.073 0-64.426 0 0 .637-24 5.259-63.442 3.187-27.406 5.418-36.339 13.147-43.985 11.315-11.052 27.728-12.718 36.732-12.869z"
                data-name="Trazado 384"
                opacity="0.14"
                transform="translate(-736.634 -275.7)"
              ></path>
              <path
                fill="#3f3f3f"
                d="M768.744 323.2c1.355.076-.319 19.381 1.594 55.417 2.47 46.635 8.127 65.789 9.96 71.921a198.573 198.573 0 0017.37 39.973 57.325 57.325 0 01-16.254-3.482 56.071 56.071 0 01-22.629-15.974c-.478-15.065-.717-37.172.558-63.9 2.07-43.301 7.489-84.107 9.401-83.955z"
                data-name="Trazado 385"
                opacity="0.17"
                transform="translate(-758.223 -287.239)"
              ></path>
            </g>
            <g transform="translate(75.61 165.968)">
              <path
                fill="#fff"
                d="M755.384 359.926a44.375 44.375 0 0114.262 33.765c0 9.993-2.869 17.185-5.976 25.21a107.1 107.1 0 01-11.792 21.879 21.844 21.844 0 01-5.5.908 19.68 19.68 0 01-5.339-.681c.8-4.769 1.514-9.463 2.311-14.233-1.354.3-3.426.681-5.976 1.06a97.643 97.643 0 01-27.648-.227c-2.709-.379-6.534-.908-11.075-1.968.4 2.877.8 5.678 1.116 8.555-4.382 2.347-6.295 1.438-6.932 1.06-1.275-.757-1.434-2.12-3.028-6.814-.717-2.2-1.434-3.937-1.833-5.072-1.753-.681-3.506-1.287-5.339-1.968.478 1.59.956 3.18 1.354 4.845a15.847 15.847 0 01-6.215.227 16.056 16.056 0 01-3.665-1.06c-1.036-3.558-2.151-7.116-3.187-10.75a19.532 19.532 0 00-8.047-5.224c-2.39-.833-3.187-.53-5.1-1.514a11.971 11.971 0 01-5.5-7.041 11.32 11.32 0 01.478-8.328c1.036-2.044 1.753-1.741 3.9-4.845 1.833-2.574 1.753-3.482 3.426-6.359a36.912 36.912 0 014.382-5.678c-1.514-4.24-2.869-6.208-3.9-7.192a2.659 2.659 0 01-.956-1.741c0-.757.717-1.438 1.833-2.2 2.709-1.817 4.382-2.877 6.693-2.65a8.237 8.237 0 015.1 3.028 43.823 43.823 0 015.5-7.192 47.821 47.821 0 0121.912-12.719c16.015-4.24 29.72 1.363 38.007 4.845a49.98 49.98 0 0116.734 10.074z"
                data-name="Trazado 386"
                transform="translate(-650.921 -343.039)"
              ></path>
              <g data-name="Grupo 672" transform="translate(21.29)">
                <g data-name="Grupo 671">
                  <path
                    fill="#1f4049"
                    d="M741.645 417.545c4.781-12.264 6.693-25.816 2.709-38.534a43.059 43.059 0 00-24.382-26.8c-12.111-5.3-26.772-9.16-39.919-5.981a43.391 43.391 0 00-27.17 19.759c-.717 1.287-2.789.151-2.072-1.136 9.8-16.655 29.959-24.832 49.4-21.046 11 2.12 22.948 5.829 31.632 12.719a46.188 46.188 0 0115.617 24.756c3.028 12.34 1.116 25.134-3.506 36.869-.558 1.287-2.869.757-2.311-.606z"
                    data-name="Trazado 387"
                    transform="translate(-650.663 -342.894)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 674" transform="translate(30.9 31.44)">
                <g data-name="Grupo 673">
                  <path
                    fill="#1f4049"
                    d="M755.61 398.411c.319-3.1.159-10.9-4.223-11.507-2.709-.379-4.462 2.953-7.49 2.725-1.514-.151-1.514-2.423 0-2.271 2.072.227 3.506-1.817 5.338-2.574a4.719 4.719 0 014.86.757c3.665 2.877 4.223 8.706 3.825 12.87-.08 1.438-2.47 1.438-2.311 0z"
                    data-name="Trazado 388"
                    transform="translate(-742.762 -384.424)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 676" transform="translate(25.751 32.227)">
                <g data-name="Grupo 675">
                  <path
                    fill="#1f4049"
                    d="M751.223 387.989c-4.542-1.817-7.49 2.877-3.187 5.148a32.258 32.258 0 004.781 1.741c3.187 1.06 6.454 2.12 9.641 3.18a1.145 1.145 0 01-.637 2.2c-4.143-1.363-8.366-2.65-12.51-4.164-2.151-.757-4.7-1.817-5.657-4.012-2.311-5.375 4.462-7.8 8.685-6.057 1.434.53.239 2.5-1.115 1.968z"
                    data-name="Trazado 389"
                    transform="translate(-743.185 -385.463)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 678" transform="translate(15.051 19.139)">
                <g data-name="Grupo 677">
                  <path
                    fill="#1f4049"
                    d="M775.364 368.345c2.151 1.211 4.621 3.1 3.984 5.829a3.617 3.617 0 01-2.151 2.5 32.923 32.923 0 00-4.94 2.423c-1.2.909-2.868-.681-1.673-1.59a22 22 0 014.542-2.5c1.2-.53 2.231-1.06 1.594-2.5a5.618 5.618 0 00-2.629-2.2c-1.275-.757-.08-2.725 1.275-1.968z"
                    data-name="Trazado 390"
                    transform="translate(-770.172 -368.175)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 680" transform="translate(7.666 23.227)">
                <g data-name="Grupo 679">
                  <path
                    fill="#1f4049"
                    d="M787.334 377.3c.637 3.861-2.072 8.328-6.773 7.419a5.644 5.644 0 01-3.9-3.331c-.876-1.893-1.036-4.542-3.028-5.678a1.152 1.152 0 011.2-1.968c2.072 1.211 2.709 3.18 3.426 5.224.478 1.363 1.036 3.028 2.629 3.482 2.868.833 4.542-2.271 4.143-4.542-.159-1.438 2.151-2.12 2.311-.606z"
                    data-name="Trazado 391"
                    transform="translate(-773.084 -373.575)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 682" transform="translate(7.647 18.322)">
                <g data-name="Grupo 681">
                  <path
                    fill="#1f4049"
                    d="M785.408 370.809c-3.426-3.558-8.048.076-10.518 2.65-1.036 1.06-2.709-.53-1.673-1.59 3.426-3.558 9.561-7.192 13.864-2.65 1.036 1.06-.637 2.65-1.673 1.59z"
                    data-name="Trazado 392"
                    transform="translate(-772.891 -367.096)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 684" transform="translate(21.536 43.962)">
                <g data-name="Grupo 683">
                  <path
                    fill="#1f4049"
                    d="M769.564 403.565a.167.167 0 00.159-.151c.08-.076.08-.151 0-.076v-.303c.159.076-.159 0 .08.076h-.159c-.08 0-.08 0-.159.076.08-.076.08 0 0 0-.08.076-.159.076 0 0-.08.076-.08.151 0 .076v-.076c.08.151 0 .151 0 0 .08.076.08.151 0 0l.159.151c-.159-.151.159.076 0 0 .08 0 .159.076.239.076-.08.076-.08 0 0 0 1.275-.757 2.55 1.211 1.2 1.968a2.73 2.73 0 01-3.665-.984 2.281 2.281 0 011.594-3.331 2.487 2.487 0 111.354 4.769c-1.673.3-2.311-1.893-.8-2.271z"
                    data-name="Trazado 393"
                    transform="translate(-767.112 -400.963)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 686" transform="translate(11.173 38.395)">
                <g data-name="Grupo 685">
                  <path
                    fill="#1f4049"
                    d="M783.728 395.268a.789.789 0 00-.4.3c.08-.151-.08.227 0 .076v.076c0-.227.08.3 0 0-.08-.227.159.227 0 0-.08-.151.159.151.08.076a.509.509 0 00.558.151 1.1 1.1 0 00.319-.227c0-.076.08-.076.08-.151-.08.227 0-.3 0-.076 0 .224-.08-.227 0 0s-.08-.151 0-.076c.08.151 0 0-.08-.076a.3.3 0 00-.239-.076c.159.076-.239 0-.319 0a1.114 1.114 0 011.434.757 1.048 1.048 0 01-.8 1.363 1.968 1.968 0 01-2.311-1.363 1.853 1.853 0 011.275-2.347 1.928 1.928 0 012.311 1.363 1.884 1.884 0 01-1.275 2.347 1.215 1.215 0 01-1.434-.757 1.109 1.109 0 01.8-1.363z"
                    data-name="Trazado 394"
                    transform="translate(-781.988 -393.61)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 688" transform="translate(6.827 31.193)">
                <g data-name="Grupo 687">
                  <path
                    fill="#1f4049"
                    d="M789.851 386.068a20.331 20.331 0 00-5.02 10.069c-.319 1.438-2.629.833-2.311-.606a22.847 22.847 0 015.657-11.053c1.036-1.136 2.709.53 1.673 1.59z"
                    data-name="Trazado 395"
                    transform="translate(-782.491 -384.097)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 690" transform="translate(3.123 42.731)">
                <g data-name="Grupo 689">
                  <path
                    fill="#1f4049"
                    d="M794.986 401.278a8.282 8.282 0 01-3.745 1.893c-1.514.3-2.151-1.893-.637-2.2a5.942 5.942 0 002.709-1.287c1.115-1.06 2.789.53 1.673 1.59z"
                    data-name="Trazado 396"
                    transform="translate(-789.738 -399.338)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 692" transform="translate(.01 45.042)">
                <g data-name="Grupo 691">
                  <path
                    fill="#1f4049"
                    d="M782.858 402.4c5.657.53 10.518 3.634 12.51 8.858 1.673 4.467 1.036 11.053-4.542 12.643-4.86 1.363-9.322-1.968-11.075-6.132-1.753-4.164-2.311-12.416 2.47-15.065a1.152 1.152 0 111.2 1.968c-3.267 1.817-2.629 8.706-1.673 11.583 1.115 3.407 4.382 6.662 8.446 5.375 4.7-1.514 4.143-7.571 2.311-10.977a12.171 12.171 0 00-9.561-5.905c-1.594-.227-1.673-2.5-.08-2.347z"
                    data-name="Trazado 397"
                    transform="translate(-778.481 -402.39)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 694" transform="translate(10.283 55.724)">
                <g data-name="Grupo 693">
                  <path
                    fill="#1f4049"
                    d="M784.8 418.09v-.454a1.2 1.2 0 012.39 0v.454a1.2 1.2 0 01-1.2 1.136 1.146 1.146 0 01-1.2-1.136z"
                    data-name="Trazado 398"
                    transform="translate(-784.8 -416.5)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 696" transform="translate(3.579 52.355)">
                <g data-name="Grupo 695">
                  <path
                    fill="#1f4049"
                    d="M793.079 412.845a2.031 2.031 0 00.4-.454 1.2 1.2 0 011.673 0 1.061 1.061 0 010 1.59 2.035 2.035 0 00-.4.454 1.2 1.2 0 01-1.673 0 1.125 1.125 0 010-1.59z"
                    data-name="Trazado 399"
                    transform="translate(-792.75 -412.05)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 698" transform="translate(25.162 53.542)">
                <g data-name="Grupo 697">
                  <path
                    fill="#1f4049"
                    d="M767.281 415.8a3.72 3.72 0 01-5.5-.454 1.159 1.159 0 01.4-1.59 1.387 1.387 0 011.673.379 1.228 1.228 0 001.753-.076c.956-.984 2.709.681 1.673 1.741z"
                    data-name="Trazado 400"
                    transform="translate(-761.602 -413.618)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 700" transform="translate(15.105 54.556)">
                <g data-name="Grupo 699">
                  <path
                    fill="#1f4049"
                    d="M778.3 416.352a9.305 9.305 0 01-12.51 5c-1.355-.606-.159-2.574 1.2-1.968a6.924 6.924 0 009-3.634c.558-1.363 2.869-.833 2.311.606z"
                    data-name="Trazado 401"
                    transform="translate(-765.192 -414.957)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 702" transform="translate(10.556 64.498)">
                <g data-name="Grupo 701">
                  <path
                    fill="#1f4049"
                    d="M776.1 428.325c2.709 2.044 5.5 4.088 8.207 6.132 1.2.908-.478 2.5-1.673 1.59-2.709-2.044-5.5-4.088-8.207-6.132-1.275-.833.478-2.423 1.673-1.59z"
                    data-name="Trazado 402"
                    transform="translate(-773.984 -428.09)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 704" transform="translate(18.882 71.081)">
                <g data-name="Grupo 703">
                  <path
                    fill="#1f4049"
                    d="M772.159 437.553a63.946 63.946 0 013.346 10.675c.319 1.438-1.992 2.044-2.311.606a63.951 63.951 0 00-3.346-10.675c-.558-1.363 1.753-1.968 2.311-.606z"
                    data-name="Trazado 403"
                    transform="translate(-769.762 -436.785)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 706" transform="translate(89.236 71.178)">
                <g data-name="Grupo 705">
                  <path
                    fill="#1f4049"
                    d="M682.026 438.342a61.36 61.36 0 01-9.8 21.273c-1.355 1.893-2.948 4.542-5.259 5.451-2.948 1.211-7.012.227-10.039-.227a1.125 1.125 0 01-.876-1.06 121.98 121.98 0 012.311-14.157c.319-1.438 2.629-.833 2.311.606a111.862 111.862 0 00-2.231 13.551 13.057 13.057 0 00-.876-1.06c3.426.53 7.33 1.363 10.119-1.06 2.151-1.893 3.984-5.148 5.418-7.571a58.866 58.866 0 006.693-16.352c.318-1.438 2.629-.833 2.231.606z"
                    data-name="Trazado 404"
                    transform="translate(-656.042 -436.914)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 708" transform="translate(47.295 81.369)">
                <g data-name="Grupo 707">
                  <path
                    fill="#1f4049"
                    d="M728.906 453.8a102.333 102.333 0 01-23.027 2.2c-6.534-.151-15.139-.3-20.876-3.482a1.152 1.152 0 111.2-1.968c5.817 3.18 14.661 3.1 21.194 3.18a97.926 97.926 0 0020.955-2.12c1.434-.3 2.072 1.893.558 2.2z"
                    data-name="Trazado 405"
                    transform="translate(-684.407 -450.375)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 710" transform="translate(35.955 78.219)">
                <g data-name="Grupo 709">
                  <path
                    fill="#1f4049"
                    d="M750.429 447.036a68.945 68.945 0 011.514 10.675c.08 2.271-1.2 3.483-3.586 3.558-1.992.076-5.976-.076-7.171-1.741-.956-1.438-1.2-3.937-1.673-5.526-.558-1.817-1.2-3.71-1.753-5.527-.478-1.438 1.833-1.968 2.311-.606 1.2 3.71 2.311 7.344 3.426 11.053l-.8-.757a14.47 14.47 0 004.382.833c2.39-.076 2.55-1.287 2.311-3.18-.319-2.725-.717-5.451-1.275-8.176-.239-1.439 2.071-2.044 2.311-.606z"
                    data-name="Trazado 406"
                    transform="translate(-737.695 -446.214)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 712" transform="translate(26.849 73.62)">
                <g data-name="Grupo 711">
                  <path
                    fill="#1f4049"
                    d="M762.441 447.907a21.851 21.851 0 01-10.358-5.829c-1.036-1.06.637-2.65 1.673-1.59a19.421 19.421 0 009.322 5.224 1.145 1.145 0 01-.637 2.2z"
                    data-name="Trazado 407"
                    transform="translate(-751.757 -440.138)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 714" transform="translate(24.636 77.516)">
                <g data-name="Grupo 713">
                  <path
                    d="M766.278 446.054a14.354 14.354 0 01.956 5.754 1.2 1.2 0 01-1.2 1.136 46.373 46.373 0 01-7.888-.757c-1.514-.3-.876-2.423.637-2.2a46.071 46.071 0 007.251.681l-1.2 1.136a12.5 12.5 0 00-.8-5.148c-.637-1.363 1.673-1.968 2.231-.606z"
                    data-name="Trazado 408"
                    transform="translate(-757.285 -445.285)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 716" transform="translate(59.504 9.466)">
                <g data-name="Grupo 715">
                  <path
                    fill="#1f4049"
                    d="M715.691 364.106a104.327 104.327 0 00-32.27-6.435c-1.514-.076-1.514-2.347 0-2.271a103.583 103.583 0 0132.907 6.511c1.434.53.8 2.725-.637 2.2z"
                    data-name="Trazado 409"
                    transform="translate(-682.285 -355.398)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 718" transform="translate(56.875 8.179)">
                <g data-name="Grupo 717">
                  <path
                    fill="#1f4049"
                    d="M717.472 360.967l.159-.151a7.952 7.952 0 00-.159 1.363c-.956-2.12-5.9-2.574-7.968-2.953q-4.064-.795-8.127-1.363c-6.056-.908-12.191-1.514-18.246-1.893-1.514-.076-1.514-2.347 0-2.271 7.091.454 14.1 1.211 21.115 2.347 3.665.606 13.545 1.136 15.3 5a1.1 1.1 0 01-.159 1.363l-.159.151c-1.115.984-2.868-.606-1.753-1.59z"
                    data-name="Trazado 410"
                    transform="translate(-681.995 -353.698)"
                  ></path>
                </g>
              </g>
              <path
                fill="#3f3f3f"
                d="M701.147 368.619c.319 8.252 3.028 12.567 5.578 14.914 1.355 1.287 1.912 1.287 7.091 5.3 7.33 5.6 7.808 6.814 8.047 7.646.876 4.012-3.665 5.829-3.984 10.523-.4 5.375 5.1 9.918 8.047 12.264 14.741 12.037 44.7 9.539 49.64 9.085-1.116 6.359-2.231 12.719-3.426 19-1.434.379-3.426.681-4.3-.3-.876-.909-.319-2.423.319-5.527.876-4.391 1.275-6.662.637-7.646-1.753-2.574-9.243-.151-15.7.908-6.135.984-15.139 1.211-26.852-2.347-.239 2.574-.4 5.072-.637 7.646h-8.047c-.956-3.331-1.833-6.662-2.789-9.993-1.833-.984-3.665-1.968-5.578-2.953.4 1.968.8 3.937 1.2 5.829-2.868-.076-5.737-.227-8.605-.3a20.243 20.243 0 00-3.984-11.129 16.143 16.143 0 00-7.091-5.829c-2.39-.909-3.107-.379-5.577-1.438a13.73 13.73 0 01-6.135-5.3c-1.912-3.1-3.028-8.1-.637-11.432 1.275-1.741 2.072-1.06 4.3-3.255 2.47-2.423 1.912-3.71 4.94-9.085 2.072-3.71 2.789-3.861 2.789-5.3-.159-3.634-5.02-4.77-4.621-7.344.4-3.1 7.888-4.315 8.286-4.391a21.879 21.879 0 017.089.454z"
                data-name="Trazado 411"
                opacity="0.12"
                transform="translate(-677 -349.007)"
              ></path>
              <path
                fill="#3f3f3f"
                d="M749.1 392a14.557 14.557 0 003.426 7.041c1.275 1.438 2.869 3.18 5.578 3.483a8.067 8.067 0 005.817-1.741c-5.021-2.954-9.881-5.83-14.821-8.783z"
                data-name="Trazado 412"
                opacity="0.14"
                transform="translate(-722.802 -354.824)"
              ></path>
            </g>
            <g transform="translate(42.468 126.996)">
              <path
                fill="#fff"
                d="M809.993 409.505a5.2 5.2 0 012.789 4.542c-.4 3.558-7.649 5.224-7.41 5.981.239.681 5.418-1.438 10.916.454.877.3 3.745 1.287 3.984 3.028.159 1.363-1.434 1.741-1.833 3.937-.319 1.514.4 1.665.478 4.391.08 1.817.08 2.953-.637 4.088-.956 1.438-2.072 1.136-2.948 2.5-1.036 1.59.319 2.574-.478 4.542-.8 2.044-3.107 3.331-4.94 3.785-2.071.53-3.187-.151-3.825.606-.956 1.136 1.275 3.1.478 5-.717 1.666-3.347 2.12-4.3 2.2-6.613.454-12.43-13.93-12.749-14.763a37.236 37.236 0 01-8.605-.984c-7.41-1.817-12.111-5.829-17.848-10.675a65.592 65.592 0 01-10.438-10.675c-5.179-6.814-7.49-12.87-9.561-18.245a76.693 76.693 0 01-5.1-21.349c-.717-9.842.876-17.185 2.311-23.62a96.742 96.742 0 0111.553-29.071c.239-.379 5.02-6.284 14.581-18.094 4.86-5.981 9.243-11.2 14.422-10.977a5.533 5.533 0 012.789.757c3.745 2.044 4.064 7.949 3.825 13.4a87.336 87.336 0 01-7.808 32.4c-5.657 11.053-10.2 13.93-12.271 24.226a50.191 50.191 0 00-1.036 11.356 44.1 44.1 0 002.311 15.217 35.52 35.52 0 0011.235 16.5c4.462 3.558 7.649 6.132 11.713 5.678 5.657-.606 10.358-6.662 15.856-6.738a5.187 5.187 0 012.546.603z"
                data-name="Trazado 413"
                transform="translate(-737.007 -292.552)"
              ></path>
              <g data-name="Grupo 720" transform="translate(0 1.528)">
                <g data-name="Grupo 719">
                  <path
                    fill="#1f4049"
                    d="M823.327 295.528c-20.079 11.81-35.058 30.812-41.194 52.54A79.339 79.339 0 00795.2 418.02c7.569 10.145 18.645 19.986 32.589 19.457 1.514-.076 1.514 2.2 0 2.271-11.872.454-21.832-6.132-29.4-14.233a83.136 83.136 0 01-18.8-32.554c-7.171-24.453-1.594-51.632 13.227-72.6a94.562 94.562 0 0129.242-26.724c1.434-.833 2.629 1.136 1.275 1.893z"
                    data-name="Trazado 414"
                    transform="translate(-776.475 -293.434)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 722" transform="translate(30.009 99.206)">
                <g data-name="Grupo 721">
                  <path
                    fill="#1f4049"
                    d="M774.155 423.171c4.3 9.766 11.075 19.986 22.947 21.879 1.514.227.876 2.423-.637 2.2-12.669-2.044-19.92-13.021-24.541-23.469-.637-1.287 1.673-1.893 2.231-.606z"
                    data-name="Trazado 415"
                    transform="translate(-771.814 -422.457)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 724" transform="translate(53.954 115.033)">
                <g data-name="Grupo 723">
                  <path
                    fill="#1f4049"
                    d="M747.012 449.977c5.418-.909 14.82-10.22 20.318-5.072 1.992 1.893 1.753 5.072.558 7.268-1.753 3.255-5.578 4.391-9 5.224a1.145 1.145 0 11-.637-2.2c3.028-.681 6.693-1.59 7.809-4.769a2.2 2.2 0 00-.638-3.028c-.478-1.59-1.594-2.12-3.346-1.438a14.339 14.339 0 00-3.586 1.287c-3.665 1.741-6.693 4.24-10.836 4.921-1.514.3-2.151-1.893-.637-2.2z"
                    data-name="Trazado 416"
                    transform="translate(-746.146 -443.363)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 726" transform="translate(50.305 145.507)">
                <g data-name="Grupo 725">
                  <path
                    fill="#1f4049"
                    d="M754.381 484.134c2.629 3.634 5.179 7.344 7.808 10.977a19.189 19.189 0 001.992 2.423 6.285 6.285 0 002.789 1.817c1.115-1.59 2.151-3.18 3.267-4.77-.478-1.363-3.825-3.18-4.94-4.164-1.2-.984.558-2.574 1.673-1.59 2.311 1.968 6.534 4.164 6.693 7.495a5.459 5.459 0 01-4.621 5.375c-3.267.454-5.9-1.666-7.729-3.937-3.267-3.937-5.976-8.328-9-12.492-.876-1.211 1.2-2.347 2.072-1.136z"
                    data-name="Trazado 417"
                    transform="translate(-752.097 -483.616)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 728" transform="translate(65.109 126.734)">
                <g data-name="Grupo 727">
                  <path
                    fill="#1f4049"
                    d="M737.379 458.88c4.621 1.287 9.322.227 13.944.984 2.39.378 4.462 1.59 4.223 4.164-.8 7.268-11.314 6.132-16.334 5.072-1.514-.3-.876-2.5.637-2.2a24.9 24.9 0 007.091.833c3.028-.227 9.561-3.861 3.267-5.754-2.151-.606-5.02-.076-7.171-.151a22.112 22.112 0 01-6.295-.833 1.109 1.109 0 11.638-2.12z"
                    data-name="Trazado 418"
                    transform="translate(-735.876 -458.819)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 730" transform="translate(66.494 134.998)">
                <g data-name="Grupo 729">
                  <path
                    fill="#1f4049"
                    d="M751.685 469.935a6.374 6.374 0 01.478 10.22c-3.984 3.1-10.04 1.136-14.1-.757-1.354-.681-.159-2.65 1.2-1.968 2.63 1.287 6.135 2.574 9.163 1.893 3.426-.681 5.259-5.3 1.992-7.419-1.195-.833 0-2.8 1.275-1.968z"
                    data-name="Trazado 419"
                    transform="translate(-737.464 -469.734)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 732" transform="translate(64.922 145.257)">
                <g data-name="Grupo 731">
                  <path
                    fill="#1f4049"
                    d="M756.722 484.053a7.323 7.323 0 01-3.028 8.252c-3.426 2.271-7.729 1.136-10.836-1.136-1.2-.909 0-2.877 1.2-1.968 2.231 1.59 5.259 2.953 7.888 1.438a5.037 5.037 0 002.39-5.981c-.4-1.363 1.912-1.968 2.39-.606z"
                    data-name="Trazado 420"
                    transform="translate(-742.363 -483.285)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 734" transform="translate(24.766)">
                <g data-name="Grupo 733">
                  <path
                    fill="#1f4049"
                    d="M797.858 291.934c10.2 13.779 6.693 31.418.159 45.8-8.206 18.096-22.07 36.266-17.847 57.009.319 1.438-1.992 2.044-2.311.606-3.665-18.094 5.817-34.6 13.944-50.269 8.207-15.823 15.936-35.885 3.984-52.01-.876-1.211 1.2-2.347 2.072-1.136z"
                    data-name="Trazado 421"
                    transform="translate(-777.048 -291.416)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 736" transform="translate(27.727 77.341)">
                <g data-name="Grupo 735">
                  <path
                    fill="#1f4049"
                    d="M802.955 394.654a153.226 153.226 0 003.107 24.075c.319 1.438-1.992 2.044-2.311.606a161.04 161.04 0 01-3.187-24.68c-.08-1.438 2.311-1.438 2.39 0z"
                    data-name="Trazado 422"
                    transform="translate(-800.562 -393.575)"
                  ></path>
                </g>
              </g>
              <path
                fill="#3f3f3f"
                d="M773.82 309.1a122.56 122.56 0 00-11.792 31.494 117.384 117.384 0 00-2.151 38.61c1.673 14.838 3.107 27.633 13.227 40.276 4.223 5.375 12.828 16.125 27.091 19.684 9.721 2.347 19.521.757 20.716 4.391.558 1.893-1.275 4.315-3.187 5.451a8.709 8.709 0 01-8.924-.681c2.868 1.893 4.223 4.542 3.586 6.435-.558 1.666-2.55 2.574-3.9 2.725-6.534.833-13.067-13.476-13.545-14.536a33.8 33.8 0 01-10.677-1.363c-8.924-2.574-14.342-8.252-20.318-14.536a75.74 75.74 0 01-11.075-14.536c-10.6-18.4-9.721-36.869-9.243-43.682a83.983 83.983 0 0113.944-41.638A76.809 76.809 0 01773.82 309.1z"
                data-name="Trazado 423"
                opacity="0.12"
                transform="translate(-742.187 -295.712)"
              ></path>
              <path
                fill="#3f3f3f"
                d="M777.1 394.5a133.286 133.286 0 0014.262 29.45 141.142 141.142 0 0036.732 38.307 39 39 0 01-11.075-.984c-15.139-3.785-23.186-16.353-26.373-21.349-4.143-6.511-5.737-11.962-8.526-21.349a145.316 145.316 0 01-5.02-24.075z"
                data-name="Trazado 424"
                opacity="0.11"
                transform="translate(-776.143 -316.459)"
              ></path>
            </g>
            <g transform="translate(134.73 132.645)">
              <path
                fill="#fff"
                d="M645.958 299.934c1.275-1.438 11.713 5 18.8 10.069 8.605 6.132 16.015 11.432 23.107 21.046A74.078 74.078 0 01701.1 361.18a75.684 75.684 0 01-2 34.52c-4.143 14.157-11.155 22.712-19.84 33.311-5.578 6.889-9.88 10.675-15.856 13.173a35.281 35.281 0 01-13.864 2.8q-2.629 3.634-5.976 8.176a31.627 31.627 0 01-4.94 5.678c-1.833 1.59-4.7 3.937-6.932 3.1-1.2-.378-1.833-1.59-2.948-3.482-1.115-1.968-.876-2.347-1.673-3.1-1.673-1.666-3.426-.606-5.657-1.893-2.231-1.363-1.2-3.18-3.984-6.889-2.151-2.877-3.346-2.65-3.984-4.694-.637-2.271.8-3.028.319-5.981-.481-2.953-2.231-3.937-1.673-5 .637-1.136 3.107-.681 6.613-.606 6.374.076 11.872-1.438 11.872-2.2 0-.833-5.657-.076-8.605-3.482-1.673-1.968-2.39-5.3-.956-6.889 1.673-1.968 6.055-.984 11.553.3 7.41 1.741 7.809 3.18 10.916 3.483 9.561.833 18.167-12.189 21.115-16.655a54.621 54.621 0 008.286-21.652c1.753-11.432-.558-20.895-2.311-27.936-.478-2.044-.319-1.06-3.665-11.962-5.9-19.381-5.5-19.305-6.932-22.636-5.893-13.464-15.295-19.364-14.02-20.73z"
                data-name="Trazado 425"
                transform="translate(-610.973 -299.085)"
              ></path>
              <g data-name="Grupo 738" transform="translate(35.241)">
                <g data-name="Grupo 737">
                  <path
                    fill="#1f4049"
                    d="M612.342 298.97c24.063 10.069 43.9 29.223 51.711 53.373 8.526 26.119 1.594 53.3-16.254 74.419-8.605 10.145-20.159 18.548-34.262 19.305-1.514.076-1.514-2.2 0-2.271 12.589-.681 23.027-8.025 30.995-16.882 8.605-9.615 15.537-21.425 18.645-33.689 6.374-24.6-1.514-50.95-19.123-69.725a96.273 96.273 0 00-33.067-22.636c-1.275-.53-.08-2.423 1.354-1.893z"
                    data-name="Trazado 426"
                    transform="translate(-610.446 -298.878)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 740" transform="translate(31.889 96.413)">
                <g data-name="Grupo 739">
                  <path
                    fill="#1f4049"
                    d="M679.248 427.57c-4.94 11.659-12.908 22.788-26.453 25.967a1.145 1.145 0 11-.637-2.2c12.669-2.952 20.159-13.476 24.78-24.377.558-1.287 2.868-.757 2.311.606z"
                    data-name="Trazado 427"
                    transform="translate(-651.292 -426.229)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 742" transform="translate(8.682 116.26)">
                <g data-name="Grupo 741">
                  <path
                    fill="#1f4049"
                    d="M708.006 459.754c-4.781-.3-8.605-2.574-13.067-3.937-2.948-.908-7.968-1.893-8.526 1.968-.717 4.694 5.578 5.678 9.163 6.057 1.514.151 1.514 2.423 0 2.271-3.586-.379-7.569-.908-10.039-3.634-1.912-2.2-2.55-5.6-.478-7.873 5.5-6.056 16.812 2.5 22.947 2.877 1.514.151 1.514 2.423 0 2.271z"
                    data-name="Trazado 428"
                    transform="translate(-683.775 -452.445)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 744" transform="translate(16.021 144.882)">
                <g data-name="Grupo 743">
                  <path
                    fill="#1f4049"
                    d="M700.222 491.954c-3.108 4.391-5.976 9.085-9.4 13.249-2.072 2.574-4.86 5-8.526 4.769-2.709-.227-5.259-2.2-5.259-4.921-.08-3.558 4.7-6.284 7.091-8.328 1.116-.984 2.868.606 1.673 1.59-1.355 1.136-4.7 3.18-5.339 4.694-.08 1.287-.08 2.5-.159 3.785 2.47 1.136 4.542.984 6.135-.454a13.817 13.817 0 003.107-3.255c3.028-4.012 5.737-8.176 8.605-12.264.876-1.287 2.948-.151 2.072 1.136z"
                    data-name="Trazado 429"
                    transform="translate(-677.034 -490.252)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 746" transform="translate(0 127.575)">
                <g data-name="Grupo 745">
                  <path
                    fill="#1f4049"
                    d="M720.168 469.593c-4.542 1.59-9.322 1.363-14.023 2.12a13.3 13.3 0 00-2.39.454c-.4 1.136-.8 2.271-1.115 3.407.319 1.363 4.781 1.741 5.737 1.741 3.028.076 5.976-.833 8.844-1.59a1.145 1.145 0 11.637 2.2c-4.621 1.287-18.087 4.164-18.565-3.861-.159-2.8 2.709-3.861 5.1-4.315 5.02-.984 10.279-.606 15.139-2.271 1.434-.53 2.072 1.666.637 2.12z"
                    data-name="Trazado 430"
                    transform="translate(-699.285 -467.392)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 748" transform="translate(1.835 137.265)">
                <g data-name="Grupo 747">
                  <path
                    fill="#1f4049"
                    d="M704.4 482.393a3.815 3.815 0 00-1.2 5.072c1.036 1.666 3.028 2.12 4.94 2.12 3.267-.076 6.534-1.514 9.4-2.953 1.354-.681 2.55 1.287 1.2 1.968-4.382 2.271-11.314 5.148-16.015 1.893-3.665-2.574-3.028-7.646.4-10.069a1.173 1.173 0 111.275 1.968z"
                    data-name="Trazado 431"
                    transform="translate(-700.252 -480.191)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 750" transform="translate(6.642 147.351)">
                <g data-name="Grupo 749">
                  <path
                    fill="#1f4049"
                    d="M699.971 494.942c-.8 2.574 1.036 5.224 3.745 5.905 2.948.757 5.9-.681 8.127-2.347 1.2-.909 2.868.681 1.673 1.59-3.187 2.423-7.41 4.164-11.474 2.574-3.426-1.363-5.577-4.921-4.462-8.328.478-1.438 2.789-.833 2.39.606z"
                    data-name="Trazado 432"
                    transform="translate(-697.284 -493.514)"
                  ></path>
                </g>
              </g>
              <path
                fill="#3f3f3f"
                d="M653.423 310.4a129.333 129.333 0 0115.3 27.1 121.463 121.463 0 019.243 40.957c.717 16.731 1.116 26.5-5.02 36.945-7.808 13.324-21.752 19.911-39.2 28.087a171.683 171.683 0 01-21.752 8.479c0 .454 0 3.71 2.47 5.451 2.709 1.817 7.41 1.136 10.358-2.347-3.825 2.347-5.578 5.527-4.621 7.419.8 1.741 3.9 2.65 6.454 2.044 4.94-1.287 4.462-7.873 11.792-14.233a25.242 25.242 0 014.3-3.028 46.833 46.833 0 0020.716-7.116c1.434-.908 6.852-4.618 14.262-15.217 4.7-6.738 10.518-15.141 13.944-27.784a74.657 74.657 0 00-12.43-63.972 84.733 84.733 0 00-25.816-22.785z"
                data-name="Trazado 433"
                opacity="0.11"
                transform="translate(-602.821 -301.677)"
              ></path>
            </g>
            <g data-name="head" transform="translate(58.05)">
              <path
                fill="#fff"
                d="M716.018 146.956c8.765 5.905 11.553 14.308 16.972 30.888 6.852 20.895 11.792 35.96 3.346 47.695-8.366 11.507-26.772 15.6-45.815 12.643a9.394 9.394 0 00-4.064 2.8c-1.594 2.044-1.355 4.088-1.833 7.344-.637 4.315-1.115 7.949-3.346 9.463-3.665 2.574-11.394-.984-15.856-4.24a33.749 33.749 0 01-11.075-14.384c-12.35-29-18.485-43.455-15.139-57.158a51.181 51.181 0 0115.139-25.967c16.174-14.534 44.46-20.667 61.671-9.084z"
                data-name="Trazado 434"
                transform="translate(-593.835 -127.854)"
              ></path>
              <g data-name="Grupo 752" transform="translate(71.659 35.876)">
                <g data-name="Grupo 751">
                  <path
                    fill="#1f4049"
                    d="M710.11 171.619c9.721 19.381 6.215 48-10.518 63.29-14.342 13.021-38.564 11.81-51.791-1.968-1.036-1.06.637-2.725 1.673-1.59 12.749 13.249 36.015 14.081 49.321 1.136C713.934 217.8 717.2 191 708.118 172.83c-.717-1.363 1.354-2.5 1.992-1.211z"
                    data-name="Trazado 435"
                    transform="translate(-647.475 -171.055)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 754" transform="translate(86.605 106.449)">
                <g data-name="Grupo 753">
                  <path
                    fill="#1f4049"
                    d="M712.188 265.354a50.942 50.942 0 01-5.1 22.636c-.637 1.363-2.709.151-2.072-1.136a48 48 0 004.781-21.5 1.2 1.2 0 012.39 0z"
                    data-name="Trazado 436"
                    transform="translate(-704.897 -264.275)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 756" transform="translate(64.685 121.375)">
                <g data-name="Grupo 755">
                  <path
                    fill="#1f4049"
                    d="M734.647 293.31c-7.968 4.391-18.087-2.347-23.824-7.419-1.116-.984.558-2.574 1.673-1.59 4.781 4.24 14.183 10.826 20.876 7.116 1.434-.757 2.629 1.211 1.275 1.893z"
                    data-name="Trazado 437"
                    transform="translate(-710.455 -283.991)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 758" transform="translate(86.179 60.781)">
                <g data-name="Grupo 757">
                  <path
                    fill="#1f4049"
                    d="M704.964 218.827c-12.271 7.419-28.844-2.725-34.9-13.173-.717-1.287 1.354-2.423 2.072-1.136 5.418 9.388 20.477 19.078 31.632 12.34a1.152 1.152 0 011.2 1.968z"
                    data-name="Trazado 438"
                    transform="translate(-669.916 -203.952)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 760" transform="translate(84.589 58.431)">
                <g data-name="Grupo 759">
                  <path
                    fill="#1f4049"
                    d="M714.13 202.932a7.748 7.748 0 00-4.3 4.694c-.478 1.363-2.789.833-2.311-.606a10.14 10.14 0 015.418-6.056c1.355-.606 2.55 1.363 1.2 1.968z"
                    data-name="Trazado 439"
                    transform="translate(-707.452 -200.849)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 762" transform="translate(111.122 32.714)">
                <g data-name="Grupo 761">
                  <path
                    fill="#1f4049"
                    d="M668.883 167.652a143.357 143.357 0 0010.837 22.788 1.183 1.183 0 01-2.072 1.136 150.819 150.819 0 01-11.075-23.393c-.478-1.287 1.833-1.893 2.311-.53z"
                    data-name="Trazado 440"
                    transform="translate(-666.508 -166.879)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 764" transform="translate(112.283 56.665)">
                <g data-name="Grupo 763">
                  <path
                    fill="#1f4049"
                    d="M678.567 200.169a12.158 12.158 0 01-10.6 4.845c-1.514-.076-1.514-2.347 0-2.271a9.851 9.851 0 008.526-3.71c.876-1.211 2.948-.076 2.072 1.136z"
                    data-name="Trazado 441"
                    transform="translate(-666.834 -198.516)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 766" transform="translate(123.215 40.035)">
                <g data-name="Grupo 765">
                  <path
                    fill="#1f4049"
                    d="M664.153 182.947a9.219 9.219 0 00-.717-5.072h2.311a6.781 6.781 0 00.876 5.905 21 21 0 00-2.151.3 7.975 7.975 0 00-.239-4.315c-.478-1.363 1.833-1.968 2.311-.606a9.334 9.334 0 01.239 5.527 1.225 1.225 0 01-2.151.3 8.979 8.979 0 01-1.116-7.646 1.237 1.237 0 012.311 0 11.371 11.371 0 01.717 6.284c-.319 1.363-2.55.757-2.39-.681z"
                    data-name="Trazado 442"
                    transform="translate(-663.114 -176.549)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 768" transform="translate(92.117 34.565)">
                <g data-name="Grupo 767">
                  <path
                    fill="#1f4049"
                    d="M703.063 176.422a4.433 4.433 0 00-1.036-5.224 19.38 19.38 0 001.992-.53 7.951 7.951 0 00.956 6.284 21 21 0 00-2.151.3 7.153 7.153 0 00-.319-4.088c-.478-1.363 1.833-1.968 2.311-.606a9.242 9.242 0 01.319 5.3 1.225 1.225 0 01-2.151.3 10.214 10.214 0 01-1.2-8.025 1.264 1.264 0 011.992-.53 6.67 6.67 0 011.673 7.495c-.717 1.287-3.028.681-2.39-.681z"
                    data-name="Trazado 443"
                    transform="translate(-701.443 -169.323)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 770" transform="translate(118.929 29.216)">
                <g data-name="Grupo 769">
                  <path
                    fill="#1f4049"
                    d="M668.338 167.438a5.254 5.254 0 00-7.649-1.968c-1.275.833-2.47-1.136-1.2-1.968 3.586-2.5 9.163-1.06 10.916 2.8.637 1.363-1.434 2.5-2.072 1.136z"
                    data-name="Trazado 444"
                    transform="translate(-658.949 -162.259)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 772" transform="translate(131.864 52.3)">
                <g data-name="Grupo 771">
                  <path
                    fill="#1f4049"
                    d="M655.682 193.091l.478.454a1.06 1.06 0 010 1.59 1.2 1.2 0 01-1.673 0l-.478-.454a1.061 1.061 0 010-1.59 1.2 1.2 0 011.673 0z"
                    data-name="Trazado 445"
                    transform="translate(-653.65 -192.75)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 774" transform="translate(126.322 51.657)">
                <g data-name="Grupo 773">
                  <path
                    fill="#1f4049"
                    d="M661.323 192.581a1.853 1.853 0 01-.159.53v-.076c.08.227.08.379.159.606a1 1 0 001.673 0c.08-.227.08-.379.159-.606v.076c-.08-.227-.08-.379-.159-.606v.076a1.257 1.257 0 01-.4 1.59 1.22 1.22 0 01-1.514-1.893 1.606 1.606 0 012.072 0 1.207 1.207 0 01.159 1.514 1.274 1.274 0 01-1.673.379 1.333 1.333 0 01-.319-1.59z"
                    data-name="Trazado 446"
                    transform="translate(-660.761 -191.9)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 776" transform="translate(129.573 58.016)">
                <g data-name="Grupo 775">
                  <path
                    fill="#1f4049"
                    d="M658.329 202.571h-.319a1.136 1.136 0 010-2.271h.319a1.136 1.136 0 010 2.271h-.319a1.136 1.136 0 010-2.271h.319a1.136 1.136 0 010 2.271z"
                    data-name="Trazado 447"
                    transform="translate(-656.875 -200.3)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 778" transform="translate(96.6 47.493)">
                <g data-name="Grupo 777">
                  <path
                    fill="#1f4049"
                    d="M698.4 187.99a.919.919 0 01.08-.454 1.2 1.2 0 011.2-1.136c.558 0 1.275.53 1.2 1.136a.919.919 0 01-.08.454 1.2 1.2 0 01-1.2 1.136c-.558 0-1.275-.454-1.2-1.136z"
                    data-name="Trazado 448"
                    transform="translate(-698.392 -186.4)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 780" transform="translate(89.515 45.6)">
                <g data-name="Grupo 779">
                  <path
                    fill="#1f4049"
                    d="M708.473 186.171H708a1.137 1.137 0 110-2.271h.478a1.2 1.2 0 011.2 1.136 1.145 1.145 0 01-1.2 1.136z"
                    data-name="Trazado 449"
                    transform="translate(-706.8 -183.9)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 782" transform="translate(91.506 50.824)">
                <g data-name="Grupo 781">
                  <path
                    fill="#1f4049"
                    d="M707.29 191.936v.454a1.2 1.2 0 01-2.39 0v-.454a1.2 1.2 0 011.2-1.136 1.253 1.253 0 011.2 1.136z"
                    data-name="Trazado 450"
                    transform="translate(-704.9 -190.8)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 784" transform="translate(85.518 26.429)">
                <g data-name="Grupo 783">
                  <path
                    fill="#1f4049"
                    d="M709.727 161.774a10.956 10.956 0 00-11.235 1.287c-1.2.908-2.868-.681-1.673-1.59a13.419 13.419 0 0114.1-1.59c1.434.606.159 2.574-1.2 1.893z"
                    data-name="Trazado 451"
                    transform="translate(-696.408 -158.577)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 786" transform="translate(48.818 36.589)">
                <g data-name="Grupo 785">
                  <path
                    fill="#1f4049"
                    d="M754.354 176.92c-.956-.908-1.912-1.741-2.948-2.65l-1.912.227a8.37 8.37 0 00-3.586 1.817 10.635 10.635 0 00-3.745 7.495c-.478 4.769 1.514 11.129 7.569 10.977a1.136 1.136 0 010 2.271c-10.039.227-12.031-12.416-8.207-19.078a11.557 11.557 0 019.96-5.981c3.267.076 6.613 2.12 5.259 5.527-.637 1.287-2.948.757-2.39-.606z"
                    data-name="Trazado 452"
                    transform="translate(-739.712 -171.998)"
                  ></path>
                </g>
              </g>
              <path
                fill="#ef2d56"
                d="M722.805 131.263a36.853 36.853 0 0113.944 6.814c14.422 11.053 18.645 28.465 20 34.219 2.629 11.356-.159 11.734 2.868 20.971 4.143 12.719 10.04 13.93 14.581 25.059 1.514 3.634 8.127 19.835.319 33.235-7.968 13.627-26.852 17.564-39.919 16.277-15.059-1.438-32.27-10.826-36.333-25.437a26.091 26.091 0 01-.717-10.22 43.908 43.908 0 0018.167-2.65 41.5 41.5 0 0016.015-11.2c5.577-6.284 7.569-12.416 9-16.882a49.01 49.01 0 001.354-26.876 45.811 45.811 0 00-31.393-33.538 79.012 79.012 0 01-10.358 10.523c-6.055 5.072-12.51 10.447-22.071 12.189a32.242 32.242 0 01-8.446.53 8.112 8.112 0 00-4.462-3.1c-4.223-1.136-7.808 1.893-8.446 2.423a11.488 11.488 0 00-3.586 6.208 13.23 13.23 0 00.637 9.085 9.819 9.819 0 002.709 3.634 10.806 10.806 0 007.49 2.12 52.585 52.585 0 0110.119 14.914 50.756 50.756 0 014.3 24.075c-.558 6.814-1.514 19.381-12.111 27.784-13.306 10.6-31.075 5.981-33.146 5.451-20.557-5.6-27.25-25.513-27.808-27.406-5.657-17.942 4.143-33.689 8.924-41.336 6.613-10.675 9.88-9.463 24.621-25.059 21.593-22.863 21.752-33.008 34.581-37.626 6.852-2.423 18.326-3.71 36.732 5.451a35.3 35.3 0 0112.435.368z"
                data-name="Trazado 453"
                transform="translate(-603.81 -123.667)"
              ></path>
              <g data-name="Grupo 788" transform="translate(78.422 101.421)">
                <g data-name="Grupo 787">
                  <path
                    fill="#1f4049"
                    d="M719.343 266.087c-4.7-.53-9.641-3.634-13.386-6.284-1.2-.833 0-2.8 1.2-1.968a37.658 37.658 0 005.657 3.331c2.072 1.06 4.223 2.347 6.613 2.65 1.434.151 1.434 2.423-.08 2.271z"
                    data-name="Trazado 454"
                    transform="translate(-705.462 -257.634)"
                  ></path>
                </g>
              </g>
              <g data-name="Grupo 790" transform="translate(75.962 100.289)">
                <g data-name="Grupo 789">
                  <path
                    fill="#1f4049"
                    d="M721.538 266.708c-3.028-.454-5.737-2.12-8.366-3.558a32.039 32.039 0 01-6.932-5.072c-1.036-1.06.637-2.65 1.673-1.59 3.426 3.482 9.243 7.268 14.262 8.1 1.514.227.877 2.423-.637 2.12z"
                    data-name="Trazado 455"
                    transform="translate(-705.914 -256.138)"
                  ></path>
                </g>
              </g>
              <path
                fill="#3f3f3f"
                d="M770.305 167.6a159.456 159.456 0 00-16.015 33.689c-6.135 18.094-9.8 28.617-3.745 36.869 5.976 8.176 19.6 11.432 30.995 7.8a28.731 28.731 0 0020.16-25.515 48.054 48.054 0 01.4 20.516c-1.2 5.829-2.709 13.249-9.322 19.456-7.888 7.419-17.928 8.176-21.593 8.479a40.56 40.56 0 01-23.505-5.3 37.945 37.945 0 01-15.3-17.337 40.814 40.814 0 01-3.347-21.955 51.041 51.041 0 018.924-24.075c1.036-1.59 3.426-5.072 14.9-16.277 7.09-7.038 13.143-12.64 17.448-16.35z"
                data-name="Trazado 456"
                opacity="0.25"
                transform="translate(-728.12 -134.34)"
              ></path>
              <path
                fill="#3f3f3f"
                d="M679.292 245.7a26.342 26.342 0 01-.4 17.034c-4.542 11.886-18.724 20.441-33.226 18.4a31.087 31.087 0 01-25.338-21.652c-5.578.681-11.155 1.438-16.812 2.12a28.939 28.939 0 001.514 10.977 33.194 33.194 0 0010.44 14.911c10.6 9.009 23.346 9.69 28.365 9.918 6.613.3 17.37.908 27.25-6.056a32.533 32.533 0 0012.271-16.277c5.099-14.688-2.789-27.331-4.064-29.375z"
                data-name="Trazado 457"
                opacity="0.15"
                transform="translate(-510.338 -153.314)"
              ></path>
              <path
                fill="#3f3f3f"
                d="M692.913 196.8c3.028 10.3 7.091 24.15 16.414 32.251 3.984 3.482 13.466 9.766 33.226 8.479a33.513 33.513 0 01-31.314 2.8c-2.948 8.4-5.976 16.807-8.924 25.134-4.223-2.271-8.446-4.467-12.669-6.738a49.326 49.326 0 008.605-26.194c.478-20.743-13.147-34.446-16.015-37.172a11.888 11.888 0 01-7.49-4.24c-3.267-4.391-1.912-10.75 1.833-14.157.717-.681 3.9-3.558 7.091-2.8 5.099 1.056 5.737 10.52 9.243 22.637z"
                data-name="Trazado 458"
                opacity="0.15"
                transform="translate(-623.158 -135.903)"
              ></path>
            </g>
          </g>
        </g>
        <rect
          width="260"
          height="6"
          x="0"
          y="0"
          fill="#ef2d56"
          data-name="Rectángulo 23"
          rx="3"
          transform="translate(830 2988)"
        ></rect>
        <text
          fill="#1f4049"
          data-name="Animate! Es tan simple, como hacer click."
          fontFamily="Nunito-Bold, Nunito"
          fontSize="70"
          fontWeight="700"
          transform="translate(692 2086)"
        >
          <tspan x="0" y="71">
            Animate! Es tan simple,
          </tspan>
          <tspan x="0" y="151">
            como hacer click.
          </tspan>
        </text>
        <text
          fill="#1f4049"
          data-name="Somos la empresa con más experiencia en el mercado, tenemos 30 sucursales de cambio en todo el país. En la actualidad el 98% de las operaciones se realizan de manera presencial. Es por eso que buscamos hacerte las cosas más fáciles y apostamos a una plata"
          fontFamily="OpenSans-Regular, 'Open Sans'"
          fontSize="30"
          transform="translate(694 2315)"
        >
          <tspan x="0" y="32">
            Somos la empresa con
          </tspan>
          <tspan
            y="32"
            fontFamily="OpenSans-SemiBold, 'Open Sans'"
            fontWeight="600"
            xmlSpace="preserve"
          >
            {" "}
            más experiencia en el mercado
          </tspan>
          <tspan y="32">, tenemos</tspan>
          <tspan
            y="32"
            fontFamily="OpenSans-SemiBold, 'Open Sans'"
            fontWeight="600"
            xmlSpace="preserve"
          >
            {" "}
            30{" "}
          </tspan>
          <tspan
            x="0"
            y="74"
            fontFamily="OpenSans-SemiBold, 'Open Sans'"
            fontWeight="600"
          >
            sucursales de cambio
          </tspan>
          <tspan y="74" xmlSpace="preserve">
            {" "}
            en todo el país.{" "}
          </tspan>
          <tspan x="0" y="136">
          En la actualidad el 98% de las operaciones se realizan de manera presencial.
          </tspan>
          <tspan x="0" y="178">
            Es por eso que{' '}
          </tspan>
          <tspan
            y="178"
            fontFamily="OpenSans-SemiBold, 'Open Sans'"
            fontWeight="600"
          >
            buscamos hacerte las cosas más fáciles{' '}
          </tspan>
          <tspan y="178">y apostamos a una</tspan>
          <tspan
            x="0"
            y="220"
            fontFamily="OpenSans-SemiBold, 'Open Sans'"
            fontWeight="600"
          >
            plataforma online de inversiones
          </tspan>
          <tspan y="220" xmlSpace="preserve">
            {" "}
            donde puedas hacer las operaciones que{" "}
          </tspan>
          <tspan x="0" y="262">
            quieras, de una forma más fácil.
          </tspan>
        </text>
        <g data-name="Grupo 793" transform="translate(146.332 3534)">
          <g
            clip-path="url(#clip-path-13)"
            data-name="Grupo 1"
            transform="translate(0 -3)"
          >
            <path
              fill="#ef2d56"
              d="M150.947 15.418a7.7 7.7 0 01-7.547-7.75 7.613 7.613 0 017.547-7.654 7.7 7.7 0 017.653 7.654 7.78 7.78 0 01-7.649 7.751"
              data-name="Trazado 1"
              transform="translate(-82.01 -.008)"
            ></path>
            <path
              fill="#fff"
              d="M24.592 71.82C11.231 71.82 0 60.734 0 44.839V0h4.454c5.035 0 8.52 2.943 8.52 9.124v15.4c2.614-3.827 7.068-8.045 14.135-8.045 13.264 0 23.431 10.989 23.431 26.589 0 15.9-10.069 28.747-25.948 28.747m0-43.661c-6.583 0-11.521 6.574-11.521 14.815 0 12.166 5.131 17.171 12.877 17.171 6.487 0 11.134-6.28 11.134-14.816 0-12.853-4.551-17.17-12.49-17.17"
              data-name="Trazado 2"
              transform="translate(0 -.001)"
            ></path>
            <path
              fill="#fff"
              d="M161.7 96.3c-10.069 0-15.588-5.788-15.588-16.484V44.007h3.679c5.809 0 9.294 3.139 9.294 9.811v24.725c0 5.3 2.227 6.966 7.939 6.966h2.421v2.846c0 5.69-2.227 7.947-7.746 7.947"
              data-name="Trazado 3"
              transform="translate(-83.563 -25.168)"
            ></path>
            <path
              fill="#fff"
              d="M236.226 71.82c-13.748 0-24.3-12.166-24.3-26.687 0-17.367 8.327-28.649 23.527-28.649 5.228 0 10.941 3.728 12.974 8.339V0h3.97c6.2 0 8.907 3.63 8.907 8.928v37.285c0 15.4-7.165 25.607-25.076 25.607m-.678-44.249c-6.583 0-10.844 6.475-10.844 15.011 0 10.989 5.616 18.152 13.071 18.152 7.261 0 10.456-5.5 10.456-15.11 0-13.246-5.712-18.053-12.683-18.053"
              data-name="Trazado 4"
              transform="translate(-121.204 -.001)"
            ></path>
            <path
              fill="#fff"
              d="M375.322 71.82c-13.748 0-24.3-12.166-24.3-26.687 0-17.367 8.327-28.649 23.527-28.649 5.229 0 10.941 3.728 12.974 8.339V0h3.97c6.2 0 8.907 3.63 8.907 8.928v37.285c0 15.4-7.164 25.607-25.076 25.607m-.678-44.249c-6.583 0-10.844 6.475-10.844 15.011 0 10.989 5.616 18.152 13.071 18.152 7.261 0 10.456-5.5 10.456-15.11 0-13.246-5.712-18.053-12.683-18.053"
              data-name="Trazado 5"
              transform="translate(-200.755 -.001)"
            ></path>
            <path
              fill="#fff"
              d="M494.369 111.408c-4.841 0-9.1-3.238-9.1-8.143v-2.551l7.358-.491c4.744-.294 6.39-2.256 9.2-9.713-6.874-10.5-16.75-36.794-18.492-49.254h6.874a7.605 7.605 0 017.552 6.181 114.894 114.894 0 0010.456 30.514c4.26-9.91 9-25.9 10.166-36.7H524c4.164 0 6.1 1.865 6.1 6.181 0 5.593-9.1 29.729-11.521 35.42-9.681 23.155-14.813 28.552-24.2 28.552"
              data-name="Trazado 6"
              transform="translate(-276.427 -23.595)"
            ></path>
          </g>
        </g>
        <text
          fill="#fff"
          data-name="¿Tenés dudas? Contactanos"
          fontFamily="Nunito-Bold, Nunito"
          fontSize="35"
          fontWeight="700"
          transform="translate(554 3566)"
        >
          <tspan x="0" y="0">
            ¿Tenés dudas? Contactanos
          </tspan>
        </text>
        <text
          fill="#fff"
          data-name="Preguntas Frecuentes"
          fontFamily="Nunito-Bold, Nunito"
          fontSize="35"
          fontWeight="700"
          transform="translate(554 3753)"
        >
          <tspan x="0" y="0">
            Preguntas Frecuentes
          </tspan>
        </text>
        <text
          fill="#fff"
          fontFamily="Nunito-Bold, Nunito"
          fontSize="35"
          fontWeight="700"
          transform="translate(1106 3754)"
        >
          <tspan x="0" y="0">
            Legales
          </tspan>
        </text>
        {/* <text
          fill="#fff"
          fontFamily="Nunito-Bold, Nunito"
          fontSize="35"
          fontWeight="700"
          transform="translate(1106 3569)"
        >
          <tspan x="0" y="0">
            Newsletter
          </tspan>
        </text> */}
        <text
          fill="#fff"
          data-name="hola@biddy.com"
          fontFamily="OpenSans-Regular, 'Open Sans'"
          fontSize="28"
          transform="translate(692 3629)"
        >
          <tspan x="0" y="0">
            hola@biddy.com
          </tspan>
        </text>
        <text
          fill="#fff"
          data-name="Recaudar SRL Agencia autorizada BCRA N° 20.001"
          fontFamily="OpenSans-Regular, 'Open Sans'"
          fontSize="28"
          transform="translate(1170 3810)"
        >
          <tspan x="0" y="0">
            Recaudar SRL
          </tspan>
          <tspan x="0" y="31">
            Agencia autorizada BCRA N° 20.001
          </tspan>
        </text>
        {/* <text
          fill="#fff"
          data-name="Dejanos tu mail"
          fontFamily="OpenSans-Regular, 'Open Sans'"
          fontSize="28"
          transform="translate(1171 3646)"
        >
          <tspan x="0" y="0">
            Dejanos tu mail
          </tspan>
        </text>
        <text
          fill="#ff6339"
          fontFamily="Nunito-Bold, Nunito"
          fontSize="28"
          fontWeight="700"
          transform="translate(1540.702 3646)"
          className="hover"
        >
          <tspan x="0" y="0">
            Enviar
          </tspan>
        </text> */}
        <text
          fill="#fff"
          data-name="@biddy"
          fontFamily="OpenSans-Regular, 'Open Sans'"
          fontSize="28"
          transform="translate(692 3683)"
        >
          <tspan x="0" y="0">
            @biddy
          </tspan>
        </text>
        {/* <g transform="translate(1132 3619.802)">
          <g data-name="mail" transform="translate(1 3)">
            <path
              fill="#fff"
              d="M31.8 11.368V22.6a5.6 5.6 0 01-5.6 5.6H6.6A5.6 5.6 0 011 22.6V11.432 8.6A5.6 5.6 0 016.6 3h19.6a5.6 5.6 0 015.6 5.6zm-2.8-1.01V8.6a2.8 2.8 0 00-2.8-2.8H6.6a2.8 2.8 0 00-2.8 2.8v1.758L16 14.017a1.4 1.4 0 00.8 0zm0 2.923L17.606 16.7a4.2 4.2 0 01-2.413 0L3.8 13.281V22.6a2.8 2.8 0 002.8 2.8h19.6a2.8 2.8 0 002.8-2.8z"
              data-name="shape"
              transform="translate(-1 -3)"
            ></path>
          </g>
        </g> */}
        <g data-name="mail" transform="translate(639.845 3600.802)">
          <g data-name="mail" transform="translate(1 3)">
            <path
              fill="#fff"
              d="M36.154 12.552v12.819a6.392 6.392 0 01-6.392 6.392H7.392A6.392 6.392 0 011 25.371V12.625 9.392A6.392 6.392 0 017.392 3h22.371a6.392 6.392 0 016.392 6.392zm-3.2-1.153V9.392a3.2 3.2 0 00-3.2-3.2H7.392a3.2 3.2 0 00-3.2 3.2V11.4l13.922 4.177a1.6 1.6 0 00.918 0zm0 3.336l-13 3.9a4.793 4.793 0 01-2.755 0l-13-3.9v10.636a3.2 3.2 0 003.2 3.2h22.364a3.2 3.2 0 003.2-3.2z"
              data-name="shape"
              transform="translate(-1 -3)"
            ></path>
          </g>
        </g>
        <g data-name="Grupo 795" transform="translate(617.387 3633.062)">
          <g
            fill="#fff"
            clip-path="url(#clip-path-17)"
            data-name="Grupo 794"
            transform="translate(25.859 24)"
          >
            <path
              d="M30.741 11.06a20.094 20.094 0 00-.4-4.548A7.86 7.86 0 0025.015.638a14.861 14.861 0 00-4.748-.61q-4.6-.052-9.2-.012a19.241 19.241 0 00-4.548.4A7.863 7.863 0 00.64 5.729a14.872 14.872 0 00-.612 4.782q-.051 4.581-.012 9.163a19.283 19.283 0 00.4 4.548 7.858 7.858 0 005.31 5.885 14.876 14.876 0 004.781.617c3.043.035 6.087.032 9.13.012a21.588 21.588 0 004.289-.329 7.972 7.972 0 005.4-3.668 10.39 10.39 0 001.355-5.139c.1-2.076.069-4.153.065-6.23 0-1.437.021-2.875-.006-4.312M27.961 19.3a19.4 19.4 0 01-.31 4.153 5.333 5.333 0 01-4.9 4.325 53.255 53.255 0 01-5.616.195c-2.134.009-4.268 0-6.4-.037a15.27 15.27 0 01-3.674-.347 5.2 5.2 0 01-4.018-4.417 23.943 23.943 0 01-.253-3.89c-.033-1.313-.007-2.628-.007-3.942 0-2.256-.046-4.514.127-6.766a6.183 6.183 0 011.464-3.849 5.7 5.7 0 013.61-1.749 27.569 27.569 0 013.56-.185c2.561-.024 5.122-.033 7.683 0a20.781 20.781 0 014.254.312 5.277 5.277 0 014.233 4.456 24.545 24.545 0 01.249 3.891q.045 3.925 0 7.851"
              data-name="Trazado 460"
            ></path>
            <path
              d="M118.52 110.934a7.9 7.9 0 108.008 7.9 7.916 7.916 0 00-8.008-7.9m.109 13.019a5.122 5.122 0 115.124-5.121 5.15 5.15 0 01-5.124 5.121"
              data-name="Trazado 461"
              transform="translate(-103.254 -103.453)"
            ></path>
            <path
              d="M324.047 78.929a1.848 1.848 0 00-1.88 1.836 1.879 1.879 0 001.861 1.871 1.85 1.85 0 001.848-1.869 1.816 1.816 0 00-1.829-1.838"
              data-name="Trazado 462"
              transform="translate(-300.443 -73.607)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Icon;